<template>
  <div class="c1-main c1-tasks-page" @click="c1HamMenuOpen = false; c1ShiftMenuOpen = false; c1TopTab = null">

    <!-- TOAST -->
    <transition name="t1-toast-fade">
      <div v-if="c1Toast" class="t1-toast" :style="{ background: c1Toast.color }">{{ c1Toast.msg }}</div>
    </transition>

    <div class="c1-sticky-top">
    <!-- TOP BAR -->
    <div class="c1-tib" @click="c1SlideOpen = null; c1VikiOpen = false">

      <!-- LEFT 25% — Viki face flush left -->
      <div class="c1-tib-side c1-tib-left" style="padding-left:0;gap:8px;">
        <div class="c1-viki-topface"
          :class="{ 'c1-viki-topface--active': c1VikiOpen }"
          @click.stop="c1VikiOpen = !c1VikiOpen"
        >
          <viki-face :mood="c1VikiMood" :speaking="c1VikiSpeaking" :size="44" style="width:72px;height:44px;display:block;overflow:hidden;border-radius:0;"/>
        </div>
        <div class="c1-shift-wrap" @click.stop="c1ShiftMenuOpen = !c1ShiftMenuOpen; c1HamMenuOpen = false">
          <div class="c1-tib-shift-pill" :class="{ open: c1ShiftMenuOpen }">
            ⏱ {{ c1ShiftElapsed }}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:10px;height:10px;margin-left:3px;transition:transform .2s" :style="{ transform: c1ShiftMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)' }"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>
      </div>

      <!-- CENTER 50% — placeholder -->
      <div class="c1-tib-center"></div>

      <!-- Speaking card — slides out from right edge of Viki's face box -->
      <transition name="c1-vmsg-slide">
        <div v-if="c1VikiSpeaking" key="msg" class="c1-viki-msgcard" style="position:absolute;left:72px;right:80px;top:0;height:44px;z-index:5;display:flex;align-items:center;padding:0 12px;background:#29b8d4;border-radius:0 6px 6px 0;" @click.stop>
          <span style="font-size:12px;color:#fff;font-weight:500;">
            <span v-if="c1VikiMessages.length">{{ c1VikiMessages[0].text }}</span>
            <span v-else>Analysing tasks...</span>
          </span>
        </div>
      </transition>
      <!-- RIGHT 25% — hamburger only -->
      <div class="c1-tib-side c1-tib-right">
        <div class="c1-ham-wrap" @click.stop>
          <button class="c1-ham-btn" :class="{ open: c1HamMenuOpen }" @click="c1HamMenuOpen = !c1HamMenuOpen; c1ShiftMenuOpen = false">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:18px;height:18px"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          </button>
        </div>
      </div>
    </div><!-- /c1-tib -->
    <!-- SHIFT DRAWER -->
    <div class="c1-top-drawer c1-shift-drawer" :class="{ open: c1ShiftMenuOpen }" @click.stop>
      <div class="c1-td-inner">
        <div class="c1-td-section-lbl">My Shift</div>
        <div class="c1-td-status-row">
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono">{{ c1ShiftStartTime ? new Date(c1ShiftStartTime).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : '—' }}</div>
            <div class="c1-td-stat-lbl">Started</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val c1-mono" style="color:var(--c1-dp)">{{ c1ShiftElapsed }}</div>
            <div class="c1-td-stat-lbl">Elapsed</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1BathroomCount }}×</div>
            <div class="c1-td-stat-lbl">🚽 Bathroom</div>
          </div>
          <div class="c1-td-stat">
            <div class="c1-td-stat-val">{{ c1CoffeeCount }}×</div>
            <div class="c1-td-stat-lbl">☕ Coffee</div>
          </div>
        </div>
        <div class="c1-td-btn-row">
          <button class="c1-td-btn c1-td-btn-shift"   :class="{ active: c1Status === 'shift' }"   @click.stop="c1SetStatus('shift')">▶ On Shift</button>
          <button class="c1-td-btn c1-td-btn-bathroom" :class="{ active: c1Status === 'bathroom' }" @click.stop="c1SetStatus('bathroom')">🚽 Bathroom</button>
          <button class="c1-td-btn c1-td-btn-coffee"  :class="{ active: c1Status === 'coffee' }"  @click.stop="c1SetStatus('coffee')">☕ Coffee</button>
          <button class="c1-td-btn c1-td-btn-break"   :class="{ active: c1Status === 'break' }"   @click.stop="c1SetStatus('break')">⏸ Break</button>
          <button class="c1-td-btn c1-td-btn-lunch"   :class="{ active: c1Status === 'lunch' }"   @click.stop="c1SetStatus('lunch')">🍽 Lunch</button>
          <button class="c1-td-btn c1-td-btn-end"     @click.stop="c1SetStatus('end')">⏹ End Shift</button>
        </div>
      </div>
    </div>
    <!-- HAM NAV DRAWER -->
    <div class="c1-top-drawer c1-ham-drawer" :class="{ open: c1HamMenuOpen }" @click.stop>
      <div class="c1-td-inner c1-td-nav-grid">
        <router-link to="/clients1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-dp)"></span>Clients</router-link>
        <router-link to="/tasks1" class="c1-td-nav-item" :class="{ on: $route.path === '/tasks1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-sc)"></span>Tasks</router-link>
        <router-link to="/stats1" class="c1-td-nav-item" :class="{ on: $route.path === '/stats1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-ld)"></span>Statistics</router-link>
        <router-link to="/chat1" class="c1-td-nav-item" :class="{ on: $route.path === '/chat1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:var(--c1-rf)"></span>Chat</router-link>
        <router-link to="/communications1" class="c1-td-nav-item" :class="{ on: $route.path === '/communications1' }" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#3b82f6"></span>Communications</router-link>
        <router-link to="/affiliation1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#8b5cf6"></span>Affiliation</router-link>
        <router-link to="/finance1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#10b981"></span>Finance</router-link>
        <router-link to="/shifts1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#f59e0b"></span>Shifts</router-link>
        <router-link to="/users1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#06b6d4"></span>Users</router-link>
        <router-link to="/brokers1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ec4899"></span>Brokers</router-link>
        <router-link to="/security1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#ef4444"></span>Security</router-link>
        <router-link to="/quiz1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#a78bfa"></span>Quiz</router-link>
        <router-link to="/instruction1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#64748b"></span>Instructions</router-link>
        <router-link to="/settings1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#94a3b8"></span>Settings</router-link>
        <router-link to="/profile1" class="c1-td-nav-item" @click.native="c1HamMenuOpen=false"><span class="c1-td-nav-dot" style="background:#22d3ee"></span>My Profile</router-link>
      </div>
    </div>
    </div><!-- /c1-sticky-top -->

    <!-- ══ TASKS TOP FILTER STRIP ══ same pattern as clients1 -->
    <div class="c1-top-strip" @click.stop>
      <div class="c1-top-strip-body">

        <!-- TAB ROW -->
        <div class="c1-ts-tab-row">
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'status'}" @click.stop="c1TopTab = c1TopTab === 'status' ? null : 'status'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
            <span>Status</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='status' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'agents'}" @click.stop="c1TopTab = c1TopTab === 'agents' ? null : 'agents'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
            <span>Agents</span>
            <span v-if="filters.task_users && filters.task_users.length" class="c1-ts-badge">{{ filters.task_users.length }}</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='agents' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'priority'}" @click.stop="c1TopTab = c1TopTab === 'priority' ? null : 'priority'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><polyline points="18 15 12 9 6 15"/></svg>
            <span>Priority</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='priority' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'date'}" @click.stop="c1TopTab = c1TopTab === 'date' ? null : 'date'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            <span>Date</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='date' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'type'}" @click.stop="c1TopTab = c1TopTab === 'type' ? null : 'type'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>
            <span>Type</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='type' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'sort'}" @click.stop="c1TopTab = c1TopTab === 'sort' ? null : 'sort'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><line x1="3" y1="6" x2="21" y2="6"/><line x1="6" y1="12" x2="18" y2="12"/><line x1="9" y1="18" x2="15" y2="18"/></svg>
            <span>Sort</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='sort' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'team' || t1TeamFilter !== null}" @click.stop="c1TopTab = c1TopTab === 'team' ? null : 'team'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            <span v-if="t1TeamFilter === 1" style="color:#0e7490;font-weight:700">Team 1</span>
            <span v-else-if="t1TeamFilter === 2" style="color:#7c3aed;font-weight:700">Team 2</span>
            <span v-else>Team</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='team' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'charts'}" @click.stop="c1TopTab = c1TopTab === 'charts' ? null : 'charts'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
            <span>Charts</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='charts' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1ShowCalendarComponent}" @click.stop="c1ShowCalendarComponent = !c1ShowCalendarComponent">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            <span>Calendar</span>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'gantt'}" @click.stop="c1TopTab = c1TopTab === 'gantt' ? null : 'gantt'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="15" y2="12"/><line x1="3" y1="18" x2="18" y2="18"/></svg>
            <span>Gantt</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='gantt' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <div class="c1-ts-tab-sep"></div>
          <div class="c1-ts-tab" :class="{on: c1TopTab === 'activity'}" @click.stop="c1TopTab = c1TopTab === 'activity' ? null : 'activity'">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:12px;height:12px"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/></svg>
            <span>Activity</span>
            <svg class="c1-ts-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" :style="{transform: c1TopTab==='activity' ? 'rotate(180deg)' : ''}"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
        </div>

        <!-- STATUS DROPDOWN -->
        <div v-show="c1TopTab === 'status'" class="c1-ts-dropdown">
          <div v-if="c1ActiveFilterCount" class="c1-reset-bar" style="margin:6px 8px 0" @click.stop="c1FullReset(); c1TopTab = null">
            <svg viewBox="0 0 24 24"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
            Reset all filters <span class="c1-reset-bar-count">{{ c1ActiveFilterCount }}</span>
          </div>
          <div class="c1-fs-search-wrap" style="margin:6px 8px 0">
            <svg class="c1-fp-sico" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input class="c1-fp-sinput" v-model.trim="wordFilter" placeholder="Search tasks…" type="text" @click.stop />
            <div v-if="wordFilter" class="c1-fp-sclear" @click.stop="wordFilter = ''">
              <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
          <div class="c1-fs-section-lbl">Status</div>
          <div class="c1-fs-grid" style="padding:0 8px">
            <div class="c1-fs-card" style="--fsclr:#fa8100" :class="{ on: selectedTab === 'active' }" @click.stop="c1SetTab('active'); c1TopTab = null">
              <span class="c1-fs-name">Production</span><span class="c1-fs-num">{{ activeTasksCounter }}</span>
            </div>
            <div class="c1-fs-card" style="--fsclr:#4275ec" :class="{ on: selectedTab === 'waiting' }" @click.stop="c1SetTab('waiting'); c1TopTab = null">
              <span class="c1-fs-name">Waiting</span><span class="c1-fs-num">{{ stats.waiting_group }}</span>
            </div>
            <div class="c1-fs-card" style="--fsclr:#2D9D5E" :class="{ on: selectedTab === 'completed' }" @click.stop="c1SetTab('completed'); c1TopTab = null">
              <span class="c1-fs-name">Completed</span><span class="c1-fs-num">{{ stats.completed_group }}</span>
            </div>
            <div class="c1-fs-card" style="--fsclr:#E05A3A" :class="{ on: filters.missed_tasks }" @click.stop="c1ToggleMissed(); c1TopTab = null">
              <span class="c1-fs-name">Missed</span><span class="c1-fs-num">{{ stats.tasks_missed }}</span>
            </div>
            <div class="c1-fs-card" style="--fsclr:#7C5CFC" :class="{ on: selectedTab === 'outline' }" @click.stop="c1SetTab('outline'); c1TopTab = null">
              <span class="c1-fs-name">Outline</span><span class="c1-fs-num">{{ stats.outline_group }}</span>
            </div>
            <div class="c1-fs-card" style="--fsclr:#E8891C" :class="{ on: filters.coming_tasks }" @click.stop="c1ToggleComing(); c1TopTab = null">
              <span class="c1-fs-name">Coming</span><span class="c1-fs-num">{{ stats.tasks_coming }}</span>
            </div>
          </div>
          <div class="c1-fs-section-lbl">Show</div>
          <div class="c1-fs-toggle" style="margin:0 8px 8px">
            <div class="c1-fs-tog-btn" :class="{ on: !filters.show_all_tasks }" @click.stop="filters.show_all_tasks = false; fetchTasks()">Mine</div>
            <div class="c1-fs-tog-btn" :class="{ on: filters.show_all_tasks }" @click.stop="filters.show_all_tasks = true; fetchTasks()">All Tasks</div>
          </div>
        </div>

        <!-- AGENTS DROPDOWN -->
        <div v-show="c1TopTab === 'agents'" class="c1-ts-dropdown">
          <div class="c1-agent-grid" style="padding:6px 8px">
            <div
              v-for="user in (salesPersonList || []).slice(0, 40)"
              :key="user.id"
              class="c1-agent-chip"
              :class="{ on: filters.task_users && filters.task_users.includes(user.id) }"
              @click.stop="c1ToggleTaskUser(user.id)"
            >
              <div class="c1-agent-av">{{ c1T1UserInitials(user) }}</div>
              <span class="c1-agent-nm">{{ c1T1ShortName(user) }}</span>
            </div>
          </div>
          <div v-if="filters.task_users && filters.task_users.length" style="padding:0 8px 8px">
            <div class="c1-fs-all" style="border-radius:8px" @click.stop="filters.task_users = []; fetchTasks()">
              <span class="c1-fs-all-lbl">Clear selection</span>
            </div>
          </div>
        </div>

        <!-- PRIORITY DROPDOWN -->
        <div v-show="c1TopTab === 'priority'" class="c1-ts-dropdown">
          <div class="c1-fs-grid c1-fs-grid-3" style="padding:6px 8px">
            <div class="c1-fs-scard" style="--fsclr:#E05A3A" :class="{ on: filters.priority_id === 1 }" @click.stop="c1SetPriorityFilter(1)">
              <svg viewBox="0 0 24 24" width="12" height="12"><polyline points="18 15 12 9 6 15"/></svg> High
            </div>
            <div class="c1-fs-scard" style="--fsclr:#E8891C" :class="{ on: filters.priority_id === 2 }" @click.stop="c1SetPriorityFilter(2)">
              <svg viewBox="0 0 24 24" width="12" height="12"><line x1="5" y1="12" x2="19" y2="12"/></svg> Medium
            </div>
            <div class="c1-fs-scard" style="--fsclr:#2D9D5E" :class="{ on: filters.priority_id === 3 }" @click.stop="c1SetPriorityFilter(3)">
              <svg viewBox="0 0 24 24" width="12" height="12"><polyline points="6 9 12 15 18 9"/></svg> Low
            </div>
            <div class="c1-fs-scard" style="--fsclr:#7C5CFC" :class="{ on: filters.priority_id === 4 }" @click.stop="c1SetPriorityFilter(4)">
              <svg viewBox="0 0 24 24" width="12" height="12"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/></svg> Critical
            </div>
          </div>
        </div>

        <!-- DATE DROPDOWN -->
        <div v-show="c1TopTab === 'date'" class="c1-ts-dropdown">
          <div class="c1-fs-grid c1-fs-grid-3" style="padding:6px 8px">
            <div class="c1-fs-scard" :class="{ on: c1DateFilter === 'T' }" @click.stop="c1ApplyDateFilter('T')">Today</div>
            <div class="c1-fs-scard" :class="{ on: c1DateFilter === 'Y' }" @click.stop="c1ApplyDateFilter('Y')">Yesterday</div>
            <div class="c1-fs-scard" :class="{ on: c1DateFilter === 'TW' }" @click.stop="c1ApplyDateFilter('TW')">This Week</div>
            <div class="c1-fs-scard" :class="{ on: c1DateFilter === 'LW' }" @click.stop="c1ApplyDateFilter('LW')">Last Week</div>
            <div class="c1-fs-scard" :class="{ on: c1DateFilter === 'TM' }" @click.stop="c1ApplyDateFilter('TM')">This Month</div>
            <div class="c1-fs-scard" :class="{ on: c1DateFilter === 'LM' }" @click.stop="c1ApplyDateFilter('LM')">Last Month</div>
            <div class="c1-fs-scard c1-fs-scard-wide" :class="{ on: c1DateFilter === 'ALL' }" @click.stop="c1ApplyDateFilter('ALL')">All Time</div>
          </div>
          <div class="c1-date-range-row" style="margin:0 8px 8px">
            <input type="date" class="c1-date-input" v-model="filters.due_date_from" @change="c1DateFilter = 'custom'; fetchTasks()" @click.stop />
            <span class="c1-date-sep">→</span>
            <input type="date" class="c1-date-input" v-model="filters.due_date_to" @change="c1DateFilter = 'custom'; fetchTasks()" @click.stop />
          </div>
        </div>

        <!-- TYPE DROPDOWN -->
        <div v-show="c1TopTab === 'type'" class="c1-ts-dropdown">
          <div class="c1-fs-grid c1-fs-grid-2" style="padding:6px 8px">
            <div class="c1-fs-scard" :class="{ on: c1TaskKind === 'task' }" @click.stop="c1SetTaskKind('task')">Task</div>
            <div class="c1-fs-scard" :class="{ on: c1TaskKind === 'meeting' }" @click.stop="c1SetTaskKind('meeting')">Meeting</div>
            <div class="c1-fs-scard" :class="{ on: c1TaskKind === 'announcement' }" @click.stop="c1SetTaskKind('announcement')">Announcement</div>
          </div>
          <div class="c1-fs-grid c1-fs-grid-2" style="padding:0 8px 8px">
            <div
              v-for="type in ((taskDictionaries && taskDictionaries.general && taskDictionaries.general.task_types) || [])"
              :key="type.id"
              class="c1-fs-scard"
              :class="{ on: filters.task_types && filters.task_types.includes(type.id) }"
              @click.stop="c1ToggleTaskType(type.id)"
            >{{ type.title || type.name }}</div>
          </div>
        </div>

        <!-- SORT DROPDOWN -->
        <div v-show="c1TopTab === 'sort'" class="c1-ts-dropdown">
          <div class="c1-fs-grid c1-fs-grid-2" style="padding:6px 8px">
            <div class="c1-fs-scard" :class="{ on: filters.sort_for_id === 'ASC' }" @click.stop="applyAmountSorting()">ID ↑</div>
            <div class="c1-fs-scard" :class="{ on: filters.sort_for_created === 'DESC' }" @click.stop="applyAmountSortingCreated()">Created ↓</div>
            <div class="c1-fs-scard" :class="{ on: filters.sort_for_mod === 'DESC' }" @click.stop="applyAmountSortingMod()">Modified ↓</div>
            <div class="c1-fs-scard" :class="{ on: filters.sort_for_time_running === true }" @click.stop="applyAmountSortingTimeRunning()">Time ↑</div>
            <div class="c1-fs-scard" :class="{ on: filters.sort_due === 'ASC' }" @click.stop="c1SortDue('ASC')">Due ↑</div>
            <div class="c1-fs-scard" :class="{ on: filters.sort_due === 'DESC' }" @click.stop="c1SortDue('DESC')">Due ↓</div>
          </div>
        </div>

        <!-- TEAM DROPDOWN -->
        <div v-show="c1TopTab === 'team'" class="c1-ts-dropdown" style="padding:6px 8px 10px">
          <div class="c1-fs-grid c1-fs-grid-3" style="padding:0">
            <div class="c1-fs-scard" :class="{ on: t1TeamFilter === null }" @click.stop="t1TeamFilter = null; fetchTasks(); c1TopTab = null">All Teams</div>
            <div class="c1-fs-scard" style="--fsclr:#0e7490" :class="{ on: t1TeamFilter === 1 }" @click.stop="t1TeamFilter = 1; fetchTasks(); c1TopTab = null">⚡ Team 1</div>
            <div class="c1-fs-scard" style="--fsclr:#7c3aed" :class="{ on: t1TeamFilter === 2 }" @click.stop="t1TeamFilter = 2; fetchTasks(); c1TopTab = null">🔥 Team 2</div>
          </div>
          <!-- Team breakdown summary -->
          <div style="display:flex;align-items:center;gap:8px;margin-top:8px;padding-top:8px;border-top:1px solid var(--c1-brd-l)">
            <span style="font-size:10px;color:var(--c1-t3);font-weight:600">BREAKDOWN</span>
            <span class="c1-t1-team-chip" style="background:rgba(14,116,144,.1);color:#0e7490">⚡ Team 1: {{ t1TeamTaskCount(1) }}</span>
            <span class="c1-t1-team-chip" style="background:rgba(124,58,237,.1);color:#7c3aed">🔥 Team 2: {{ t1TeamTaskCount(2) }}</span>
          </div>
        </div>

        <!-- CHARTS DROPDOWN -->
        <div v-show="c1TopTab === 'charts'" class="c1-ts-dropdown" style="padding:8px">
          <div class="c1-kpi-row">
            <div class="c1-kpi"><div class="c1-kpi-lbl">Active</div><div class="c1-kpi-val" style="color:#fa8100">{{ activeTasksCounter }}</div></div>
            <div class="c1-kpi"><div class="c1-kpi-lbl">Waiting</div><div class="c1-kpi-val" style="color:#4275ec">{{ stats.waiting_group }}</div></div>
            <div class="c1-kpi"><div class="c1-kpi-lbl">Done</div><div class="c1-kpi-val" style="color:#2D9D5E">{{ stats.completed_group }}</div></div>
            <div class="c1-kpi"><div class="c1-kpi-lbl">Missed</div><div class="c1-kpi-val" style="color:#E05A3A">{{ stats.tasks_missed }}</div></div>
          </div>
          <div class="c1-donut-row" style="margin-top:10px">
            <svg class="c1-donut" viewBox="0 0 80 80">
              <circle cx="40" cy="40" r="30" fill="none" stroke="#EDECEA" stroke-width="12"/>
              <circle cx="40" cy="40" r="30" fill="none" stroke="#fa8100" stroke-width="12" :stroke-dasharray="c1T1DonutDash(activeTasksCounter)" :stroke-dashoffset="c1T1DonutOffset(0)" transform="rotate(-90 40 40)"/>
              <circle cx="40" cy="40" r="30" fill="none" stroke="#4275ec" stroke-width="12" :stroke-dasharray="c1T1DonutDash(stats.waiting_group)" :stroke-dashoffset="c1T1DonutOffset(activeTasksCounter)" transform="rotate(-90 40 40)"/>
              <circle cx="40" cy="40" r="30" fill="none" stroke="#2D9D5E" stroke-width="12" :stroke-dasharray="c1T1DonutDash(stats.completed_group)" :stroke-dashoffset="c1T1DonutOffset((activeTasksCounter||0)+(stats.waiting_group||0))" transform="rotate(-90 40 40)"/>
              <text x="40" y="44" text-anchor="middle" font-size="13" font-weight="700" fill="var(--c1-t1,#2C2925)">{{ c1T1TotalTasks }}</text>
            </svg>
            <div class="c1-donut-legend">
              <div class="c1-dl-row"><span class="c1-dl-dot" style="background:#fa8100"></span><span>Active</span><span class="c1-dl-val">{{ activeTasksCounter }}</span></div>
              <div class="c1-dl-row"><span class="c1-dl-dot" style="background:#4275ec"></span><span>Waiting</span><span class="c1-dl-val">{{ stats.waiting_group }}</span></div>
              <div class="c1-dl-row"><span class="c1-dl-dot" style="background:#2D9D5E"></span><span>Done</span><span class="c1-dl-val">{{ stats.completed_group }}</span></div>
            </div>
          </div>
          <div class="c1-co-lbl" style="margin-top:12px">By Agent</div>
          <div v-if="!c1AgentTaskRows.length" class="c1-chart-empty">No agent data</div>
          <div v-for="row in c1AgentTaskRows.slice(0,8)" :key="row.name" class="c1-agent-bar-row">
            <div class="c1-agent-bar-name">{{ row.name }}</div>
            <div class="c1-agent-bar-track"><div class="c1-agent-bar-fill" :style="{ width: row.pct + '%' }"></div></div>
            <div class="c1-agent-bar-num">{{ row.count }}</div>
          </div>
          <div class="c1-co-lbl" style="margin-top:12px">By Team</div>
          <div style="display:flex;align-items:center;gap:6px;margin-top:4px">
            <span class="c1-t1-team-chip" style="background:rgba(14,116,144,.1);color:#0e7490">⚡ Team 1: {{ t1TeamTaskCount(1) }}</span>
            <span class="c1-t1-team-chip" style="background:rgba(124,58,237,.1);color:#7c3aed">🔥 Team 2: {{ t1TeamTaskCount(2) }}</span>
          </div>
        </div>

        <!-- GANTT DROPDOWN -->
        <div v-show="c1TopTab === 'gantt'" class="c1-ts-dropdown">
          <div class="c1-gantt-nav" style="display:flex;align-items:center;gap:8px;padding:8px 8px 4px">
            <button class="c1-cal-nav-btn" @click.stop="c1GanttOffset--">‹</button>
            <span style="font-size:11px;color:var(--c1-t2);flex:1">{{ c1GanttMonthLabel }}</span>
            <button class="c1-cal-nav-btn" @click.stop="c1GanttOffset++">›</button>
          </div>
          <div class="c1-gantt-wrap" style="margin:0 8px 8px;overflow-x:auto">
            <div class="c1-gantt-hdr">
              <div class="c1-gantt-name-col"></div>
              <div class="c1-gantt-days-col">
                <div v-for="d in c1GanttDays" :key="d.n" class="c1-gantt-day-tick" :class="{ today: d.isToday }">{{ d.label }}</div>
              </div>
            </div>
            <div v-for="row in c1GanttRows" :key="row.id" class="c1-gantt-row">
              <div class="c1-gantt-name" :title="row.title">{{ row.shortTitle }}</div>
              <div class="c1-gantt-bar-col">
                <div class="c1-gantt-bar-track">
                  <div class="c1-gantt-bar" :class="{ 'c1-gantt-done': row.done, 'c1-gantt-overdue': row.overdue }"
                    :style="{ left: row.left + '%', width: row.width + '%', background: row.color }"
                    @click.stop="c1OpenTaskDetail(row.task)">
                    <span class="c1-gantt-bar-lbl">{{ row.shortTitle }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!c1GanttRows.length" class="c1-chart-empty" style="padding:12px">No tasks in this period</div>
          </div>
        </div>

        <!-- ACTIVITY DROPDOWN -->
        <div v-show="c1TopTab === 'activity'" class="c1-ts-dropdown" style="max-height:260px;overflow-y:auto">
          <div class="c1-co-lbl" style="padding:8px 8px 4px">Activity Log</div>
          <div v-if="!c1GlobalLogs.length" class="c1-chart-empty" style="padding:8px">No activity recorded yet</div>
          <div v-for="(entry, i) in c1GlobalLogs.slice(0,20)" :key="i" class="c1-log-entry" style="padding:6px 8px">
            <div class="c1-log-icon" :class="'c1-log-' + entry.type">
              <svg v-if="entry.type==='create'" viewBox="0 0 24 24" width="10" height="10"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              <svg v-else-if="entry.type==='done'" viewBox="0 0 24 24" width="10" height="10"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else viewBox="0 0 24 24" width="10" height="10"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/></svg>
            </div>
            <div class="c1-log-body">
              <div class="c1-log-msg">{{ entry.msg }}</div>
              <div class="c1-log-meta"><span class="c1-log-task" @click.stop="entry.task && c1OpenTaskDetail(entry.task)">#{{ entry.taskId }}</span> · {{ entry.who }}</div>
            </div>
            <div class="c1-log-time c1-mono">{{ entry.timeAgo }}</div>
          </div>
        </div>

      </div>
    </div><!-- /c1-top-strip -->

    <!-- TASK SMART CALENDAR — always visible below filter tabs -->
    <c1-task-smart-calendar
      :tasks="tasks"
      @daySelected="c1CalDaySelected"
      @reset="c1FullReset"
    />

    <!-- STATUS STRIP (compact single-line) -->
    <div class="c1-status-strip">
      <div class="c1-status-pill" :class="'c1-sp-' + c1CurrentTabKey">
        <span class="c1-sp-dot"></span>
        <span class="c1-sp-lbl">{{ c1CurrentTabLabel }}</span>
        <span class="c1-sp-count">{{ c1CurrentTabCount }}</span>
      </div>
      <div class="c1-hp"></div>
      <div class="c1-ss-shortcuts">
        <div class="c1-ss-chip" :class="{ on: selectedTab === 'active' }" @click="c1SetTab('active')">Active <span>{{ activeTasksCounter }}</span></div>
        <div class="c1-ss-chip" :class="{ on: selectedTab === 'waiting' }" @click="c1SetTab('waiting')">Wait <span>{{ stats.waiting_group }}</span></div>
        <div class="c1-ss-chip c1-ss-done" :class="{ on: selectedTab === 'completed' }" @click="c1SetTab('completed')">Done <span>{{ stats.completed_group }}</span></div>
        <div class="c1-ss-chip c1-ss-missed" :class="{ on: filters.missed_tasks }" @click="c1ToggleMissed()">Miss <span>{{ stats.tasks_missed }}</span></div>
      </div>
    </div>

    <!-- Viki left panel backdrop -->
    <transition name="c1-bd-fade">
      <div v-if="c1VikiOpen" class="c1-panel-backdrop" @click.stop="c1VikiOpen = false"></div>
    </transition>

    <!-- VIKI LEFT PANEL -->
    <transition name="c1-viki-slide">
      <div v-if="c1VikiOpen" class="c1-viki-left-panel" @click.stop>
        <div class="c1-panel-hdr-bar">
          <span class="c1-panel-hdr-ttl">Viki AI</span>
          <div class="c1-panel-back-btn" @click="c1VikiOpen = false">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </div>
        </div>
        <div class="c1-sl-body">
          <div v-for="(msg, i) in c1VikiMessages" :key="i" class="c1-viki-msg-row" :class="{ 'c1-viki-msg-warn': msg.type === 'warn', 'c1-viki-msg-ok': msg.type === 'ok', 'c1-viki-msg-info': msg.type === 'info' }">
            <div class="c1-viki-msg-icon">
              <svg v-if="msg.type === 'warn'" viewBox="0 0 24 24" width="14" height="14"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
              <svg v-else-if="msg.type === 'ok'" viewBox="0 0 24 24" width="14" height="14"><polyline points="20 6 9 17 4 12"/></svg>
              <svg v-else viewBox="0 0 24 24" width="14" height="14"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            </div>
            <div class="c1-viki-msg-body" v-html="msg.text"></div>
          </div>
          <div v-if="!c1VikiMessages.length" class="c1-chart-empty" style="color:#2D9D5E">All caught up!</div>
          <div style="height:16px"></div>
        </div>
      </div>
    </transition>

    <!-- Panel backdrop -->
    <transition name="c1-bd-fade">
      <div v-if="c1SlideOpen" class="c1-panel-backdrop" @click.stop="c1SlideOpen = null"></div>
    </transition>

    <!-- ======== UNIFIED RIGHT PANEL ======== -->
    <div class="c1-panel" :class="{ 'c1-panel--open': c1PanelIsOpen }" @click.capture="c1FilterPanelClick">
      <div class="c1-panel-track" :class="{ 'at-content': c1PanelAtContent }">

        <!-- SCREEN 0: NAV MENU -->
        <div class="c1-panel-screen">
          <!-- ── USER STRIP ── -->
          <div class="c1-nav-user-strip">
            <div class="c1-nav-av">
              {{ c1UserInitials }}
              <span class="c1-nav-av-dot" :class="'c1-dst-' + c1Status"></span>
            </div>
            <div class="c1-nav-uinfo">
              <div class="c1-nav-uname">{{ c1UserFullName }}</div>
              <div class="c1-nav-urole">{{ c1RoleLabel }}</div>
            </div>
            <div class="c1-nav-status-wrap" @click.stop="c1StatusMenuOpen = !c1StatusMenuOpen">
              <div class="c1-nav-status-btn" :class="'c1-st-' + c1Status">
                <span class="c1-nav-status-sdot"></span>
                <span class="c1-nav-status-elapsed">{{ c1StatusElapsed }}</span>
              </div>
              <transition name="c1-sfade">
                <div v-if="c1StatusMenuOpen" class="c1-nav-status-menu">
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('available')"><span class="c1-nav-status-opt-dot c1-st-dot-available"></span>Available</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('bathroom')"><span class="c1-nav-status-opt-dot c1-st-dot-bathroom"></span>Bathroom</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('coffee')"><span class="c1-nav-status-opt-dot c1-st-dot-coffee"></span>Coffee break</div>
                  <div class="c1-nav-status-opt" @click.stop="c1SetStatus('shift')"><span class="c1-nav-status-opt-dot c1-st-dot-shift"></span>Start shift</div>
                  <div class="c1-nav-status-opt c1-sto-end" @click.stop="c1SetStatus('end')"><span class="c1-nav-status-opt-dot c1-st-dot-end"></span>End shift</div>
                </div>
              </transition>
            </div>
          </div>

          <!-- ── TIMEZONE BAR ── -->
          <div class="c1-nav-tz-bar">
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇬🇧</span><span class="c1-nav-tz-time">{{ c1TzUK }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🇮🇱</span><span class="c1-nav-tz-time">{{ c1TzIL }}</span></div>
            <div class="c1-nav-tz-sep"></div>
            <div class="c1-nav-tz-cell"><span class="c1-nav-tz-flag">🏝</span><span class="c1-nav-tz-time">{{ c1TzCB }}</span></div>
          </div>

          <!-- ── NAVIGATE: all pages ── -->
          <div v-if="c1NavMode === 'navigate'" class="c1-sl-body" style="padding:6px 0 12px">
            <div class="c1-psel-sub c1-psel-sub-back" @click.stop="c1NavMode = 'panels'">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:14px;height:14px;flex-shrink:0"><polyline points="15 18 9 12 15 6"/></svg>
              <span class="c1-psel-sub-lbl">{{ c1CurrentPageLabel }}</span>
            <span class="c1-nav-x-btn" @click.stop="c1SlideOpen = null"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="width:15px;height:15px;display:block"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></span></div>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">CRM</div>
            <router-link class="c1-psel-sub" to="/clients1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Clients</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/tasks1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Tasks</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/stats1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Statistics</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/chat1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Chat</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/communications1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Communications</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/affiliation1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">Affiliation</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Sales</div>
            <router-link class="c1-psel-sub" to="/finance1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Finance</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/shifts1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Shifts</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/games1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-sc)"></span><span class="c1-psel-sub-lbl">Games</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Team</div>
            <router-link class="c1-psel-sub" to="/users1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Users</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/brokers1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Brokers</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/security1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-rf)"></span><span class="c1-psel-sub-lbl">Security</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <div class="c1-psel-divider"></div>
            <div class="c1-psel-grp-hdr">Admin</div>
            <router-link class="c1-psel-sub" to="/quiz1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Quiz</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/instruction1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Instructions</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/settings1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:#7c6f9f"></span><span class="c1-psel-sub-lbl">Settings</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
            <router-link class="c1-psel-sub" to="/profile1" @click.native="c1SlideOpen = null; sessionStorage.setItem('c1keepNav','1')"><span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span><span class="c1-psel-sub-lbl">My Profile</span><svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></router-link>
          </div>

          <!-- ── PANELS MODE ── -->
          <div v-else class="c1-sl-body" style="padding:6px 0 12px">

            <!-- Navigate row -->
            <div class="c1-psel-sub c1-psel-sub-navigate" @click.stop="c1NavMode = 'navigate'">
              <span class="c1-psel-sub-dot" style="background:var(--c1-dp)"></span>
              <span class="c1-psel-sub-lbl" style="font-weight:600;color:var(--c1-dp)">{{ c1CurrentPageLabel }}</span>
              <span class="c1-psel-sub-hint">Go to another page</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-divider"></div>

            <!-- Quick actions -->
            <div class="c1-psel-action-row">
              <div class="c1-psel-action-btn" @click.stop="c1OpenCreateTask(); c1SlideOpen = null">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                New Task
              </div>
              <div class="c1-psel-action-btn c1-psel-action-announce" @click.stop="c1SetTab('announcements'); c1SlideOpen = null">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 17H2a3 3 0 0 0 3-3V9a7 7 0 0 1 14 0v5a3 3 0 0 0 3 3z"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
                Announce
                <span v-if="c1AnnouncementCount" class="c1-psel-opt-badge">{{ c1AnnouncementCount }}</span>
              </div>
            </div>
            <div class="c1-psel-action-row" style="padding-top:0">
              <div class="c1-psel-action-btn c1-psel-action-outline" @click.stop="c1SetTab('outline'); c1SlideOpen = null">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/></svg>
                Outline <span v-if="stats.outline_group" style="background:rgba(255,255,255,.3);border-radius:4px;padding:0 4px;margin-left:3px">{{ stats.outline_group }}</span>
              </div>
              <div v-if="CheckUserPermission && CheckUserPermission([1, 2])" class="c1-psel-action-btn c1-psel-action-events" @click.stop="c1SetTab('events'); c1SlideOpen = null">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                Events <span v-if="stats.events_group" style="background:rgba(255,255,255,.3);border-radius:4px;padding:0 4px;margin-left:3px">{{ stats.events_group }}</span>
              </div>
              <div v-else class="c1-psel-action-btn c1-psel-action-events" @click.stop="c1SetTab('events'); c1SlideOpen = null">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
                Coming <span v-if="stats.tasks_coming" style="background:rgba(255,255,255,.3);border-radius:4px;padding:0 4px;margin-left:3px">{{ stats.tasks_coming }}</span>
              </div>
            </div>
            <div class="c1-psel-divider"></div>

            <!-- Filters group -->
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
              Filters<span v-if="c1ActiveFilterCount" class="c1-psel-opt-badge" style="margin-left:6px">{{ c1ActiveFilterCount }}</span>
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'filters' && c1FilterTab === 'status' }" @click.stop="c1SelectPanel('filters','status')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Status</span>
              <span class="c1-psel-sub-hint">Active · Waiting · Done</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'filters' && c1FilterTab === 'agents' }" @click.stop="c1SelectPanel('filters','agents')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Agents</span>
              <span class="c1-psel-sub-hint">Filter by agent</span>
              <span v-if="filters.task_users && filters.task_users.length" class="c1-psel-opt-badge">{{ filters.task_users.length }}</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'filters' && c1FilterTab === 'priority' }" @click.stop="c1SelectPanel('filters','priority')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Priority</span>
              <span class="c1-psel-sub-hint">High · Med · Low</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'filters' && c1FilterTab === 'date' }" @click.stop="c1SelectPanel('filters','date')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Date</span>
              <span class="c1-psel-sub-hint">Due date range</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'filters' && c1FilterTab === 'type' }" @click.stop="c1SelectPanel('filters','type')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Type</span>
              <span class="c1-psel-sub-hint">Task · Meeting · etc.</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'filters' && c1FilterTab === 'sort' }" @click.stop="c1SelectPanel('filters','sort')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Sort</span>
              <span class="c1-psel-sub-hint">Order results</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>

            <div class="c1-psel-divider"></div>

            <!-- Charts group -->
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
              Charts
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'charts' }" @click.stop="c1SelectPanel('charts','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">7-Day Trend</span>
              <span class="c1-psel-sub-hint">Tasks over time</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'charts-agents' }" @click.stop="c1SelectPanel('charts-agents','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">By Agent</span>
              <span class="c1-psel-sub-hint">Tasks per person</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>

            <div class="c1-psel-divider"></div>

            <!-- Calendar group -->
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Calendar
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'calendar' }" @click.stop="c1SelectPanel('calendar','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Monthly View</span>
              <span class="c1-psel-sub-hint">Tasks by date</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>

            <div class="c1-psel-divider"></div>

            <!-- Gantt group -->
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="15" y2="12"/><line x1="3" y1="18" x2="18" y2="18"/></svg>
              Gantt
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'gantt' }" @click.stop="c1SelectPanel('gantt','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Timeline View</span>
              <span class="c1-psel-sub-hint">Tasks on timeline</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>

            <div class="c1-psel-divider"></div>

            <!-- Logs group -->
            <div class="c1-psel-grp-hdr">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:13px;height:13px"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
              Activity
            </div>
            <div class="c1-psel-sub" :class="{ on: c1PanelActiveContent === 'logs' }" @click.stop="c1SelectPanel('logs','')">
              <span class="c1-psel-sub-dot"></span>
              <span class="c1-psel-sub-lbl">Activity Log</span>
              <span class="c1-psel-sub-hint">All task actions</span>
              <svg class="c1-psel-nav-arr" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>
            </div>

          </div><!-- end v-else panels -->
        </div><!-- end screen 0 -->

        <!-- SCREEN 1: CONTENT -->
        <div class="c1-panel-screen">
          <div class="c1-panel-hdr-bar">
            <span class="c1-panel-hdr-ttl">{{ c1ActivePanelLabel }}</span>
            <div class="c1-panel-back-btn" @click="c1SlideOpen = null">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>

          <!-- ── FILTERS CONTENT ── -->
          <template v-if="c1PanelActiveContent === 'filters'">
            <div class="c1-ftab-menu">
              <div class="c1-ftab-mi" :class="{ on: c1FilterTab === 'status' }" @click.stop="c1FilterTab = 'status'">
                <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/></svg>
                <span>Status</span>
              </div>
              <div class="c1-ftab-mi" :class="{ on: c1FilterTab === 'agents' }" @click.stop="c1FilterTab = 'agents'">
                <svg viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
                <span>Agents</span>
                <span v-if="filters.task_users && filters.task_users.length" class="c1-ftab-badge">{{ filters.task_users.length }}</span>
              </div>
              <div class="c1-ftab-mi" :class="{ on: c1FilterTab === 'priority' }" @click.stop="c1FilterTab = 'priority'">
                <svg viewBox="0 0 24 24"><polyline points="18 15 12 9 6 15"/></svg>
                <span>Priority</span>
              </div>
              <div class="c1-ftab-mi" :class="{ on: c1FilterTab === 'date' }" @click.stop="c1FilterTab = 'date'">
                <svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                <span>Date</span>
              </div>
              <div class="c1-ftab-mi" :class="{ on: c1FilterTab === 'type' }" @click.stop="c1FilterTab = 'type'">
                <svg viewBox="0 0 24 24"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>
                <span>Type</span>
              </div>
              <div class="c1-ftab-mi" :class="{ on: c1FilterTab === 'sort' }" @click.stop="c1FilterTab = 'sort'">
                <svg viewBox="0 0 24 24"><line x1="3" y1="6" x2="21" y2="6"/><line x1="6" y1="12" x2="18" y2="12"/><line x1="9" y1="18" x2="15" y2="18"/></svg>
                <span>Sort</span>
              </div>
            </div>

            <div v-if="c1ActiveFilterCount" class="c1-reset-bar" @click.stop="c1FullReset()">
              <svg viewBox="0 0 24 24"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-4.95"/></svg>
              Reset all filters
              <span class="c1-reset-bar-count">{{ c1ActiveFilterCount }}</span>
            </div>

            <div class="c1-sl-body">

        <!-- STATUS TAB -->
        <template v-if="c1FilterTab === 'status'">
          <div class="c1-fs-search-wrap">
            <svg class="c1-fp-sico" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input class="c1-fp-sinput" v-model.trim="wordFilter" placeholder="Search tasks…" type="text" />
            <div v-if="wordFilter" class="c1-fp-sclear" @click="wordFilter = ''">
              <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
          <div class="c1-fp-group c1-fp-full" style="padding:0 12px 4px">
            <div class="c1-fp-search">
              <svg class="c1-fp-sico" viewBox="0 0 24 24"><line x1="4" y1="9" x2="20" y2="9"/><line x1="4" y1="15" x2="20" y2="15"/><line x1="10" y1="3" x2="8" y2="21"/><line x1="16" y1="3" x2="14" y2="21"/></svg>
              <input class="c1-fp-sinput" v-model.trim="filters.task_id" placeholder="#Task ID…" type="text" />
            </div>
          </div>
          <div class="c1-fs-section-lbl">Status</div>
          <div class="c1-fs-grid">
            <div class="c1-fs-card" style="--fsclr:#fa8100" :class="{ on: selectedTab === 'active' }" @click="c1SetTab('active'); c1SlideOpen = null">
              <span class="c1-fs-name">Production</span>
              <span class="c1-fs-num">{{ activeTasksCounter }}</span>
            </div>
            <div class="c1-fs-card" style="--fsclr:#4275ec" :class="{ on: selectedTab === 'waiting' }" @click="c1SetTab('waiting'); c1SlideOpen = null">
              <span class="c1-fs-name">Waiting</span>
              <span class="c1-fs-num">{{ stats.waiting_group }}</span>
            </div>
            <div class="c1-fs-card" style="--fsclr:#2D9D5E" :class="{ on: selectedTab === 'completed' }" @click="c1SetTab('completed'); c1SlideOpen = null">
              <span class="c1-fs-name">Completed</span>
              <span class="c1-fs-num">{{ stats.completed_group }}</span>
            </div>
            <div class="c1-fs-card" style="--fsclr:#E05A3A" :class="{ on: filters.missed_tasks }" @click="c1ToggleMissed(); c1SlideOpen = null">
              <span class="c1-fs-name">Missed</span>
              <span class="c1-fs-num">{{ stats.tasks_missed }}</span>
            </div>
            <div class="c1-fs-card" style="--fsclr:#7C5CFC" :class="{ on: selectedTab === 'outline' }" @click="c1SetTab('outline'); c1SlideOpen = null">
              <span class="c1-fs-name">Outline</span>
              <span class="c1-fs-num">{{ stats.outline_group }}</span>
            </div>
            <div class="c1-fs-card" style="--fsclr:#E8891C" :class="{ on: filters.coming_tasks }" @click="c1ToggleComing(); c1SlideOpen = null">
              <span class="c1-fs-name">Coming</span>
              <span class="c1-fs-num">{{ stats.tasks_coming }}</span>
            </div>
          </div>
          <div class="c1-fs-section-lbl">Scheduled</div>
          <div class="c1-fs-grid c1-fs-grid-3">
            <div class="c1-fs-scard" :class="{ on: filters.coming_tasks }" @click="comingTasksFilterMenuHandler()">Coming</div>
            <div class="c1-fs-scard" :class="{ on: filters.missed_tasks }" @click="missedTasksFilterMenuHandler()">Missed</div>
            <div class="c1-fs-scard" :class="{ on: filters.today_tasks }" @click="todayTasksFilterMenuHandler()">Today</div>
          </div>
          <div class="c1-fs-section-lbl">Show</div>
          <div class="c1-fs-toggle">
            <div class="c1-fs-tog-btn" :class="{ on: !filters.show_all_tasks }" @click="filters.show_all_tasks = false; fetchTasks()">Mine</div>
            <div class="c1-fs-tog-btn" :class="{ on: filters.show_all_tasks }" @click="filters.show_all_tasks = true; fetchTasks()">All Tasks</div>
          </div>
        </template>

        <!-- AGENTS TAB -->
        <template v-if="c1FilterTab === 'agents'">
          <div class="c1-fs-agent-hdr">
            <span class="c1-fs-section-lbl" style="padding:10px 14px 4px">Assigned to
              <span v-if="filters.task_users && filters.task_users.length" class="c1-fs-agent-count">{{ filters.task_users.length }}</span>
            </span>
            <span v-if="filters.task_users && filters.task_users.length" class="c1-fs-agent-clear" @click.stop="filters.task_users = []; fetchTasks()">Clear all</span>
          </div>
          <div class="c1-agent-grid">
            <div
              v-for="user in (salesPersonList || []).slice(0, 30)"
              :key="user.id"
              class="c1-agent-chip"
              :class="{ on: filters.task_users && filters.task_users.includes(user.id) }"
              @click="c1ToggleTaskUser(user.id)"
            >
              <div class="c1-agent-av">{{ c1T1UserInitials(user) }}</div>
              <span class="c1-agent-nm">{{ c1T1ShortName(user) }}</span>
            </div>
          </div>
        </template>

        <!-- PRIORITY TAB -->
        <template v-if="c1FilterTab === 'priority'">
          <div class="c1-fs-section-lbl" style="padding-top:10px">Priority level</div>
          <div class="c1-fs-grid c1-fs-grid-3">
            <div class="c1-fs-scard" style="--fsclr:#E05A3A" :class="{ on: filters.priority_id === 1 }" @click="c1SetPriorityFilter(1)">
              <svg viewBox="0 0 24 24" width="12" height="12"><polyline points="18 15 12 9 6 15"/></svg> High
            </div>
            <div class="c1-fs-scard" style="--fsclr:#E8891C" :class="{ on: filters.priority_id === 2 }" @click="c1SetPriorityFilter(2)">
              <svg viewBox="0 0 24 24" width="12" height="12"><line x1="5" y1="12" x2="19" y2="12"/></svg> Medium
            </div>
            <div class="c1-fs-scard" style="--fsclr:#2D9D5E" :class="{ on: filters.priority_id === 3 }" @click="c1SetPriorityFilter(3)">
              <svg viewBox="0 0 24 24" width="12" height="12"><polyline points="6 9 12 15 18 9"/></svg> Low
            </div>
            <div class="c1-fs-scard" style="--fsclr:#7C5CFC" :class="{ on: filters.priority_id === 4 }" @click="c1SetPriorityFilter(4)">
              <svg viewBox="0 0 24 24" width="12" height="12"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/></svg> Critical
            </div>
          </div>
        </template>

        <!-- DATE TAB -->
        <template v-if="c1FilterTab === 'date'">
          <div class="c1-fs-section-lbl" style="padding-top:10px">Due date range</div>
          <div class="c1-fs-grid c1-fs-grid-3">
            <div class="c1-fs-scard" :class="{ on: c1DateFilter === 'T' }" @click="c1ApplyDateFilter('T')">T</div>
            <div class="c1-fs-scard" :class="{ on: c1DateFilter === 'Y' }" @click="c1ApplyDateFilter('Y')">Y</div>
            <div class="c1-fs-scard" :class="{ on: c1DateFilter === 'TW' }" @click="c1ApplyDateFilter('TW')">TW</div>
            <div class="c1-fs-scard" :class="{ on: c1DateFilter === 'LW' }" @click="c1ApplyDateFilter('LW')">LW</div>
            <div class="c1-fs-scard" :class="{ on: c1DateFilter === 'TM' }" @click="c1ApplyDateFilter('TM')">TM</div>
            <div class="c1-fs-scard" :class="{ on: c1DateFilter === 'LM' }" @click="c1ApplyDateFilter('LM')">LM</div>
            <div class="c1-fs-scard c1-fs-scard-wide" :class="{ on: c1DateFilter === 'ALL' }" @click="c1ApplyDateFilter('ALL')">ALL</div>
          </div>
          <div class="c1-fs-section-lbl" style="padding-top:8px">Custom due range</div>
          <div class="c1-date-range-row" style="margin:0 12px 12px">
            <input type="date" class="c1-date-input" v-model="filters.due_date_from" @change="c1DateFilter = 'custom'; fetchTasks()" />
            <span class="c1-date-sep">→</span>
            <input type="date" class="c1-date-input" v-model="filters.due_date_to" @change="c1DateFilter = 'custom'; fetchTasks()" />
          </div>
        </template>

        <!-- TYPE TAB -->
        <template v-if="c1FilterTab === 'type'">
          <div class="c1-fs-section-lbl" style="padding-top:10px">Task type</div>
          <div class="c1-fs-grid c1-fs-grid-2">
            <div class="c1-fs-scard" :class="{ on: c1TaskKind === 'task' }" @click="c1SetTaskKind('task')">Task</div>
            <div class="c1-fs-scard" :class="{ on: c1TaskKind === 'meeting' }" @click="c1SetTaskKind('meeting')">Meeting</div>
            <div class="c1-fs-scard" :class="{ on: c1TaskKind === 'announcement' }" @click="c1SetTaskKind('announcement')">Announcement</div>
          </div>
          <div class="c1-fs-section-lbl" style="padding-top:8px">Category</div>
          <div class="c1-fs-grid c1-fs-grid-2">
            <div
              v-for="type in ((taskDictionaries && taskDictionaries.general && taskDictionaries.general.task_types) || [])"
              :key="type.id"
              class="c1-fs-scard"
              :class="{ on: filters.task_types && filters.task_types.includes(type.id) }"
              @click="c1ToggleTaskType(type.id)"
            >{{ type.title || type.name }}</div>
          </div>
        </template>

        <!-- SORT TAB -->
        <template v-if="c1FilterTab === 'sort'">
          <div class="c1-fs-section-lbl" style="padding-top:10px">Sort by</div>
          <div class="c1-fs-grid c1-fs-grid-2">
            <div class="c1-fs-scard" :class="{ on: filters.sort_for_id === 'ASC' }" @click="applyAmountSorting()">ID ↑</div>
            <div class="c1-fs-scard" :class="{ on: filters.sort_for_created === 'DESC' }" @click="applyAmountSortingCreated()">Created ↓</div>
            <div class="c1-fs-scard" :class="{ on: filters.sort_for_mod === 'DESC' }" @click="applyAmountSortingMod()">Modified ↓</div>
            <div class="c1-fs-scard" :class="{ on: filters.sort_for_time_running === true }" @click="applyAmountSortingTimeRunning()">Time ↑</div>
            <div class="c1-fs-scard" :class="{ on: filters.sort_due === 'ASC' }" @click="c1SortDue('ASC')">Due ↑</div>
            <div class="c1-fs-scard" :class="{ on: filters.sort_due === 'DESC' }" @click="c1SortDue('DESC')">Due ↓</div>
          </div>
        </template>

            </div>
          </template>

          <!-- ── CHARTS CONTENT ── -->
          <template v-else-if="c1PanelActiveContent === 'charts'">
            <div class="c1-sl-body">

        <!-- KPI row -->
        <div class="c1-co-lbl">Overview</div>
        <div class="c1-kpi-row">
          <div class="c1-kpi"><div class="c1-kpi-lbl">Active</div><div class="c1-kpi-val" style="color:#fa8100">{{ activeTasksCounter }}</div></div>
          <div class="c1-kpi"><div class="c1-kpi-lbl">Waiting</div><div class="c1-kpi-val" style="color:#4275ec">{{ stats.waiting_group }}</div></div>
          <div class="c1-kpi"><div class="c1-kpi-lbl">Done</div><div class="c1-kpi-val" style="color:#2D9D5E">{{ stats.completed_group }}</div></div>
          <div class="c1-kpi"><div class="c1-kpi-lbl">Outline</div><div class="c1-kpi-val" style="color:#7C5CFC">{{ stats.outline_group }}</div></div>
        </div>
        <div class="c1-kpi-row" style="margin-top:6px">
          <div class="c1-kpi"><div class="c1-kpi-lbl">Missed</div><div class="c1-kpi-val" style="color:#E05A3A">{{ stats.tasks_missed }}</div></div>
          <div class="c1-kpi"><div class="c1-kpi-lbl">Coming</div><div class="c1-kpi-val" style="color:#E8891C">{{ stats.tasks_coming }}</div></div>
          <div class="c1-kpi"><div class="c1-kpi-lbl">Today</div><div class="c1-kpi-val">{{ stats.tasks_today }}</div></div>
          <div class="c1-kpi"><div class="c1-kpi-lbl">Rate</div><div class="c1-kpi-val" style="color:#2D9D5E">{{ c1T1CompletionRate }}%</div></div>
        </div>

        <!-- Donut -->
        <div class="c1-co-lbl" style="margin-top:14px">Distribution</div>
        <div class="c1-donut-row">
          <svg class="c1-donut" viewBox="0 0 80 80">
            <circle cx="40" cy="40" r="30" fill="none" stroke="#EDECEA" stroke-width="12"/>
            <circle cx="40" cy="40" r="30" fill="none" stroke="#fa8100" stroke-width="12"
              :stroke-dasharray="c1T1DonutDash(activeTasksCounter)"
              :stroke-dashoffset="c1T1DonutOffset(0)"
              transform="rotate(-90 40 40)"/>
            <circle cx="40" cy="40" r="30" fill="none" stroke="#4275ec" stroke-width="12"
              :stroke-dasharray="c1T1DonutDash(stats.waiting_group)"
              :stroke-dashoffset="c1T1DonutOffset(activeTasksCounter)"
              transform="rotate(-90 40 40)"/>
            <circle cx="40" cy="40" r="30" fill="none" stroke="#2D9D5E" stroke-width="12"
              :stroke-dasharray="c1T1DonutDash(stats.completed_group)"
              :stroke-dashoffset="c1T1DonutOffset((activeTasksCounter||0)+(stats.waiting_group||0))"
              transform="rotate(-90 40 40)"/>
            <circle cx="40" cy="40" r="30" fill="none" stroke="#7C5CFC" stroke-width="12"
              :stroke-dasharray="c1T1DonutDash(stats.outline_group)"
              :stroke-dashoffset="c1T1DonutOffset((activeTasksCounter||0)+(stats.waiting_group||0)+(stats.completed_group||0))"
              transform="rotate(-90 40 40)"/>
            <text x="40" y="44" text-anchor="middle" font-size="13" font-weight="700" fill="var(--c1-t1,#2C2925)">{{ c1T1TotalTasks }}</text>
          </svg>
          <div class="c1-donut-legend">
            <div class="c1-dl-row"><span class="c1-dl-dot" style="background:#fa8100"></span><span>Active</span><span class="c1-dl-val">{{ activeTasksCounter }}</span></div>
            <div class="c1-dl-row"><span class="c1-dl-dot" style="background:#4275ec"></span><span>Waiting</span><span class="c1-dl-val">{{ stats.waiting_group }}</span></div>
            <div class="c1-dl-row"><span class="c1-dl-dot" style="background:#2D9D5E"></span><span>Done</span><span class="c1-dl-val">{{ stats.completed_group }}</span></div>
            <div class="c1-dl-row"><span class="c1-dl-dot" style="background:#7C5CFC"></span><span>Outline</span><span class="c1-dl-val">{{ stats.outline_group }}</span></div>
          </div>
        </div>

        <!-- Completion rate -->
        <div class="c1-co-lbl" style="margin-top:14px">Completion Rate</div>
        <div class="c1-crate-wrap">
          <div class="c1-crate-track">
            <div class="c1-crate-fill" :style="{ width: c1T1CompletionRate + '%' }"></div>
          </div>
          <span class="c1-crate-pct">{{ c1T1CompletionRate }}%</span>
        </div>

        <!-- Bar chart by status -->
        <div class="c1-co-lbl" style="margin-top:14px">Status Breakdown</div>
        <div class="c1-vbar-chart">
          <div class="c1-vbar-row">
            <div class="c1-vbar-lbl">Active</div>
            <div class="c1-vbar-track"><div class="c1-vbar-fill" :style="{ width: c1T1Pct(activeTasksCounter) + '%', background: '#fa8100' }"><span class="c1-vbar-val">{{ activeTasksCounter }}</span></div></div>
          </div>
          <div class="c1-vbar-row">
            <div class="c1-vbar-lbl">Waiting</div>
            <div class="c1-vbar-track"><div class="c1-vbar-fill" :style="{ width: c1T1Pct(stats.waiting_group) + '%', background: '#4275ec' }"><span class="c1-vbar-val">{{ stats.waiting_group }}</span></div></div>
          </div>
          <div class="c1-vbar-row">
            <div class="c1-vbar-lbl">Done</div>
            <div class="c1-vbar-track"><div class="c1-vbar-fill" :style="{ width: c1T1Pct(stats.completed_group) + '%', background: '#2D9D5E' }"><span class="c1-vbar-val">{{ stats.completed_group }}</span></div></div>
          </div>
          <div class="c1-vbar-row">
            <div class="c1-vbar-lbl">Outline</div>
            <div class="c1-vbar-track"><div class="c1-vbar-fill" :style="{ width: c1T1Pct(stats.outline_group) + '%', background: '#7C5CFC' }"><span class="c1-vbar-val">{{ stats.outline_group }}</span></div></div>
          </div>
          <div class="c1-vbar-row">
            <div class="c1-vbar-lbl">Missed</div>
            <div class="c1-vbar-track"><div class="c1-vbar-fill" :style="{ width: c1T1Pct(stats.tasks_missed) + '%', background: '#E05A3A' }"><span class="c1-vbar-val">{{ stats.tasks_missed }}</span></div></div>
          </div>
        </div>

        <!-- Overdue timeline -->
        <div class="c1-co-lbl" style="margin-top:14px">Overdue Timeline</div>
        <div class="c1-overdue-list">
          <div v-for="(task, i) in c1OverdueTasks.slice(0,5)" :key="task.id" class="c1-overdue-row" @click="c1OpenTaskDetail(task)">
            <div class="c1-overdue-rank">{{ i+1 }}</div>
            <div class="c1-overdue-info">
              <div class="c1-overdue-title">{{ c1T1Truncate(task.title || task.content_title, 40) }}</div>
              <div class="c1-overdue-due">Due {{ c1T1FmtDate(task.due_date) }}</div>
            </div>
            <div class="c1-overdue-days">{{ c1DaysOverdue(task) }}d</div>
          </div>
          <div v-if="!c1OverdueTasks.length" class="c1-chart-empty" style="color:#2D9D5E">No overdue tasks</div>
        </div>

        <!-- 7-day chart -->
        <div class="c1-co-lbl" style="margin-top:14px">Last 7 Days</div>
        <div class="c1-7day-chart">
          <div v-for="(day, i) in c1T1SevenDays" :key="i" class="c1-7day-col">
            <div class="c1-7day-bars">
              <div class="c1-7day-bar due" :style="{ height: c1T17DayH(day.due) + 'px' }" :title="day.due + ' due'"></div>
              <div class="c1-7day-bar done" :style="{ height: c1T17DayH(day.done) + 'px' }" :title="day.done + ' done'"></div>
            </div>
            <div class="c1-7day-lbl">{{ day.label }}</div>
          </div>
        </div>
        <div class="c1-7day-legend">
          <span style="display:inline-block;width:8px;height:8px;border-radius:2px;background:#fa8100;margin-right:4px"></span><span style="font-size:10px;color:var(--c1-t2)">Due</span>
          &nbsp;&nbsp;
          <span style="display:inline-block;width:8px;height:8px;border-radius:2px;background:#2D9D5E;margin-right:4px"></span><span style="font-size:10px;color:var(--c1-t2)">Done</span>
        </div>

        <!-- Time per task bar -->
        <div class="c1-co-lbl" style="margin-top:14px">Time Logged (top tasks)</div>
        <div class="c1-vbar-chart">
          <div v-for="task in c1TopTimeTasks" :key="task.id" class="c1-vbar-row">
            <div class="c1-vbar-lbl" style="max-width:80px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{ c1T1Truncate(task.title || '#'+task.id, 12) }}</div>
            <div class="c1-vbar-track">
              <div class="c1-vbar-fill" :style="{ width: c1TimePct(task) + '%', background: '#7C5CFC' }">
                <span class="c1-vbar-val">{{ getTaskTotalTime(task.task_time_duration) }}</span>
              </div>
            </div>
          </div>
          <div v-if="!c1TopTimeTasks.length" class="c1-chart-empty">No time data yet</div>
        </div>

            </div>
          </template>

          <!-- ── CALENDAR CONTENT ── -->
          <template v-else-if="c1PanelActiveContent === 'calendar'">
            <div class="c1-panel-hdr-bar" style="border-top:1px solid var(--c1-border)">
              <span class="c1-panel-hdr-ttl" style="flex:1">{{ c1CalMonthLabel }}</span>
              <div class="c1-cal-nav">
                <button class="c1-cal-nav-btn" @click="c1CalPrev">‹</button>
                <button class="c1-cal-nav-btn" @click="c1CalNext">›</button>
              </div>
            </div>
      <div class="c1-cal-grid-head">
        <div v-for="d in ['S','M','T','W','T','F','S']" :key="d" class="c1-cal-dh">{{ d }}</div>
      </div>
      <div class="c1-cal-grid">
        <div v-for="(day, i) in c1CalDays" :key="i"
          class="c1-cal-cell"
          :class="{
            'c1-cal-off': !day.inMonth,
            'c1-cal-today': day.isToday,
            'c1-cal-has': day.tasks && day.tasks.length
          }"
          @click="day.tasks && day.tasks.length && c1CalDayClick(day)">
          <div class="c1-cal-dn">{{ day.d }}</div>
          <div v-if="day.tasks && day.tasks.length" class="c1-cal-dots">
            <span v-for="(t, ti) in day.tasks.slice(0,3)" :key="ti"
              class="c1-cal-dot"
              :class="{
                'c1-cal-dot-red': c1IsOverdue(t),
                'c1-cal-dot-yellow': c1IsDueToday(t),
                'c1-cal-dot-green': t.is_completed || t.completed_at
              }"></span>
          </div>
        </div>
      </div>
      <div class="c1-cal-legend">
        <span class="c1-cal-dot c1-cal-dot-red"></span> Overdue
        <span class="c1-cal-dot c1-cal-dot-yellow" style="margin-left:8px"></span> Today
        <span class="c1-cal-dot c1-cal-dot-green" style="margin-left:8px"></span> Done
      </div>
      <!-- day task list -->
      <div v-if="c1CalSelected" class="c1-cal-day-tasks">
        <div class="c1-co-lbl">{{ c1CalSelected.label }}</div>
        <div v-for="t in c1CalSelected.tasks" :key="t.id" class="c1-cal-task-row" @click="c1OpenTaskDetail(t)">
          <div class="c1-cal-task-dot" :style="{ background: c1T1TypeColor(t) }"></div>
          <div class="c1-cal-task-title">{{ c1T1Truncate(t.title || t.content_title || '#'+t.id, 38) }}</div>
          <div class="c1-bs" :class="'c1-t1-bs-' + c1T1StatusKey(t)" style="font-size:9px;padding:2px 5px">{{ c1T1StatusLabel(t) }}</div>
        </div>
      </div>
          </template>


          <!-- ── GANTT CONTENT ── -->
          <template v-else-if="c1PanelActiveContent === 'gantt'">
            <div class="c1-sl-body">
              <div class="c1-co-lbl">Task Timeline <span style="font-size:10px;font-weight:400;color:var(--c1-t3)">{{ c1GanttMonthLabel }}</span></div>
              <div class="c1-gantt-nav">
                <button class="c1-cal-nav-btn" @click="c1GanttOffset--">‹</button>
                <span style="font-size:11px;color:var(--c1-t2)">{{ c1GanttMonthLabel }}</span>
                <button class="c1-cal-nav-btn" @click="c1GanttOffset++">›</button>
              </div>
              <!-- Gantt header: day numbers -->
              <div class="c1-gantt-wrap">
                <div class="c1-gantt-hdr">
                  <div class="c1-gantt-name-col"></div>
                  <div class="c1-gantt-days-col">
                    <div v-for="d in c1GanttDays" :key="d.n" class="c1-gantt-day-tick" :class="{ today: d.isToday }">{{ d.label }}</div>
                  </div>
                </div>
                <div v-for="row in c1GanttRows" :key="row.id" class="c1-gantt-row">
                  <div class="c1-gantt-name" :title="row.title">{{ row.shortTitle }}</div>
                  <div class="c1-gantt-bar-col">
                    <div class="c1-gantt-bar-track">
                      <div
                        class="c1-gantt-bar"
                        :class="{ 'c1-gantt-done': row.done, 'c1-gantt-overdue': row.overdue }"
                        :style="{ left: row.left + '%', width: row.width + '%', background: row.color }"
                        :title="row.title + ' · ' + row.dateRange"
                        @click="c1OpenTaskDetail(row.task)"
                      >
                        <span class="c1-gantt-bar-lbl">{{ row.shortTitle }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="!c1GanttRows.length" class="c1-chart-empty" style="padding:20px 14px">No tasks in this period</div>
              </div>
              <div class="c1-gantt-legend">
                <span class="c1-gantt-leg-dot" style="background:#fa8100"></span><span>Active</span>
                <span class="c1-gantt-leg-dot" style="background:#2D9D5E;margin-left:12px"></span><span>Done</span>
                <span class="c1-gantt-leg-dot" style="background:#E05A3A;margin-left:12px"></span><span>Overdue</span>
              </div>
            </div>
          </template>

          <!-- ── LOGS CONTENT ── -->
          <template v-else-if="c1PanelActiveContent === 'logs'">
            <div class="c1-sl-body">
              <div class="c1-co-lbl">Activity Log</div>
              <div v-if="c1GlobalLogs.length === 0" class="c1-chart-empty">No activity recorded yet</div>
              <div v-for="(entry, i) in c1GlobalLogs" :key="i" class="c1-log-entry">
                <div class="c1-log-icon" :class="'c1-log-' + entry.type">
                  <svg v-if="entry.type==='create'" viewBox="0 0 24 24" width="10" height="10"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                  <svg v-else-if="entry.type==='done'" viewBox="0 0 24 24" width="10" height="10"><polyline points="20 6 9 17 4 12"/></svg>
                  <svg v-else-if="entry.type==='transfer'" viewBox="0 0 24 24" width="10" height="10"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/></svg>
                  <svg v-else-if="entry.type==='reply'" viewBox="0 0 24 24" width="10" height="10"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 0 2 2z"/></svg>
                  <svg v-else viewBox="0 0 24 24" width="10" height="10"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/></svg>
                </div>
                <div class="c1-log-body">
                  <div class="c1-log-msg">{{ entry.msg }}</div>
                  <div class="c1-log-meta"><span class="c1-log-task" @click="entry.task && c1OpenTaskDetail(entry.task)">#{{ entry.taskId }}</span> · {{ entry.who }}</div>
                </div>
                <div class="c1-log-time c1-mono">{{ entry.timeAgo }}</div>
              </div>
            </div>
          </template>

          <!-- ── CHARTS BY AGENT ── -->
          <template v-else-if="c1PanelActiveContent === 'charts-agents'">
            <div class="c1-sl-body">
              <div class="c1-co-lbl">Tasks by Agent</div>
              <div v-if="!c1AgentTaskRows.length" class="c1-chart-empty">No agent data</div>
              <div v-for="row in c1AgentTaskRows" :key="row.name" class="c1-agent-bar-row">
                <div class="c1-agent-bar-name">{{ row.name }}</div>
                <div class="c1-agent-bar-track">
                  <div class="c1-agent-bar-fill" :style="{ width: row.pct + '%' }"></div>
                </div>
                <div class="c1-agent-bar-num">{{ row.count }}</div>
              </div>
              <div class="c1-co-lbl" style="margin-top:14px">Completion by Agent</div>
              <div v-for="row in c1AgentTaskRows" :key="'d-'+row.name" class="c1-agent-bar-row">
                <div class="c1-agent-bar-name">{{ row.name }}</div>
                <div class="c1-agent-bar-track">
                  <div class="c1-agent-bar-fill" :style="{ width: row.donePct + '%', background: '#2D9D5E' }"></div>
                </div>
                <div class="c1-agent-bar-num" style="color:#2D9D5E">{{ row.done }}</div>
              </div>
            </div>
          </template>

        </div><!-- /c1-panel-screen (content) -->
      </div><!-- /c1-panel-track -->
    </div><!-- /c1-panel -->

    <!-- ======== PAGINATION ======== -->
    <div class="c1-pg-bar">
      <div class="c1-pg-btn" :class="{ disabled: pagination.currentPage <= 1 }" @click="setPage(1)">
        <svg viewBox="0 0 24 24"><polyline points="11 17 6 12 11 7"/><polyline points="18 17 13 12 18 7"/></svg>
      </div>
      <div class="c1-pg-btn" :class="{ disabled: pagination.currentPage <= 1 }" @click="setPage(pagination.currentPage - 1)">
        <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
      </div>
      <div class="c1-pg-info">{{ pagination.from }}–{{ pagination.to }} of {{ pagination.total }}</div>
      <div class="c1-pg-sep"></div>
      <div class="c1-pg-info">p.{{ pagination.currentPage }}/{{ pagination.lastPage }}</div>
      <div class="c1-hp"></div>
      <div class="c1-pg-btn" :class="{ disabled: pagination.currentPage >= pagination.lastPage }" @click="setPage(pagination.currentPage + 1)">
        <svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
      </div>
      <div class="c1-pg-btn" :class="{ disabled: pagination.currentPage >= pagination.lastPage }" @click="setPage(pagination.lastPage)">
        <svg viewBox="0 0 24 24"><polyline points="13 17 18 12 13 7"/><polyline points="6 17 11 12 6 7"/></svg>
      </div>
    </div>

    <!-- ======== ANNOUNCEMENT TAB ======== -->
    <div v-if="selectedTab === 'announcements'" class="c1-announce-list">
      <div v-if="c1Announcements.length === 0" class="c1-empty">
        <div class="c1-empty-icon"><svg viewBox="0 0 24 24"><path d="M22 17H2a3 3 0 0 0 3-3V9a7 7 0 0 1 14 0v5a3 3 0 0 0 3 3z"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg></div>
        <div class="c1-empty-msg">No announcements</div>
      </div>
      <div v-for="ann in c1Announcements" :key="ann.id" class="c1-ann-card">
        <div class="c1-ann-head">
          <div class="c1-ann-badge">ANNOUNCE</div>
          <div class="c1-ann-title">{{ ann.title }}</div>
          <div class="c1-ann-date">{{ c1T1FmtDate(ann.created_at) }}</div>
        </div>
        <div v-if="ann.content" class="c1-ann-body">{{ c1T1Truncate(ann.content, 160) }}</div>
        <div class="c1-ann-stats">
          <span class="c1-ann-stat ok">
            <svg viewBox="0 0 24 24" width="10" height="10"><polyline points="20 6 9 17 4 12"/></svg>
            {{ c1AnnReplied(ann, 'understood') }} Understood
          </span>
          <span class="c1-ann-stat info">
            <svg viewBox="0 0 24 24" width="10" height="10"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/></svg>
            {{ c1AnnReplied(ann, 'more_info') }} Need Info
          </span>
          <span class="c1-ann-stat done">
            <svg viewBox="0 0 24 24" width="10" height="10"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/></svg>
            {{ c1AnnReplied(ann, 'done') }} Done
          </span>
          <span class="c1-ann-stat pending">
            <svg viewBox="0 0 24 24" width="10" height="10"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            {{ c1AnnPending(ann) }} Pending
          </span>
        </div>
        <div class="c1-ann-reply-row" v-if="!c1MyAnnReply(ann)">
          <button class="c1-ann-btn understood" @click="c1ReplyAnn(ann, 'understood')">Understood</button>
          <button class="c1-ann-btn more-info" @click="c1ReplyAnn(ann, 'more_info')">Need more info</button>
          <button class="c1-ann-btn done" @click="c1ReplyAnn(ann, 'done')">Done</button>
        </div>
        <div v-else class="c1-ann-replied">
          <svg viewBox="0 0 24 24" width="12" height="12"><polyline points="20 6 9 17 4 12"/></svg>
          You replied: <strong>{{ c1MyAnnReply(ann) }}</strong>
        </div>
        <!-- who hasn't replied -->
        <div v-if="ann.recipients && ann.recipients.length" class="c1-ann-who">
          <span class="c1-ann-who-lbl">No reply yet:</span>
          <span v-for="u in c1AnnNoReply(ann).slice(0,8)" :key="u.id" class="c1-ag-av" :title="c1T1UserName(u)" style="width:22px;height:22px;font-size:9px">{{ c1T1UserInitials(u) }}</span>
          <span v-if="c1AnnNoReply(ann).length > 8" style="font-size:10px;color:var(--c1-t3)">+{{ c1AnnNoReply(ann).length - 8 }}</span>
        </div>
      </div>
    </div>

    <!-- ======== TASK LIST ======== -->
    <div class="c1-leads" v-if="c1T1Ready && selectedTab !== 'announcements'">

      <div v-for="task in tasks" :key="task.id" class="c1-box c1-t1-box"
           :class="{ 'c1-t1-missed': task.missedScheduledCall, 'c1-t1-soon': task.scheduledCallSoon }"
           :style="c1T1PriorityBorder(task)">

        <div class="c1-box-acc" :style="{ background: c1T1TypeColor(task) }"></div>

        <!-- ROW 1: type icon · title · status · expand -->
        <div class="c1-box-r1" @click.stop="c1ToggleExpand(task.id)">
          <div class="c1-cr c1-cr-name" style="padding:0;gap:0;width:100%">
            <div class="c1-cr-ic c1-t1-type-ic" :style="{ background: c1T1TypeColor(task) }">
              {{ c1T1TypeLabel(task) }}
            </div>
            <div class="c1-cr-txt" style="flex-direction:column;align-items:flex-start;gap:2px;overflow:hidden;flex:1;min-width:0">
              <div style="display:flex;align-items:center;gap:5px;flex-wrap:nowrap;overflow:hidden;width:100%;">
                <span class="c1-nm-text c1-t1-title">{{ task.title || task.content_title || ('Task #' + task.id) }}</span>
                <span v-if="task.missedScheduledCall" class="c1-tag-missed">MISSED</span>
                <span v-if="task.scheduledCallSoon" class="c1-tag-new">SOON</span>
                <span v-if="task.priority_id === 1" class="c1-tag-hp">⚡</span>
                <span v-if="c1IsAnnouncement(task)" class="c1-tag-announce">ANN</span>
                <span v-if="task.main_task_id" class="c1-hierarchy-badge">SUB</span>
              </div>
              <div style="display:flex;align-items:center;gap:6px;flex-wrap:nowrap;">
                <span class="c1-mi c1-mono" style="font-size:9px">#{{ task.id }}</span>
                <span v-if="task.task_sub_status_type" class="c1-mi" style="font-size:9px">{{ task.task_sub_status_type.name || task.task_sub_status_type }}</span>
                <span v-if="task.kind && task.kind !== 'task'" class="c1-mi" style="font-size:9px;text-transform:capitalize">{{ task.kind }}</span>
                <span v-if="task.created_at" class="c1-mi" style="font-size:9px;color:var(--c1-t3)">{{ c1T1FmtDate(task.created_at) }}</span>
              </div>
            </div>
            <div class="c1-bs" :class="'c1-t1-bs-' + c1T1StatusKey(task)" style="flex-shrink:0">{{ c1T1StatusLabel(task) }}</div>
            <button class="c1-card-exp-btn" :class="{ on: c1T1Expanded === task.id }">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
            </button>
          </div>
        </div>

        <!-- ROW 2: assignment (creator → assignees) + due date + priority -->
        <div class="c1-cr c1-t1-assign-row" @click.stop="c1ToggleExpand(task.id)">
          <div class="c1-cr-ic" style="background:rgba(0,0,0,.04);font-size:12px;color:var(--c1-t3)">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:13px;height:13px"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
          </div>
          <div class="c1-cr-txt" style="flex-direction:row;align-items:center;gap:5px;flex-wrap:nowrap;overflow:hidden;flex:1;">
            <template v-if="task.from_user">
              <div class="c1-ag-av" :title="'From: ' + c1T1UserName(task.from_user)" style="flex-shrink:0">{{ c1T1UserInitials(task.from_user) }}</div>
              <span class="c1-t1-agent-name">{{ c1T1ShortName(task.from_user) }}</span>
            </template>
            <svg v-if="c1TaskAssignees(task).length" viewBox="0 0 24 24" style="width:10px;height:10px;flex-shrink:0;opacity:.35;color:var(--c1-t3)" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
            <template v-for="(au, ai) in c1TaskAssignees(task).slice(0, 3)">
              <div :key="'au'+ai" class="c1-ag-av c1-t1-to-av" :title="c1T1UserName(au)" style="flex-shrink:0">{{ c1T1UserInitials(au) }}</div>
            </template>
            <span v-if="c1TaskAssignees(task).length === 1" class="c1-t1-agent-name" style="color:#fa8100">{{ c1T1ShortName(c1TaskAssignees(task)[0]) }}</span>
            <span v-if="c1TaskAssignees(task).length > 3" class="c1-ag-more">+{{ c1TaskAssignees(task).length - 3 }}</span>
          </div>
          <div v-if="task.due_date" class="c1-t1-due-pill" :style="c1T1DueDateStyle(task)">
            <svg viewBox="0 0 24 24" width="9" height="9" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            {{ c1T1FmtDate(task.due_date) }}
          </div>
          <span v-if="task.priority_id" class="c1-t1-pri-badge" :class="'c1-pri-' + task.priority_id">{{ c1PriLabel(task.priority_id) }}</span>
        </div>

        <!-- ROW 3: description + tags -->
        <div v-if="task.content || (task.tags && task.tags.length)" class="c1-cr c1-t1-desc-row" @click.stop="c1ToggleExpand(task.id)">
          <div class="c1-cr-ic" style="background:rgba(0,0,0,.03)">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
          </div>
          <div class="c1-cr-txt" style="flex-direction:column;align-items:flex-start;gap:3px;overflow:hidden;">
            <div v-if="task.content" class="c1-t1-content">{{ c1T1Truncate(task.content, 90) }}</div>
            <div v-if="task.tags && task.tags.length" style="display:flex;gap:4px;flex-wrap:wrap;">
              <span v-for="tag in task.tags.slice(0, 5)" :key="tag.id||tag" class="c1-t1-tag">{{ tag.title || tag }}</span>
            </div>
          </div>
        </div>

        <!-- ROW 4: stats bar (subtasks · time · attachments · client · steps) -->
        <div class="c1-t1-stats-bar">
          <!-- Subtasks progress -->
          <div v-if="task.sub_tasks && task.sub_tasks.length" class="c1-t1-stat-chip">
            <svg viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
            <span>{{ c1SubDone(task) }}/{{ task.sub_tasks.length }}</span>
            <div class="c1-t1-subtrack"><div class="c1-t1-subfill" :style="{ width: c1SubPct(task) + '%' }"></div></div>
          </div>
          <!-- Time tracked -->
          <div v-if="task.task_time_duration" class="c1-t1-stat-chip c1-t1-stat-time">
            <svg viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            <span>{{ getTaskTotalTime(task.task_time_duration) }}</span>
          </div>
          <!-- Live timer -->
          <div v-if="c1IsTimerRunning(task)" class="c1-t1-stat-chip c1-t1-stat-live">
            <span class="c1-timer-dot"></span><span>{{ c1LiveElapsed(task) }}</span>
          </div>
          <!-- Attachments -->
          <div v-if="task.task_attachments && task.task_attachments.length" class="c1-t1-stat-chip">
            <svg viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" stroke-width="2"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
            <span>{{ task.task_attachments.length }} file{{ task.task_attachments.length !== 1 ? 's' : '' }}</span>
          </div>
          <!-- Linked client -->
          <div v-if="(task.client && (task.client.first_name || task.client.name)) || task.client_name" class="c1-t1-stat-chip c1-t1-stat-client">
            <svg viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            <span>{{ (task.client && (task.client.first_name || task.client.name)) || task.client_name }}</span>
          </div>
          <!-- Sequential steps mini-dots -->
          <div v-if="task.sequential_steps && task.sequential_steps.length" class="c1-t1-steps-mini">
            <div v-for="(step, si) in task.sequential_steps" :key="si"
              class="c1-step-dot"
              :class="{
                'c1-step-dot-done':   step.status === 'done',
                'c1-step-dot-active': step.status === 'active',
                'c1-step-dot-locked': step.status === 'locked'
              }"
              :title="step.title || ('Step ' + (si + 1))"></div>
          </div>
        </div>

        <!-- EXPANDED DETAIL (inline accordion) -->
        <transition name="c1-expand">
          <div v-if="c1T1Expanded === task.id" class="c1-t1-expand-body">

            <!-- Description -->
            <div v-if="task.content" class="c1-exp-sec">
              <div class="c1-exp-lbl">Description</div>
              <div class="c1-t1-drawer-content" v-html="task.content"></div>
            </div>

            <!-- Sub-tasks -->
            <div v-if="task.sub_tasks && task.sub_tasks.length" class="c1-exp-sec">
              <div class="c1-exp-lbl">Sub-tasks ({{ c1SubDone(task) }}/{{ task.sub_tasks.length }})</div>
              <div class="c1-subtask-progress">
                <div class="c1-subtask-bar" :style="{ width: c1SubPct(task) + '%' }"></div>
              </div>
              <div v-for="sub in task.sub_tasks" :key="sub.id" class="c1-subtask-row">
                <div class="c1-subtask-check" :class="{ done: sub.is_completed || sub.completed_at }" @click.stop="c1ToggleSubtask(task, sub)">
                  <svg v-if="sub.is_completed || sub.completed_at" viewBox="0 0 24 24" width="10" height="10"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
                <span class="c1-subtask-title" :class="{ 'c1-subtask-done-text': sub.is_completed || sub.completed_at }">{{ sub.title || sub.content }}</span>
              </div>
            </div>

            <!-- Sequential Steps detail -->
            <div v-if="task.sequential_steps && task.sequential_steps.length" class="c1-exp-sec">
              <div class="c1-exp-lbl">Sequential Steps</div>
              <div class="c1-seq-steps">
                <div v-for="(step, si) in task.sequential_steps" :key="si"
                  class="c1-seq-step"
                  :class="{
                    'c1-seq-done': step.status === 'done',
                    'c1-seq-active': step.status === 'active',
                    'c1-seq-locked': step.status === 'locked'
                  }">
                  <div class="c1-seq-num">
                    <svg v-if="step.status === 'done'" viewBox="0 0 24 24" width="12" height="12"><polyline points="20 6 9 17 4 12"/></svg>
                    <svg v-else-if="step.status === 'locked'" viewBox="0 0 24 24" width="12" height="12"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                    <span v-else>{{ si + 1 }}</span>
                  </div>
                  <div class="c1-seq-info">
                    <div class="c1-seq-title">{{ step.title || ('Step ' + (si+1)) }}</div>
                    <div class="c1-seq-status">{{ step.status }}</div>
                  </div>
                  <svg v-if="si < task.sequential_steps.length - 1" class="c1-seq-arrow" viewBox="0 0 24 24" width="14" height="14"><polyline points="9 18 15 12 9 6"/></svg>
                </div>
              </div>
            </div>

            <!-- Time tracking -->
            <div class="c1-exp-sec">
              <div class="c1-exp-lbl" style="display:flex;align-items:center;justify-content:space-between">
                <span>Time Tracking</span>
                <span style="font-size:11px;font-weight:700;color:#7C5CFC">{{ getTaskTotalTime(task.task_time_duration) }}</span>
              </div>
              <!-- Live elapsed timer display -->
              <div v-if="c1IsTimerRunning(task)" class="c1-live-timer">
                <span class="c1-live-timer-dot"></span>
                <span class="c1-live-timer-display c1-mono">{{ c1LiveElapsed(task) }}</span>
              </div>
              <div class="c1-timer-btns">
                <button class="c1-timer-start-btn" :disabled="c1IsTimerRunning(task)" @click.stop="c1StartTimer(task)">
                  <svg viewBox="0 0 24 24" width="12" height="12"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                  Start
                </button>
                <button class="c1-timer-pause-btn" :disabled="!c1IsTimerRunning(task)" @click.stop="c1PauseTimer(task)">
                  <svg viewBox="0 0 24 24" width="12" height="12"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>
                  Pause
                </button>
                <button class="c1-timer-stop-btn" :disabled="!c1IsTimerRunning(task)" @click.stop="c1StopTimer(task)">
                  <svg viewBox="0 0 24 24" width="12" height="12"><rect x="4" y="4" width="16" height="16" rx="2"/></svg>
                  Stop & Log
                </button>
              </div>
              <div v-if="task.task_time_sessions && task.task_time_sessions.length" class="c1-time-sessions">
                <div v-for="(s, si) in task.task_time_sessions.slice(0,5)" :key="si" class="c1-time-session-row">
                  <svg viewBox="0 0 24 24" width="10" height="10"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                  <span class="c1-mono">{{ c1T1FmtDate(s.started_at) }}</span>
                  <span>→</span>
                  <span class="c1-mono">{{ s.ended_at ? c1T1FmtDate(s.ended_at) : 'running' }}</span>
                  <span class="c1-time-dur">{{ s.duration_minutes ? s.duration_minutes + 'm' : '' }}</span>
                </div>
              </div>
            </div>

            <!-- Attachments -->
            <div v-if="task.task_attachments && task.task_attachments.length" class="c1-exp-sec">
              <div class="c1-exp-lbl">Attachments ({{ task.task_attachments.length }})</div>
              <div v-for="att in task.task_attachments" :key="att.id" class="c1-exp-activity-row">
                <div class="c1-exp-a-badge" style="background:#F0ECFF;color:var(--c1-dp)">
                  <svg viewBox="0 0 24 24" style="width:10px;height:10px"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
                </div>
                <div class="c1-exp-a-body"><span style="font-weight:500;font-size:11px">{{ att.file_name || att.name || 'File' }}</span></div>
                <div class="c1-exp-a-date c1-mono">{{ c1T1FmtDate(att.created_at) }}</div>
              </div>
            </div>

            <!-- History log -->
            <div v-if="task.task_logs && task.task_logs.length" class="c1-exp-sec">
              <div class="c1-exp-lbl">Activity Log ({{ task.task_logs.length }})</div>
              <div v-for="log in task.task_logs.slice(0,8)" :key="log.id" class="c1-exp-activity-row">
                <div class="c1-exp-a-badge" style="background:#F2F1F0;color:var(--c1-t3)">LOG</div>
                <div class="c1-exp-a-body"><span style="font-size:11px">{{ log.content || log.message || log.action }}</span></div>
                <div class="c1-exp-a-date c1-mono">{{ c1T1FmtDate(log.created_at) }}</div>
              </div>
            </div>

            <!-- Actions row -->
            <div class="c1-exp-sec c1-exp-actions">
              <button class="c1-action-btn c1-action-detail" @click.stop="c1OpenTaskDetail(task)">
                <svg viewBox="0 0 24 24" width="12" height="12"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                Full Detail
              </button>
              <button class="c1-action-btn c1-action-transfer" @click.stop="c1OpenTransfer(task)">
                <svg viewBox="0 0 24 24" width="12" height="12"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>
                Transfer
              </button>
              <button v-if="!(task.is_completed || task.completed_at)" class="c1-action-btn c1-action-close" @click.stop="c1CloseTask(task)">
                <svg viewBox="0 0 24 24" width="12" height="12"><polyline points="20 6 9 17 4 12"/></svg>
                Close Task
              </button>
              <button class="c1-action-btn c1-action-open" @click.stop="openTask(task)">
                Open Window
              </button>
            </div>

          </div>
        </transition>

      </div>

      <div v-if="tasks.length === 0" class="c1-empty">
        <div class="c1-empty-icon">
          <svg viewBox="0 0 24 24"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
        </div>
        <div class="c1-empty-msg">No tasks found</div>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="!c1T1Ready" class="c1-loading">
      <div class="c1-spinner"></div>
      <div style="font-size:11px;color:#A09E98;margin-top:8px">Loading...</div>
    </div>

    <!-- ======== CREATE TASK SLIDE-FROM-LEFT ======== -->
    <transition name="c1-slide-left">
      <div v-if="c1ShowCreateTask" class="c1-create-wrap" @click.self="c1ShowCreateTask = false">
        <div class="c1-create-panel">
          <div class="c1-panel-hdr-bar">
            <svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            <span class="c1-panel-hdr-ttl">{{ c1CreateForm.due_date ? 'New Meeting' : 'New Task' }}</span>
            <div class="c1-collapse-btn" @click="c1ShowCreateTask = false">
              <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </div>
          </div>
          <div class="c1-create-body">

            <!-- Title -->
            <div class="c1-create-field">
              <label class="c1-create-lbl">Title *</label>
              <input class="c1-create-input" v-model="c1CreateForm.title" placeholder="Task title…" type="text" />
            </div>

            <!-- Description -->
            <div class="c1-create-field">
              <label class="c1-create-lbl">Description</label>
              <textarea class="c1-create-textarea" v-model="c1CreateForm.content" placeholder="Describe the task…" rows="3"></textarea>
            </div>

            <!-- Assign to (multi) -->
            <div class="c1-create-field">
              <label class="c1-create-lbl" style="display:flex;align-items:center;justify-content:space-between">
                <span>Assign To</span>
                <span v-if="c1CreateForm.to_user_ids.length" style="font-size:9px;color:var(--c1-dp);font-weight:600">{{ c1CreateForm.to_user_ids.length }} selected</span>
              </label>
              <div class="c1-agent-grid" style="max-height:120px;overflow-y:auto">
                <div
                  v-for="u in (salesPersonList || [])"
                  :key="u.id"
                  class="c1-agent-chip"
                  :class="{ on: c1CreateForm.to_user_ids.includes(u.id) }"
                  @click="c1ToggleAssignee(u.id)"
                  style="padding:4px 8px"
                >
                  <div class="c1-agent-av" style="width:22px;height:22px;font-size:9px">{{ c1T1UserInitials(u) }}</div>
                  <span class="c1-agent-nm" style="font-size:10px">{{ c1T1ShortName(u) }}</span>
                </div>
              </div>
            </div>

            <!-- Priority -->
            <div class="c1-create-field">
              <label class="c1-create-lbl">Priority</label>
              <div class="c1-drawer-pri-row" style="padding:0">
                <div class="c1-drawer-pri" :class="{ on: c1CreateForm.priority_id === 1 }" style="--pc:#E05A3A" @click="c1CreateForm.priority_id = 1">
                  <svg viewBox="0 0 24 24" width="11" height="11"><polyline points="18 15 12 9 6 15"/></svg>High
                </div>
                <div class="c1-drawer-pri" :class="{ on: c1CreateForm.priority_id === 2 }" style="--pc:#E8891C" @click="c1CreateForm.priority_id = 2">
                  <svg viewBox="0 0 24 24" width="11" height="11"><line x1="5" y1="12" x2="19" y2="12"/></svg>Med
                </div>
                <div class="c1-drawer-pri" :class="{ on: c1CreateForm.priority_id === 3 }" style="--pc:#2D9D5E" @click="c1CreateForm.priority_id = 3">
                  <svg viewBox="0 0 24 24" width="11" height="11"><polyline points="6 9 12 15 18 9"/></svg>Low
                </div>
                <div class="c1-drawer-pri" :class="{ on: c1CreateForm.priority_id === 4 }" style="--pc:#7C5CFC" @click="c1CreateForm.priority_id = 4">
                  <svg viewBox="0 0 24 24" width="11" height="11"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/></svg>Crit
                </div>
              </div>
            </div>

            <!-- Due date (makes it a meeting if set) -->
            <div class="c1-create-field">
              <label class="c1-create-lbl">Due Date <span style="font-size:9px;opacity:.6">(sets as Meeting)</span></label>
              <input class="c1-create-input" v-model="c1CreateForm.due_date" type="date" />
            </div>

            <!-- Task type -->
            <div class="c1-create-field">
              <label class="c1-create-lbl">Type</label>
              <div class="c1-fs-toggle" style="margin:0">
                <div class="c1-fs-tog-btn" :class="{ on: c1CreateForm.kind === 'task' }" @click="c1CreateForm.kind = 'task'">Task</div>
                <div class="c1-fs-tog-btn" :class="{ on: c1CreateForm.kind === 'meeting' || !!c1CreateForm.due_date }" @click="c1CreateForm.kind = 'meeting'">Meeting</div>
                <div class="c1-fs-tog-btn" :class="{ on: c1CreateForm.kind === 'announcement' }" @click="c1CreateForm.kind = 'announcement'">Announce</div>
              </div>
            </div>

            <!-- Announcement recipients (if announcement) -->
            <div v-if="c1CreateForm.kind === 'announcement'" class="c1-create-field">
              <label class="c1-create-lbl">Broadcast to</label>
              <div class="c1-agent-grid" style="max-height:140px;overflow-y:auto">
                <div
                  v-for="u in (salesPersonList || [])"
                  :key="u.id"
                  class="c1-agent-chip"
                  :class="{ on: c1CreateForm.recipients && c1CreateForm.recipients.includes(u.id) }"
                  @click="c1ToggleRecipient(u.id)"
                  style="padding:4px 8px"
                >
                  <div class="c1-agent-av" style="width:22px;height:22px;font-size:9px">{{ c1T1UserInitials(u) }}</div>
                  <span class="c1-agent-nm" style="font-size:10px">{{ c1T1ShortName(u) }}</span>
                </div>
              </div>
            </div>

            <!-- Sub-tasks -->
            <div class="c1-create-field">
              <label class="c1-create-lbl" style="display:flex;align-items:center;justify-content:space-between">
                <span>Sub-tasks</span>
                <button class="c1-add-sub-btn" @click.stop="c1AddSubTask">+ Add</button>
              </label>
              <div v-for="(sub, si) in c1CreateForm.sub_tasks" :key="si" class="c1-create-sub-row">
                <div class="c1-subtask-check" :class="{ done: sub.done }" @click.stop="sub.done = !sub.done"></div>
                <input class="c1-create-sub-input" v-model="sub.title" :placeholder="'Sub-task ' + (si+1) + '…'" type="text" />
                <button class="c1-create-sub-del" @click.stop="c1CreateForm.sub_tasks.splice(si,1)">
                  <svg viewBox="0 0 24 24" width="10" height="10"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>
              </div>
            </div>

            <!-- Attach file -->
            <div class="c1-create-field">
              <label class="c1-create-lbl">Attach File</label>
              <label class="c1-attach-btn">
                <svg viewBox="0 0 24 24" width="12" height="12"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
                Attach file
                <input type="file" style="display:none" @change="c1HandleFileAttach" />
              </label>
              <div v-if="c1CreateForm.attachedFile" class="c1-attached-name">{{ c1CreateForm.attachedFile.name }}</div>
            </div>

            <div v-if="c1CreateError" class="c1-dsr-ack" style="background:#FFF2EE;color:#E05A3A;margin:0 0 8px">
              <svg viewBox="0 0 24 24" width="12" height="12"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/></svg>
              {{ c1CreateError }}
            </div>

            <button class="c1-pkf-submit" :disabled="c1CreateLoading || !c1CreateForm.title.trim()" @click="c1SubmitCreate">
              <span v-if="c1CreateLoading">Creating…</span>
              <span v-else>{{ c1CreateForm.kind === 'announcement' ? 'Broadcast Announcement' : (c1CreateForm.due_date ? 'Create Meeting' : 'Create Task') }}</span>
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- ======== TASK DETAIL DRAWER (slide from right) ======== -->
    <transition name="c1-drawer">
      <div v-if="c1DetailTask" class="c1-drawer-wrap" @click.self="c1DetailTask = null">
        <div class="c1-drawer">
          <div class="c1-drawer-head">
            <div class="c1-drawer-av" :style="{ background: c1T1TypeColor(c1DetailTask) }">
              {{ c1T1TypeLabel(c1DetailTask) }}
            </div>
            <div class="c1-drawer-title">
              <div class="c1-drawer-name">{{ c1DetailTask.title || c1DetailTask.content_title || ('Task #' + c1DetailTask.id) }}</div>
              <div class="c1-drawer-sub">#{{ c1DetailTask.id }}{{ c1DetailTask.task_sub_status_type ? ' · ' + (c1DetailTask.task_sub_status_type.name || c1DetailTask.task_sub_status_type) : '' }}</div>
            </div>
            <button class="c1-drawer-close" @click="c1DetailTask = null">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>

          <div class="c1-drawer-body">

            <!-- Task Info Grid -->
            <div class="c1-exp-sec">
              <div class="c1-exp-lbl">Task Info</div>
              <div class="c1-exp-grid">
                <div class="c1-exp-field"><div class="c1-exp-fl">ID</div><div class="c1-exp-fv c1-mono">#{{ c1DetailTask.id }}</div></div>
                <div class="c1-exp-field"><div class="c1-exp-fl">Status</div><div class="c1-exp-fv"><span class="c1-bs" :class="'c1-t1-bs-' + c1T1StatusKey(c1DetailTask)">{{ c1T1StatusLabel(c1DetailTask) }}</span></div></div>
                <div class="c1-exp-field"><div class="c1-exp-fl">Priority</div><div class="c1-exp-fv" :style="c1PriStyle(c1DetailTask.priority_id)">{{ c1PriLabel(c1DetailTask.priority_id) }}</div></div>
                <div class="c1-exp-field" v-if="c1DetailTask.from_user"><div class="c1-exp-fl">From</div><div class="c1-exp-fv">{{ c1T1UserName(c1DetailTask.from_user) }}</div></div>
                <div class="c1-exp-field" v-if="c1TaskAssignees(c1DetailTask).length">
                  <div class="c1-exp-fl">Assigned</div>
                  <div class="c1-exp-fv" style="font-weight:600;display:flex;flex-wrap:wrap;gap:4px">
                    <span v-for="(au,ai) in c1TaskAssignees(c1DetailTask)" :key="'dau'+ai" class="c1-assignee-pill">{{ c1T1UserName(au) }}</span>
                  </div>
                </div>
                <div class="c1-exp-field" v-if="c1DetailTask.main_task_id"><div class="c1-exp-fl">Parent</div><div class="c1-exp-fv c1-mono" style="color:var(--c1-dp)">Task #{{ c1DetailTask.main_task_id }}</div></div>
                <div class="c1-exp-field" v-if="c1DetailTask.sub_task_pos_id"><div class="c1-exp-fl">Position</div><div class="c1-exp-fv c1-mono">{{ c1DetailTask.main_task_id }}/{{ c1DetailTask.sub_task_pos_id }}</div></div>
                <div class="c1-exp-field" v-if="c1DetailTask.due_date"><div class="c1-exp-fl">Due</div><div class="c1-exp-fv c1-mono" :style="c1T1DueDateStyle(c1DetailTask)">{{ c1T1FmtDate(c1DetailTask.due_date) }}</div></div>
                <div class="c1-exp-field" v-if="c1DetailTask.created_at"><div class="c1-exp-fl">Created</div><div class="c1-exp-fv c1-mono">{{ c1T1FmtDate(c1DetailTask.created_at) }}</div></div>
                <div class="c1-exp-field" v-if="c1DetailTask.task_time_duration"><div class="c1-exp-fl">Time</div><div class="c1-exp-fv" style="font-weight:600;color:#7C5CFC">{{ getTaskTotalTime(c1DetailTask.task_time_duration) }}</div></div>
              </div>
            </div>

            <!-- Description -->
            <div v-if="c1DetailTask.content" class="c1-exp-sec">
              <div class="c1-exp-lbl">Description</div>
              <div class="c1-t1-drawer-content" v-html="c1DetailTask.content"></div>
            </div>

            <!-- Sub-tasks with checkboxes -->
            <div v-if="c1DetailTask.sub_tasks && c1DetailTask.sub_tasks.length" class="c1-exp-sec">
              <div class="c1-exp-lbl">Sub-tasks ({{ c1SubDone(c1DetailTask) }}/{{ c1DetailTask.sub_tasks.length }})</div>
              <div class="c1-subtask-progress"><div class="c1-subtask-bar" :style="{ width: c1SubPct(c1DetailTask) + '%' }"></div></div>
              <div v-for="sub in c1DetailTask.sub_tasks" :key="sub.id" class="c1-subtask-row">
                <div class="c1-subtask-check" :class="{ done: sub.is_completed || sub.completed_at }" @click.stop="c1ToggleSubtask(c1DetailTask, sub)">
                  <svg v-if="sub.is_completed || sub.completed_at" viewBox="0 0 24 24" width="10" height="10"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
                <span class="c1-subtask-title" :class="{ 'c1-subtask-done-text': sub.is_completed || sub.completed_at }">{{ sub.title || sub.content }}</span>
              </div>
            </div>

            <!-- Sequential Steps -->
            <div v-if="c1DetailTask.sequential_steps && c1DetailTask.sequential_steps.length" class="c1-exp-sec">
              <div class="c1-exp-lbl">Sequential Steps</div>
              <div class="c1-seq-steps">
                <div v-for="(step, si) in c1DetailTask.sequential_steps" :key="si"
                  class="c1-seq-step"
                  :class="{ 'c1-seq-done': step.status==='done', 'c1-seq-active': step.status==='active', 'c1-seq-locked': step.status==='locked' }">
                  <div class="c1-seq-num">
                    <svg v-if="step.status==='done'" viewBox="0 0 24 24" width="12" height="12"><polyline points="20 6 9 17 4 12"/></svg>
                    <svg v-else-if="step.status==='locked'" viewBox="0 0 24 24" width="12" height="12"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                    <span v-else>{{ si+1 }}</span>
                  </div>
                  <div class="c1-seq-info">
                    <div class="c1-seq-title">{{ step.title || ('Step '+(si+1)) }}</div>
                    <div class="c1-seq-status">{{ step.status }}</div>
                  </div>
                  <svg v-if="si < c1DetailTask.sequential_steps.length-1" class="c1-seq-arrow" viewBox="0 0 24 24" width="14" height="14"><polyline points="9 18 15 12 9 6"/></svg>
                </div>
              </div>
            </div>

            <!-- Time tracking -->
            <div class="c1-exp-sec">
              <div class="c1-exp-lbl" style="display:flex;align-items:center;justify-content:space-between">
                <span>Time Tracking</span>
                <span style="font-size:11px;font-weight:700;color:#7C5CFC">{{ getTaskTotalTime(c1DetailTask.task_time_duration) }}</span>
              </div>
              <!-- Live elapsed timer display -->
              <div v-if="c1IsTimerRunning(c1DetailTask)" class="c1-live-timer">
                <span class="c1-live-timer-dot"></span>
                <span class="c1-live-timer-display c1-mono">{{ c1LiveElapsed(c1DetailTask) }}</span>
              </div>
              <div class="c1-timer-btns">
                <button class="c1-timer-start-btn" :disabled="c1IsTimerRunning(c1DetailTask)" @click.stop="c1StartTimer(c1DetailTask)">
                  <svg viewBox="0 0 24 24" width="12" height="12"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                  Start Timer
                </button>
                <button class="c1-timer-pause-btn" :disabled="!c1IsTimerRunning(c1DetailTask)" @click.stop="c1PauseTimer(c1DetailTask)">
                  <svg viewBox="0 0 24 24" width="12" height="12"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>
                  Pause
                </button>
                <button class="c1-timer-stop-btn" :disabled="!c1IsTimerRunning(c1DetailTask)" @click.stop="c1StopTimer(c1DetailTask)">
                  <svg viewBox="0 0 24 24" width="12" height="12"><rect x="4" y="4" width="16" height="16" rx="2"/></svg>
                  Stop & Log
                </button>
              </div>
              <div v-if="c1DetailTask.task_time_sessions && c1DetailTask.task_time_sessions.length" class="c1-time-sessions">
                <div v-for="(s, si) in c1DetailTask.task_time_sessions.slice(0,8)" :key="si" class="c1-time-session-row">
                  <svg viewBox="0 0 24 24" width="10" height="10"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                  <span class="c1-mono">{{ c1T1FmtDate(s.started_at) }}</span>
                  <span>→</span>
                  <span class="c1-mono">{{ s.ended_at ? c1T1FmtDate(s.ended_at) : 'running' }}</span>
                  <span class="c1-time-dur">{{ s.duration_minutes ? s.duration_minutes + 'm' : '' }}</span>
                </div>
              </div>
            </div>

            <!-- Priority selector -->
            <div class="c1-exp-sec">
              <div class="c1-exp-lbl">Priority</div>
              <div class="c1-drawer-pri-row">
                <div class="c1-drawer-pri" :class="{ on: c1DetailPriority === 1 }" style="--pc:#E05A3A" @click="c1DetailPriority = 1">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="12" height="12"><polyline points="18 15 12 9 6 15"/></svg>High
                </div>
                <div class="c1-drawer-pri" :class="{ on: c1DetailPriority === 2 }" style="--pc:#E8891C" @click="c1DetailPriority = 2">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="12" height="12"><line x1="5" y1="12" x2="19" y2="12"/></svg>Med
                </div>
                <div class="c1-drawer-pri" :class="{ on: c1DetailPriority === 3 }" style="--pc:#2D9D5E" @click="c1DetailPriority = 3">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="12" height="12"><polyline points="6 9 12 15 18 9"/></svg>Low
                </div>
                <div class="c1-drawer-pri" :class="{ on: c1DetailPriority === 4 }" style="--pc:#7C5CFC" @click="c1DetailPriority = 4">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="12" height="12"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/></svg>Crit
                </div>
              </div>
            </div>

            <!-- Status change -->
            <div class="c1-exp-sec">
              <div class="c1-exp-lbl">Change Status</div>
              <div class="c1-drawer-status-row">
                <button class="c1-dsr-btn act" @click="c1DetailUpdateStatus('active')">Active</button>
                <button class="c1-dsr-btn wait" @click="c1DetailUpdateStatus('waiting')">Waiting</button>
                <button class="c1-dsr-btn outline" @click="c1DetailUpdateStatus('outline')">Outline</button>
                <button class="c1-dsr-btn done" @click="c1DetailUpdateStatus('done')">Mark Done</button>
              </div>
              <div v-if="c1DetailStatusAck" class="c1-dsr-ack">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="12" height="12"><polyline points="20 6 9 17 4 12"/></svg>
                Status updated to <strong>{{ c1DetailStatusAck }}</strong>
              </div>
            </div>

            <!-- Transfer -->
            <div class="c1-exp-sec">
              <div class="c1-exp-lbl">Transfer to</div>
              <div class="c1-transfer-row">
                <select class="c1-create-select" v-model="c1TransferUserId" style="flex:1">
                  <option value="">— Select agent —</option>
                  <option v-for="u in (salesPersonList || [])" :key="u.id" :value="u.id">{{ u.full_name || u.first_name + ' ' + u.last_name }}</option>
                </select>
                <button class="c1-dsr-btn act" style="flex-shrink:0" :disabled="!c1TransferUserId" @click="c1DoTransfer">Transfer</button>
              </div>
              <div v-if="c1TransferAck" class="c1-dsr-ack">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="12" height="12"><polyline points="20 6 9 17 4 12"/></svg>
                {{ c1TransferAck }}
              </div>
            </div>

            <!-- Close task (only opener) -->
            <div class="c1-exp-sec" v-if="!(c1DetailTask.is_completed || c1DetailTask.completed_at) && c1IsTaskOpener(c1DetailTask)">
              <button class="c1-drawer-complete-btn" @click="c1CloseTask(c1DetailTask)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="14" height="14"><polyline points="20 6 9 17 4 12"/></svg>
                Close Task
              </button>
            </div>

            <!-- Attachments -->
            <div v-if="c1DetailTask.task_attachments && c1DetailTask.task_attachments.length" class="c1-exp-sec">
              <div class="c1-exp-lbl">Attachments</div>
              <div v-for="att in c1DetailTask.task_attachments" :key="att.id" class="c1-exp-activity-row">
                <div class="c1-exp-a-badge" style="background:#F0ECFF;color:var(--c1-dp)">
                  <svg viewBox="0 0 24 24" style="width:10px;height:10px"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
                </div>
                <div class="c1-exp-a-body"><span style="font-weight:500;font-size:11px">{{ att.file_name || att.name || 'File' }}</span></div>
                <div class="c1-exp-a-date c1-mono">{{ c1T1FmtDate(att.created_at) }}</div>
              </div>
            </div>

            <!-- History log -->
            <div v-if="c1DetailTask.task_logs && c1DetailTask.task_logs.length" class="c1-exp-sec">
              <div class="c1-exp-lbl">History Log ({{ c1DetailTask.task_logs.length }})</div>
              <div v-for="log in c1DetailTask.task_logs.slice(0,15)" :key="log.id" class="c1-exp-activity-row">
                <div class="c1-exp-a-badge" style="background:#F2F1F0;color:var(--c1-t3)">LOG</div>
                <div class="c1-exp-a-body"><span style="font-size:11px">{{ log.content || log.message || log.action }}</span></div>
                <div class="c1-exp-a-date c1-mono">{{ c1T1FmtDate(log.created_at) }}</div>
              </div>
            </div>

            <!-- Replies thread from task_reply_log -->
            <div class="c1-exp-sec" v-if="c1DetailTask.task_reply_logs && c1DetailTask.task_reply_logs.length">
              <div class="c1-exp-lbl">Replies ({{ c1DetailTask.task_reply_logs.length }})</div>
              <div class="c1-replies-thread">
                <div v-for="reply in c1DetailTask.task_reply_logs" :key="reply.id" class="c1-reply-row" :class="{ 'c1-reply-mine': c1IsMine(reply) }">
                  <div class="c1-reply-av" :title="c1ReplyUserName(reply)">{{ c1ReplyUserInitials(reply) }}</div>
                  <div class="c1-reply-bubble">
                    <div class="c1-reply-name">{{ c1ReplyUserName(reply) }}</div>
                    <div class="c1-reply-text">{{ reply.content || reply.reply || reply.message }}</div>
                    <div class="c1-reply-time c1-mono">{{ c1T1FmtDate(reply.created_at) }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Comment -->
            <div class="c1-exp-sec" style="padding-bottom:4px">
              <div class="c1-exp-lbl">Add Comment</div>
              <div class="c1-drawer-comment-wrap">
                <textarea class="c1-drawer-comment" v-model="c1DetailComment" placeholder="Write a comment…" rows="3"></textarea>
                <button class="c1-drawer-comment-send" :disabled="!c1DetailComment.trim()" @click="c1SendDetailComment">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="12" height="12"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                  Send
                </button>
              </div>
              <div v-if="c1DetailCommentSent" class="c1-dsr-ack">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="12" height="12"><polyline points="20 6 9 17 4 12"/></svg>
                Comment logged
              </div>
            </div>

            <div class="c1-exp-sec" style="padding-bottom:20px">
              <button class="c1-pkf-submit" style="margin:0 14px;width:calc(100% - 28px)" @click="openTask(c1DetailTask)">
                Open Full Task Window
              </button>
            </div>

          </div>
        </div>
      </div>
    </transition>

    <!-- Transfer modal -->
    <transition name="t1-toast-fade">
      <div v-if="c1TransferModal" class="c1-modal-wrap" @click.self="c1TransferModal = null">
        <div class="c1-modal">
          <div class="c1-modal-ttl">Transfer Task #{{ c1TransferModal.id }}</div>
          <div class="c1-create-field">
            <label class="c1-create-lbl">Transfer to</label>
            <select class="c1-create-select" v-model="c1TransferUserId">
              <option value="">— Select agent —</option>
              <option v-for="u in (salesPersonList || [])" :key="u.id" :value="u.id">{{ u.full_name || u.first_name + ' ' + u.last_name }}</option>
            </select>
          </div>
          <div class="c1-modal-actions">
            <button class="c1-dsr-btn outline" @click="c1TransferModal = null">Cancel</button>
            <button class="c1-pkf-submit" style="margin:0;padding:8px 20px" :disabled="!c1TransferUserId" @click="c1DoTransferModal">Transfer</button>
          </div>
        </div>
      </div>
    </transition>

    <!-- MainTaskWindow -->
    <transition name="fade">
      <MainTaskWindow
        :key="closeRec"
        @close="countClose()"
        v-if="showMainTaskWindow && !c1ShowCreateTask"
        @changeToWaitingTabAfterCreatingATask="changeToWaitingTabAfterCreatingATask"
        :preOpenMainTaskWindowFromHeader="preOpenMainTaskWindowFromHeader"
        v-click-outside="closeMainTaskWindow"
        v-on:fetchTasks="fetchTasks"
        v-on:closeMainTaskWindow="closeMainTaskWindow"
        :selectedTaskTab="selectedTab"
        @updated="fetchTasks"
        mode="reply"
      />
    </transition>

    <!-- C1 Calendar component (legacy) -->
    <transition name="fade">
      <C1TaskCalendar
        v-if="c1ShowCalendarComponent"
        :tasks="tasks"
        :taskDictionaries="taskDictionaries"
        @openTask="openTask"
        @close="c1ShowCalendarComponent = false"
      />
    </transition>

    <!-- C1 New Task Sheet (legacy) -->
    <transition name="fade">
      <C1NewTaskSheet
        v-if="c1ShowNewTaskSheet"
        :taskDictionaries="taskDictionaries"
        :salesPersonList="salesPersonList"
        :todayTasks="c1TodayTasks"
        :categories="c1Categories"
        @fetchTasks="fetchTasks"
        @close="c1ShowNewTaskSheet = false"
      />
    </transition>

  </div>
</template>

<script>
import TasksTableContainer from "../../../features/tasks.feature/containers/TasksTable.container";
import MainTaskWindow from "../../tasks.feature/components/MainTaskWindow.component";
import C1NewTaskSheet from "../components/C1NewTaskSheet.component";
import C1TaskCalendar from "../components/C1TaskCalendar.component";
import VikiFace from "../../clients1.feature/VikiFace.vue";
import C1TaskSmartCalendar from "../C1TaskSmartCalendar.vue";
import moment from "moment/moment";
import vClickOutside from "v-click-outside";
import axios from "axios";

const API = "/api";
const TYPE_COLORS = ["#fa8100","#7C5CFC","#C75450","#2D9D5E","#1144bc","#D4A017","#E05A3A","#00796b","#827717","#4275ec"];

function authHeader() {
  return { Authorization: "Bearer " + (localStorage.getItem("user-token") || localStorage.getItem("token")) };
}

export default {
  name: "Tasks1Container",
  extends: TasksTableContainer,
  components: { MainTaskWindow, C1NewTaskSheet, C1TaskCalendar, VikiFace, C1TaskSmartCalendar },
  directives: { clickOutside: vClickOutside.directive },

  beforeDestroy() {
    clearInterval(this._c1StatusInterval);
    if (this._c1StatusInterval) clearInterval(this._c1StatusInterval);
  },

  mounted() {
    // Shift tracking
    const savedStatus = localStorage.getItem('c1_status');
    const savedSince  = localStorage.getItem('c1_status_since');
    const today = new Date().toISOString().slice(0, 10);
    const savedShiftDay = localStorage.getItem('c1_shift_day');
    if (savedShiftDay !== today) {
      if (!this.c1Status) this.c1Status = 'shift';
      this.c1ShiftStartTime = Date.now();
      this.c1BathroomCount = 0;
      this.c1CoffeeCount = 0;
      localStorage.setItem('c1_status', 'shift');
      localStorage.setItem('c1_status_since', String(Date.now()));
      localStorage.setItem('c1_shift_start', String(Date.now()));
      localStorage.setItem('c1_shift_day', today);
      localStorage.setItem('c1_bathroom_count', '0');
      localStorage.setItem('c1_coffee_count', '0');
    } else {
      if (savedStatus && !this.c1Status) this.c1Status = savedStatus;
      this.c1ShiftStartTime = parseInt(localStorage.getItem('c1_shift_start') || String(Date.now()), 10);
      this.c1BathroomCount = parseInt(localStorage.getItem('c1_bathroom_count') || '0', 10);
      this.c1CoffeeCount   = parseInt(localStorage.getItem('c1_coffee_count') || '0', 10);
    }
    this.c1StatusSince = savedSince ? parseInt(savedSince, 10) : Date.now();
    this._c1StatusInterval = setInterval(this.c1TickStatus, 1000);
    document.documentElement.style.setProperty('--gnm-sw', '0px');
  },

  beforeMount() {
    this.$store.dispatch("clients/getGeneralDictionary").then(() => {
      this.$store.dispatch("tasks/getTaskDictionary").then(() => {
        this.$store.dispatch("clients/getSalesPersonList").then(() => {
          this.$store.dispatch("tasks/getCategories").then(() => {
            this.c1T1Ready = true;
          });
        });
      });
    });
  },

  created() {
    const _keepNav = sessionStorage.getItem('c1keepNav'); if (_keepNav) sessionStorage.removeItem('c1keepNav');
    const _openPanel = sessionStorage.getItem('c1openPanel'); if (_openPanel) sessionStorage.removeItem('c1openPanel');
    if (_openPanel) { this.c1SlideOpen = 'filters'; }
    else if (_keepNav) { this.c1SlideOpen = 'nav'; this.c1NavMode = 'panels'; }
    const tick = () => {
      const d = new Date();
      this.c1TimeStr = [d.getHours(), d.getMinutes(), d.getSeconds()].map(n => String(n).padStart(2,"0")).join(":");
    };
    tick();
    setInterval(tick, 1000);
    this.c1BuildVikiMessages();
  },

  data() {
    return {
      c1Status: 'available',
      c1StatusSince: 0,
      c1StatusElapsed: '00:00',
      c1StatusMenuOpen: false,
      _c1StatusInterval: null,
      c1HamMenuOpen: false,
      c1ShiftMenuOpen: false,
      c1ShiftElapsed: '00:00',
      c1ShiftStartTime: 0,
      c1BathroomCount: 0,
      c1CoffeeCount: 0,
      c1WeekLog: [],
      // ui state
      c1TopTab: null,
      c1SlideOpen: null,
      c1VikiOpen: false,
      c1PanelActiveContent: null,
      c1NavMode: 'panels',
      c1FilterTab: "status",
      c1DateFilter: "ALL",
      c1T1Ready: false,
      c1TimeStr: "",
      c1Toast: null,
      c1TaskKind: null,

      // task list expand
      c1T1Expanded: null,

      // detail drawer
      c1DetailTask: null,
      c1DetailPriority: null,
      c1DetailComment: "",
      c1DetailCommentSent: false,
      c1DetailStatusAck: null,
      c1TransferUserId: "",
      c1TransferAck: null,
      c1TransferModal: null,

      // create panel
      c1ShowCreateTask: false,
      c1CreateLoading: false,
      c1CreateError: null,
      c1CreateForm: {
        title: "",
        content: "",
        to_user_id: "",
        to_user_ids: [],
        priority_id: null,
        due_date: "",
        kind: "task",
        sub_tasks: [],
        recipients: [],
        attachedFile: null,
      },

      // calendar
      c1CalYear: new Date().getFullYear(),
      c1CalMonth: new Date().getMonth(),
      c1CalSelected: null,
      c1ShowCalendarComponent: false,
      c1WeekOffset: 0,

      // legacy
      c1ShowNewTaskSheet: false,

      // announcements
      c1Announcements: [],
      c1MyReplies: {},

      // viki
      c1VikiMessages: [],
      c1VikiUnread: false,
      c1VikiMood: 'neutral',
      c1VikiSpeaking: false,

      // running timers (task id → true) — plain object for Vue 2 reactivity
      c1RunningTimers: {},
      c1TimerStartedAt: {},

      // gantt
      c1GanttOffset: 0,

      // ---- FEATURE: Team Filter ----
      t1TeamFilter: null,   // null=all, 1=Team1, 2=Team2
    };
  },

  computed: {
    c1UserInitials() {
      const u = this.auth && this.auth.user;
      if (!u) return "?";
      return ((u.first_name || "")[0] || "").toUpperCase() + ((u.last_name || "")[0] || "").toUpperCase();
    },
    c1RoleLabel() {
      const map = { 1:"Admin", 2:"Team Leader", 3:"Manager", 4:"Senior Agent", 5:"Agent", 6:"Junior Agent", 7:"New Agent", 8:"Support", 9:"Retention", 10:"Finance", 12:"Super Admin" };
      return map[(this.auth && this.auth.user && this.auth.user.role)] || "User";
    },
    c1CurrentPageLabel() {
      const map = {
        '/clients1':'Clients', '/tasks1':'Tasks', '/stats1':'Statistics',
        '/chat1':'Chat', '/communications1':'Communications', '/affiliation1':'Affiliation',
        '/finance1':'Finance', '/shifts1':'Shifts', '/games1':'Games',
        '/users1':'Users', '/brokers1':'Brokers', '/security1':'Security',
        '/quiz1':'Quiz', '/instruction1':'Instructions', '/settings1':'Settings', '/profile1':'My Profile',
      };
      return map[this.$route.path] || 'Menu';
    },
    c1UserFullName() {
      const u = this.auth && this.auth.user;
      if (!u) return "User";
      return ((u.first_name || "") + " " + (u.last_name || "")).trim() || "User";
    },
    c1TzUK() { return this.c1TzTime("Europe/London"); },
    c1TzIL() { return this.c1TzTime("Asia/Jerusalem"); },
    c1TzCB() { return this.c1TzTime("America/Cayman"); },
    c1ActiveFilterCount() {
      let n = 0;
      if (this.filters.task_users && this.filters.task_users.length) n += this.filters.task_users.length;
      if (this.filters.task_types && this.filters.task_types.length) n += this.filters.task_types.length;
      if (this.filters.priority_id) n++;
      if (this.filters.missed_tasks) n++;
      if (this.filters.coming_tasks) n++;
      if (this.filters.today_tasks) n++;
      if (this.wordFilter) n++;
      if (this.c1DateFilter !== "ALL") n++;
      if (this.t1TeamFilter !== null) n++;
      return n;
    },

    c1PanelIsOpen() {
      return !!this.c1SlideOpen && this.c1SlideOpen !== 'menu';
    },
    c1PanelAtContent() {
      return this.c1PanelIsOpen && this.c1SlideOpen !== 'nav';
    },
    c1ActivePanelLabel() {
      if (!this.c1PanelIsOpen || this.c1SlideOpen === 'nav') return 'Panels';
      if (this.c1PanelActiveContent === 'filters') {
        const m = { status: 'Status', agents: 'Agents', priority: 'Priority', date: 'Date', type: 'Type', sort: 'Sort' };
        return m[this.c1FilterTab] || 'Filter';
      }
      if (this.c1PanelActiveContent === 'charts') return 'Charts';
      if (this.c1PanelActiveContent === 'calendar') return 'Calendar';
      if (this.c1PanelActiveContent === 'gantt') return 'Gantt';
      if (this.c1PanelActiveContent === 'logs') return 'Activity Log';
      if (this.c1PanelActiveContent === 'charts-agents') return 'By Agent';
      return 'Panels';
    },

    c1CurrentTabKey() {
      if (this.filters.missed_tasks) return 'missed';
      if (this.filters.coming_tasks) return 'coming';
      if (this.filters.today_tasks) return 'today';
      return this.selectedTab || 'active';
    },
    c1CurrentTabLabel() {
      const m = { active:'Production', waiting:'Waiting', completed:'Done', outline:'Outline', announcements:'Announcements', events:'Events', missed:'Missed', coming:'Coming', today:'Today' };
      return m[this.c1CurrentTabKey] || 'Tasks';
    },
    c1CurrentTabCount() {
      const k = this.c1CurrentTabKey;
      if (k === 'active') return this.activeTasksCounter || 0;
      if (k === 'waiting') return this.stats.waiting_group || 0;
      if (k === 'completed') return this.stats.completed_group || 0;
      if (k === 'outline') return this.stats.outline_group || 0;
      if (k === 'announcements') return this.c1AnnouncementCount || 0;
      if (k === 'events') return this.stats.events_group || 0;
      if (k === 'missed') return this.stats.tasks_missed || 0;
      if (k === 'coming') return this.stats.tasks_coming || 0;
      return 0;
    },

    c1T1TotalTasks() {
      return (this.activeTasksCounter || 0) + (this.stats.waiting_group || 0) + (this.stats.completed_group || 0) + (this.stats.outline_group || 0);
    },

    c1T1CompletionRate() {
      const total = this.c1T1TotalTasks || 1;
      return Math.round((this.stats.completed_group || 0) / total * 100);
    },

    c1T1SevenDays() {
      const allTasks = this.tasks || [];
      const days = [];
      for (let i = 6; i >= 0; i--) {
        const d = moment().subtract(i, "days");
        const dateStr = d.format("YYYY-MM-DD");
        const due = allTasks.filter(t => t.due_date && moment(t.due_date).format("YYYY-MM-DD") === dateStr).length;
        const done = allTasks.filter(t => (t.is_completed || t.completed_at) && moment(t.completed_at || t.updated_at).format("YYYY-MM-DD") === dateStr).length;
        days.push({ label: d.format("dd")[0], date: dateStr, due, done });
      }
      return days;
    },

    c1OverdueTasks() {
      const now = moment();
      return (this.tasks || []).filter(t => t.due_date && !t.is_completed && !t.completed_at && moment(t.due_date).isBefore(now, "day"))
        .sort((a, b) => moment(a.due_date).diff(moment(b.due_date)));
    },

    c1TopTimeTasks() {
      return (this.tasks || [])
        .filter(t => t.task_time_duration)
        .sort((a, b) => (b.task_time_duration || 0) - (a.task_time_duration || 0))
        .slice(0, 6);
    },

    c1AnnouncementCount() {
      return this.c1Announcements.length;
    },

    c1TodayTasks() {
      const today = moment().format("YYYY-MM-DD");
      return (this.tasks || []).filter(t => {
        const f = t.start_time || t.start_date || t.created_at;
        return f && moment(f).format("YYYY-MM-DD") === today;
      });
    },

    c1Categories() {
      return this.$store.state.tasks.categories || [];
    },

    // Calendar computed
    c1CalMonthLabel() {
      return moment().year(this.c1CalYear).month(this.c1CalMonth).format("MMMM YYYY");
    },

    c1CalDays() {
      const year = this.c1CalYear;
      const month = this.c1CalMonth;
      const firstDay = new Date(year, month, 1).getDay();
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      const daysInPrev = new Date(year, month, 0).getDate();
      const today = moment().format("YYYY-MM-DD");
      const allTasks = this.tasks || [];
      const days = [];

      // prev month padding
      for (let i = firstDay - 1; i >= 0; i--) {
        const d = daysInPrev - i;
        const dateStr = moment(new Date(year, month - 1, d)).format("YYYY-MM-DD");
        days.push({ d, inMonth: false, isToday: false, dateStr, tasks: [] });
      }
      // current month
      for (let d = 1; d <= daysInMonth; d++) {
        const dateStr = moment(new Date(year, month, d)).format("YYYY-MM-DD");
        const dayTasks = allTasks.filter(t => {
          const due = t.due_date && moment(t.due_date).format("YYYY-MM-DD") === dateStr;
          const start = t.start_date && moment(t.start_date).format("YYYY-MM-DD") === dateStr;
          return due || start;
        });
        days.push({ d, inMonth: true, isToday: dateStr === today, dateStr, tasks: dayTasks });
      }
      // next month padding to fill 6 rows
      const remaining = 42 - days.length;
      for (let d = 1; d <= remaining; d++) {
        const dateStr = moment(new Date(year, month + 1, d)).format("YYYY-MM-DD");
        days.push({ d, inMonth: false, isToday: false, dateStr, tasks: [] });
      }
      return days;
    },

    // Gantt
    c1GanttMonthLabel() {
      return moment().add(this.c1GanttOffset, 'months').format('MMMM YYYY');
    },
    c1GanttDays() {
      const m = moment().add(this.c1GanttOffset, 'months');
      const days = m.daysInMonth();
      const today = moment().format('YYYY-MM-DD');
      return Array.from({ length: days }, (_, i) => {
        const d = i + 1;
        const dateStr = m.clone().date(d).format('YYYY-MM-DD');
        return { n: d, label: d % 5 === 1 ? String(d) : '', isToday: dateStr === today };
      });
    },
    c1GanttRows() {
      const m = moment().add(this.c1GanttOffset, 'months');
      const monthStart = m.clone().startOf('month');
      const monthEnd = m.clone().endOf('month');
      const daysInMonth = m.daysInMonth();
      const now = moment();
      const tasks = (this.tasks || []).filter(t => {
        const anchor = t.due_date || t.start_date || t.created_at;
        if (!anchor) return false;
        const due = t.due_date && moment(t.due_date).isBetween(monthStart, monthEnd, 'day', '[]');
        const start = t.start_date && moment(t.start_date).isBetween(monthStart, monthEnd, 'day', '[]');
        const span = t.start_date && t.due_date && moment(t.start_date).isBefore(monthEnd) && moment(t.due_date).isAfter(monthStart);
        const created = !t.due_date && !t.start_date && t.created_at && moment(t.created_at).isBetween(monthStart, monthEnd, 'day', '[]');
        return due || start || span || created;
      }).slice(0, 25);
      return tasks.map(t => {
        const startD = t.start_date ? moment(t.start_date) : (t.created_at ? moment(t.created_at) : monthStart.clone());
        const endD = t.due_date ? moment(t.due_date) : startD.clone().add(3, 'days');
        const clampedStart = moment.max(startD, monthStart);
        const clampedEnd = moment.min(endD, monthEnd);
        const leftDays = clampedStart.diff(monthStart, 'days');
        const widthDays = Math.max(1, clampedEnd.diff(clampedStart, 'days') + 1);
        const left = Math.round(leftDays / daysInMonth * 100);
        const width = Math.round(widthDays / daysInMonth * 100);
        const done = !!(t.is_completed || t.completed_at);
        const overdue = !done && t.due_date && moment(t.due_date).isBefore(now, 'day');
        const title = t.title || t.content_title || ('#' + t.id);
        return {
          id: t.id,
          task: t,
          title,
          shortTitle: title.length > 16 ? title.substring(0, 14) + '…' : title,
          dateRange: (t.start_date ? moment(t.start_date).format('D MMM') : '') + (t.due_date ? ' → ' + moment(t.due_date).format('D MMM') : ''),
          left, width, done, overdue,
          color: done ? '#2D9D5E' : overdue ? '#E05A3A' : '#7C5CFC'
        };
      });
    },
    // Global logs (aggregated from all task logs)
    c1GlobalLogs() {
      const allTasks = this.tasks || [];
      const entries = [];
      allTasks.forEach(t => {
        const title = t.title || t.content_title || ('#' + t.id);
        // creation
        entries.push({
          type: 'create', taskId: t.id, task: t,
          msg: 'Task created: ' + title,
          who: t.from_user ? this.c1T1UserName(t.from_user) : 'System',
          ts: t.created_at, timeAgo: this.c1TimeAgo(t.created_at)
        });
        // completion
        if (t.is_completed || t.completed_at) {
          entries.push({
            type: 'done', taskId: t.id, task: t,
            msg: 'Completed: ' + title,
            who: t.to_user ? this.c1T1UserName(t.to_user) : '—',
            ts: t.completed_at || t.updated_at, timeAgo: this.c1TimeAgo(t.completed_at || t.updated_at)
          });
        }
        // task logs
        (t.task_logs || []).slice(0, 3).forEach(log => {
          entries.push({
            type: 'log', taskId: t.id, task: t,
            msg: log.content || log.message || log.action || 'Log entry',
            who: '—',
            ts: log.created_at, timeAgo: this.c1TimeAgo(log.created_at)
          });
        });
        // replies
        (t.task_reply_logs || []).slice(0, 2).forEach(r => {
          entries.push({
            type: 'reply', taskId: t.id, task: t,
            msg: 'Reply: ' + (r.content || r.reply || '').substring(0, 60),
            who: this.c1ReplyUserName(r),
            ts: r.created_at, timeAgo: this.c1TimeAgo(r.created_at)
          });
        });
      });
      return entries.filter(e => e.ts).sort((a, b) => new Date(b.ts) - new Date(a.ts)).slice(0, 60);
    },
    // Agent task distribution
    t1TeamTaskCount() {
      return (teamId) => {
        const allTasks = this.tasks || [];
        return allTasks.filter(t => this.t1TaskTeamId(t) === teamId).length;
      };
    },

    c1AgentTaskRows() {
      const allTasks = this.tasks || [];
      const map = {};
      allTasks.forEach(t => {
        if (!t.to_user) return;
        const name = this.c1T1ShortName(t.to_user);
        if (!map[name]) map[name] = { name, count: 0, done: 0 };
        map[name].count++;
        if (t.is_completed || t.completed_at) map[name].done++;
      });
      const rows = Object.values(map).sort((a, b) => b.count - a.count).slice(0, 12);
      const maxCount = rows.length ? Math.max(...rows.map(r => r.count)) : 1;
      return rows.map(r => ({
        ...r,
        pct: Math.round(r.count / maxCount * 100),
        donePct: r.count ? Math.round(r.done / r.count * 100) : 0
      }));
    },

    // Week calendar
    c1WeekCalLabel() {
      const ws = moment().add(this.c1WeekOffset, 'weeks').startOf('isoWeek');
      return ws.format('DD MMM') + ' – ' + ws.clone().endOf('isoWeek').format('DD MMM YYYY');
    },
    c1WeekViewDays() {
      const ws = moment().add(this.c1WeekOffset, 'weeks').startOf('isoWeek');
      const today = moment().format('YYYY-MM-DD');
      const now = moment();
      const allTasks = this.tasks || [];
      return Array.from({ length: 7 }, (_, i) => {
        const d = ws.clone().add(i, 'days');
        const date = d.format('YYYY-MM-DD');
        const active = allTasks.filter(t => {
          const due = t.due_date && moment(t.due_date).format('YYYY-MM-DD') === date;
          const start = t.start_date && moment(t.start_date).format('YYYY-MM-DD') === date;
          return (due || start) && !t.is_completed && !t.completed_at;
        }).length;
        const done = allTasks.filter(t => (t.is_completed || t.completed_at) && moment(t.completed_at || t.updated_at).format('YYYY-MM-DD') === date).length;
        const missed = allTasks.filter(t => t.due_date && !t.is_completed && !t.completed_at && moment(t.due_date).format('YYYY-MM-DD') === date && moment(t.due_date).isBefore(now, 'day')).length;
        return { date, dow: d.format('ddd').toUpperCase(), dd: d.format('D'), isToday: date === today, active, done, missed, total: active + done + missed };
      });
    },
    c1WeekBarMaxTotal() {
      return Math.max(1, ...this.c1WeekViewDays.map(d => d.active + d.done + d.missed));
    },
    c1WeekBarH() {
      return (count) => {
        if (!count) return 0;
        return Math.max(8, Math.round((count / this.c1WeekBarMaxTotal) * 48));
      };
    },
  },

  watch: {
    c1SlideOpen(val) {
      if (val && val !== 'nav' && val !== 'menu') {
        this.c1PanelActiveContent = val;
      }
    },
    c1T1Expanded(newId) {
      this.c1DetailComment = "";
      this.c1DetailCommentSent = false;
    },
    c1DetailTask(task) {
      this.c1DetailComment = "";
      this.c1DetailCommentSent = false;
      this.c1DetailStatusAck = null;
      this.c1TransferUserId = "";
      this.c1TransferAck = null;
      if (task) {
        this.c1DetailPriority = task.priority_id || null;
      }
    },
    selectedTab(tab) {
      if (tab === "announcements") {
        this.c1LoadAnnouncements();
      }
    },
    tasks() {
      this.c1BuildVikiMessages();
    }
  },

  methods: {
    c1SetStatus(s) {
      if (s === 'bathroom') this.c1BathroomCount++;
      if (s === 'coffee')   this.c1CoffeeCount++;
      if (!this.c1Status) this.c1Status = 'shift';
      this.c1Status = s;
      this.c1StatusSince = Date.now();
      this.c1StatusElapsed = '00:00';
      this.c1ShiftMenuOpen = false;
      localStorage.setItem('c1_status', s);
      localStorage.setItem('c1_status_since', String(this.c1StatusSince));
      if (s === 'bathroom') localStorage.setItem('c1_bathroom_count', String(this.c1BathroomCount));
      if (s === 'coffee')   localStorage.setItem('c1_coffee_count',   String(this.c1CoffeeCount));
      if (s === 'end') this.c1SaveTodayToLog();
    },
    c1TickStatus() {
      const fmtSec = (sec) => {
        const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s2 = sec % 60;
        return h > 0
          ? String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0')
          : String(m).padStart(2,'0') + ':' + String(s2).padStart(2,'0');
      };
      this.c1StatusElapsed = fmtSec(Math.floor((Date.now() - this.c1StatusSince) / 1000));
      this.c1ShiftElapsed  = fmtSec(Math.floor((Date.now() - this.c1ShiftStartTime) / 1000));
    },
    c1SaveTodayToLog() {
      try {
        const today = new Date().toISOString().slice(0, 10);
        const workedMin = Math.floor((Date.now() - this.c1ShiftStartTime) / 60000);
        const log = JSON.parse(localStorage.getItem('c1_week_log') || '[]').filter(r => r.date !== today);
        log.unshift({ date: today, workedMin: Math.max(0, workedMin), bathroom: this.c1BathroomCount, coffee: this.c1CoffeeCount });
        localStorage.setItem('c1_week_log', JSON.stringify(log.slice(0, 14)));
        this.c1WeekLog = log.slice(0, 14);
      } catch(e) {}
    },
    c1FilterPanelClick(e) {
      // Panel stays open after selecting — user uses back (←) or X to close
    },
    c1TzTime(tz) {
      try {
        return new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: tz });
      } catch(e) { return "--:--"; }
    },
    c1Logout() {
      this.$store.dispatch('user/logOut');
    },
    // ── Unified panel ─────────────────────────────────────────
    c1PanelBtnClick() {
      this.c1SlideOpen = this.c1PanelIsOpen ? null : 'nav';
    },
    c1SelectPanel(panel, sub) {
      if (panel === 'filters') {
        this.c1FilterTab = sub || 'status';
        this.c1SlideOpen = 'filters';
      } else if (panel === 'charts') {
        this.c1SlideOpen = 'charts';
      } else if (panel === 'calendar') {
        this.c1SlideOpen = 'calendar';
      } else if (panel === 'gantt') {
        this.c1SlideOpen = 'gantt';
      } else if (panel === 'logs') {
        this.c1SlideOpen = 'logs';
      } else if (panel === 'charts-agents') {
        this.c1SlideOpen = 'charts-agents';
      }
    },
    // ── Slide panels ──────────────────────────────────────────
    c1OpenSlide(panel) {
      this.c1SlideOpen = this.c1SlideOpen === panel ? null : panel;
    },

    // ── Toast ─────────────────────────────────────────────────
    c1ShowToast(msg, color = "#2D9D5E") {
      this.c1Toast = { msg, color };
      setTimeout(() => { this.c1Toast = null; }, 3000);
    },

    // ── Tabs ──────────────────────────────────────────────────
    c1SetTab(alias) {
      this.filters.active_group = false;
      this.filters.waiting_group = false;
      this.filters.completed_group = false;
      this.filters.outline_group = false;
      this.filters.events_group = false;
      this.filters.waiting_approval_group = false;
      this.filters.missed_tasks = false;
      this.filters.coming_tasks = false;
      this.filters.today_tasks = false;
      if (alias === "active") this.filters.active_group = true;
      else if (alias === "waiting") this.filters.waiting_group = true;
      else if (alias === "completed") this.filters.completed_group = true;
      else if (alias === "outline") this.filters.outline_group = true;
      else if (alias === "events") this.filters.events_group = true;
      this.selectedTab = alias;
      this.setPage(1);
    },
    c1ToggleMissed() {
      this.filters.missed_tasks = !this.filters.missed_tasks;
      this.fetchTasks();
    },
    c1ToggleComing() {
      this.filters.coming_tasks = !this.filters.coming_tasks;
      this.fetchTasks();
    },

    // ── Filters ───────────────────────────────────────────────
    c1ToggleTaskType(id) {
      if (!this.filters.task_types) this.$set(this.filters, "task_types", []);
      const idx = this.filters.task_types.indexOf(id);
      if (idx === -1) this.filters.task_types.push(id);
      else this.filters.task_types.splice(idx, 1);
      this.fetchTasks();
    },
    c1ToggleTaskUser(id) {
      if (!this.filters.task_users) this.$set(this.filters, "task_users", []);
      const idx = this.filters.task_users.indexOf(id);
      if (idx === -1) this.filters.task_users.push(id);
      else this.filters.task_users.splice(idx, 1);
      this.fetchTasks();
    },
    c1SetPriorityFilter(p) {
      this.filters.priority_id = this.filters.priority_id === p ? null : p;
      this.fetchTasks();
    },
    c1SetTaskKind(kind) {
      this.c1TaskKind = this.c1TaskKind === kind ? null : kind;
      this.fetchTasks();
    },
    // Override parent getQueryParams to inject task_kind from c1TaskKind
    getQueryParams() {
      const params = TasksTableContainer.methods.getQueryParams.call(this);
      if (this.c1TaskKind) params.task_kind = this.c1TaskKind;
      // Also wire missed_tasks and coming_tasks (parent loop skips them without special handling)
      if (this.filters.missed_tasks) params.missed_tasks = 1;
      if (this.filters.coming_tasks) params.coming_tasks = 1;
      if (this.filters.today_tasks) params.today_tasks = 1;
      if (this.filters.priority_id) params.priority_id = this.filters.priority_id;
      if (this.filters.task_users && this.filters.task_users.length) params.task_users = this.filters.task_users;
      if (this.filters.due_date_from) params.due_date_from = this.filters.due_date_from;
      if (this.filters.due_date_to) params.due_date_to = this.filters.due_date_to;
      if (this.filters.sort_due) params.sort_due = this.filters.sort_due;
      if (this.t1TeamFilter !== null) params.team_id = this.t1TeamFilter;
      return params;
    },
    c1SortDue(dir) {
      this.filters.sort_due = dir;
      this.fetchTasks();
    },
    c1ApplyDateFilter(range) {
      this.c1DateFilter = range;
      const now = moment();
      if (range === "T") {
        this.filters.due_date_from = now.format("YYYY-MM-DD");
        this.filters.due_date_to = now.format("YYYY-MM-DD");
      } else if (range === "Y") {
        const y = moment().subtract(1,"day");
        this.filters.due_date_from = y.format("YYYY-MM-DD");
        this.filters.due_date_to = y.format("YYYY-MM-DD");
      } else if (range === "TW") {
        this.filters.due_date_from = now.startOf("isoWeek").format("YYYY-MM-DD");
        this.filters.due_date_to = now.endOf("isoWeek").format("YYYY-MM-DD");
      } else if (range === "LW") {
        this.filters.due_date_from = moment().subtract(1,"week").startOf("isoWeek").format("YYYY-MM-DD");
        this.filters.due_date_to = moment().subtract(1,"week").endOf("isoWeek").format("YYYY-MM-DD");
      } else if (range === "TM") {
        this.filters.due_date_from = now.startOf("month").format("YYYY-MM-DD");
        this.filters.due_date_to = now.endOf("month").format("YYYY-MM-DD");
      } else if (range === "LM") {
        this.filters.due_date_from = moment().subtract(1,"month").startOf("month").format("YYYY-MM-DD");
        this.filters.due_date_to = moment().subtract(1,"month").endOf("month").format("YYYY-MM-DD");
      } else {
        this.filters.due_date_from = null;
        this.filters.due_date_to = null;
      }
      this.fetchTasks();
    },
    c1FullReset() {
      this.$set(this.filters, "task_users", []);
      this.$set(this.filters, "task_types", []);
      this.filters.priority_id = null;
      this.filters.missed_tasks = false;
      this.filters.coming_tasks = false;
      this.filters.today_tasks = false;
      this.filters.due_date_from = null;
      this.filters.due_date_to = null;
      this.wordFilter = "";
      this.c1DateFilter = "ALL";
      this.c1TaskKind = null;
      this.t1TeamFilter = null;
      this.fetchTasks();
    },

    c1CalDaySelected({ date, dateTo }) {
      this.filters.due_date_from = date;
      this.filters.due_date_to = dateTo || date;
      this.c1DateFilter = 'custom';
      this.fetchTasks();
    },

    // ── Task display helpers ──────────────────────────────────
    c1T1TypeColor(task) {
      const types = (this.taskDictionaries && this.taskDictionaries.general && this.taskDictionaries.general.task_types) || [];
      const typeId = task.task_type_id || (task.task_type && task.task_type.id);
      const idx = types.findIndex(t => t.id === typeId);
      return TYPE_COLORS[idx % TYPE_COLORS.length] || "#7C5CFC";
    },
    c1T1TypeLabel(task) {
      const types = (this.taskDictionaries && this.taskDictionaries.general && this.taskDictionaries.general.task_types) || [];
      const typeId = task.task_type_id || (task.task_type && task.task_type.id);
      const found = types.find(t => t.id === typeId);
      if (found) return (found.title || found.name || "").slice(0,3).toUpperCase();
      return "TSK";
    },
    c1T1StatusLabel(task) {
      if (task.is_completed || task.completed_at) return "DONE";
      if (task.is_waiting) return "WAIT";
      if (task.missedScheduledCall) return "MISS";
      if (task.scheduledCallSoon) return "SOON";
      if (task.task_sub_status_type) return (task.task_sub_status_type.name || "").slice(0,4).toUpperCase();
      return "ACT";
    },
    c1T1StatusKey(task) {
      if (task.is_completed || task.completed_at) return "done";
      if (task.is_waiting) return "wait";
      if (task.missedScheduledCall) return "miss";
      if (task.scheduledCallSoon) return "soon";
      return "act";
    },
    c1T1UserName(user) {
      if (!user) return "";
      return user.full_name || (user.first_name ? (user.first_name + " " + (user.last_name || "")).trim() : (user.username || ""));
    },
    c1T1UserInitials(user) {
      if (!user) return "?";
      const name = this.c1T1UserName(user);
      return name.split(" ").slice(0,2).map(w => w[0] || "").join("").toUpperCase() || "?";
    },
    c1T1ShortName(user) {
      if (!user) return "";
      const name = this.c1T1UserName(user);
      const parts = name.split(" ");
      return parts[0] + (parts[1] ? " " + parts[1][0] + "." : "");
    },
    c1T1FmtDate(d) {
      if (!d) return "";
      return moment(d).format("DD/MM/YY");
    },
    c1T1Truncate(text, len = 80) {
      if (!text) return "";
      const plain = String(text).replace(/<[^>]+>/g, "");
      return plain.length > len ? plain.slice(0, len) + "…" : plain;
    },
    c1T1DueDateStyle(task) {
      if (!task.due_date) return "";
      const diff = moment(task.due_date).diff(moment(), "days");
      if (diff < 0) return "color:#E05A3A;font-weight:600";
      if (diff <= 1) return "color:#E8891C;font-weight:600";
      return "";
    },
    c1T1PriorityBorder(task) {
      const p = task.priority_id;
      if (p === 1) return "border-left: 3px solid #E05A3A";
      if (p === 2) return "border-left: 3px solid #E8891C";
      if (p === 3) return "border-left: 3px solid #2D9D5E";
      if (p === 4) return "border-left: 3px solid #7C5CFC";
      // No priority — show subtle team border if team_id is known
      const teamId = this.t1TaskTeamId(task);
      if (teamId === 1) return "border-left: 3px solid #0e7490";
      if (teamId === 2) return "border-left: 3px solid #7c3aed";
      return "";
    },

    t1TaskTeamId(task) {
      // Try to get team_id from the assigned user on the task
      const toUser = task.to_user || (task.taskAssignment && task.taskAssignment[0] && task.taskAssignment[0].assignedTo);
      if (toUser && toUser.team_id) return toUser.team_id;
      // Fallback: look up in salesPersonList
      const userId = toUser && toUser.id;
      if (userId && this.salesPersonList) {
        const found = this.salesPersonList.find(u => u.id === userId);
        if (found && found.team_id) return found.team_id;
      }
      return null;
    },
    c1PriLabel(p) {
      if (p === 1) return "High";
      if (p === 2) return "Med";
      if (p === 3) return "Low";
      if (p === 4) return "Critical";
      return "";
    },
    c1PriStyle(p) {
      if (p === 1) return "color:#E05A3A;font-weight:600";
      if (p === 2) return "color:#E8891C;font-weight:600";
      if (p === 3) return "color:#2D9D5E;font-weight:600";
      if (p === 4) return "color:#7C5CFC;font-weight:600";
      return "";
    },
    c1IsAnnouncement(task) {
      return task.task_kind === "announcement" || task.type === "announcement";
    },
    c1IsTaskOpener(task) {
      const me = this.auth && this.auth.user && this.auth.user.id;
      return task.from_user && task.from_user.id === me;
    },

    // ── Multi-assignee helpers ─────────────────────────────────
    /**
     * Returns all assignee user objects for a task (excludes the creator self-assignment).
     * Uses taskAssignment → assignedTo (auto-loaded by TaskAssignment model's $with).
     */
    c1TaskAssignees(task) {
      if (!task || !task.taskAssignment || !task.taskAssignment.length) return [];
      return task.taskAssignment
        .filter(a => a.assigned_to !== a.assigned_by && a.assignedTo)
        .map(a => a.assignedTo)
        .filter((u, i, arr) => arr.findIndex(x => x && u && x.id === u.id) === i); // deduplicate
    },

    // ── Expand ────────────────────────────────────────────────
    c1ToggleExpand(id) {
      this.c1T1Expanded = this.c1T1Expanded === id ? null : id;
      this.c1DetailTask = null;
    },

    // ── Sub-tasks ─────────────────────────────────────────────
    c1SubDone(task) {
      if (!task.sub_tasks) return 0;
      return task.sub_tasks.filter(s => s.is_completed || s.completed_at).length;
    },
    c1SubPct(task) {
      if (!task.sub_tasks || !task.sub_tasks.length) return 0;
      return Math.round(this.c1SubDone(task) / task.sub_tasks.length * 100);
    },
    c1ToggleSubtask(task, sub) {
      const wasCompleted = !!(sub.is_completed || sub.completed_at);
      this.$set(sub, "is_completed", !wasCompleted);
      if (!wasCompleted) this.$set(sub, "completed_at", new Date().toISOString());
      else this.$set(sub, "completed_at", null);
    },

    // ── Chart helpers ─────────────────────────────────────────
    c1T1Pct(val) {
      const total = this.c1T1TotalTasks || 1;
      return Math.round((val || 0) / total * 100);
    },
    c1T1DonutDash(val) {
      const circ = 2 * Math.PI * 30;
      const total = this.c1T1TotalTasks || 1;
      const seg = (val || 0) / total * circ;
      return seg + " " + (circ - seg);
    },
    c1T1DonutOffset(precedingVal) {
      const circ = 2 * Math.PI * 30;
      const total = this.c1T1TotalTasks || 1;
      return -(precedingVal / total * circ);
    },
    c1T17DayH(val) {
      const allDays = this.c1T1SevenDays;
      const mx = Math.max(...allDays.map(d => Math.max(d.due, d.done)), 1);
      return Math.round((val || 0) / mx * 40);
    },
    c1DaysOverdue(task) {
      if (!task.due_date) return 0;
      return Math.abs(moment(task.due_date).diff(moment(), "days"));
    },
    c1TimePct(task) {
      const maxTime = Math.max(...(this.c1TopTimeTasks.map(t => t.task_time_duration || 0)), 1);
      return Math.round((task.task_time_duration || 0) / maxTime * 100);
    },

    // ── Calendar ──────────────────────────────────────────────
    c1CalPrev() {
      if (this.c1CalMonth === 0) { this.c1CalMonth = 11; this.c1CalYear--; }
      else this.c1CalMonth--;
      this.c1CalSelected = null;
    },
    c1CalNext() {
      if (this.c1CalMonth === 11) { this.c1CalMonth = 0; this.c1CalYear++; }
      else this.c1CalMonth++;
      this.c1CalSelected = null;
    },
    c1CalDayClick(day) {
      this.c1CalSelected = {
        label: moment(day.dateStr).format("dddd, D MMM YYYY"),
        tasks: day.tasks,
      };
    },
    c1IsOverdue(task) {
      return task.due_date && !task.is_completed && !task.completed_at && moment(task.due_date).isBefore(moment(), "day");
    },
    c1IsDueToday(task) {
      return task.due_date && moment(task.due_date).isSame(moment(), "day");
    },

    // ── Viki ──────────────────────────────────────────────────
    c1BuildVikiMessages() {
      const msgs = [];
      const overdue = this.c1OverdueTasks ? this.c1OverdueTasks.length : 0;
      const missed = this.stats && this.stats.tasks_missed ? this.stats.tasks_missed : 0;
      const coming = this.stats && this.stats.tasks_coming ? this.stats.tasks_coming : 0;

      if (overdue > 0) {
        msgs.push({ type: "warn", text: `You have <strong>${overdue} overdue task${overdue > 1 ? "s" : ""}</strong> — follow up now.` });
      }
      if (missed > 0) {
        msgs.push({ type: "warn", text: `<strong>${missed} missed task${missed > 1 ? "s" : ""}</strong> need attention.` });
      }
      if (coming > 0) {
        msgs.push({ type: "info", text: `<strong>${coming} task${coming > 1 ? "s" : ""}</strong> due soon — stay ahead.` });
      }
      if (this.c1AnnouncementCount > 0) {
        msgs.push({ type: "info", text: `<strong>${this.c1AnnouncementCount} announcement${this.c1AnnouncementCount > 1 ? "s" : ""}</strong> waiting for your reply.` });
      }
      if (msgs.length === 0) {
        msgs.push({ type: "ok", text: "All tasks looking good. <strong>Keep the momentum!</strong>" });
      }
      this.c1VikiMessages = msgs;
      this.c1VikiUnread = msgs.some(m => m.type === "warn");
    },

    // ── Open task detail drawer ───────────────────────────────
    c1OpenTaskDetail(task) {
      this.c1T1Expanded = null;
      this.c1DetailTask = task;
    },
    c1OpenCreateTask() {
      this.c1CreateForm = {
        title: "",
        content: "",
        to_user_id: "",
        to_user_ids: [],
        priority_id: null,
        due_date: "",
        kind: "task",
        sub_tasks: [],
        recipients: [],
        attachedFile: null,
      };
      this.c1CreateError = null;
      this.c1ShowCreateTask = true;
    },
    c1OpenTransfer(task) {
      this.c1TransferModal = task;
      this.c1TransferUserId = "";
    },

    // ── Timer ─────────────────────────────────────────────────
    c1IsTimerRunning(task) {
      return !!this.c1RunningTimers[task.id] || (task.timer_running === true) || (task.task_time_sessions && task.task_time_sessions.some(s => !s.ended_at));
    },
    async c1StartTimer(task) {
      const userId = this.auth && this.auth.user && this.auth.user.id;
      if (!userId) return;
      const now = new Date().toISOString();
      try {
        // Try GET to see if a time record already exists for this task
        let existing = null;
        try {
          const r = await axios.get(`${API}/tasks/time/${task.id}`, { headers: authHeader() });
          existing = r.data && r.data.data ? r.data.data : r.data;
        } catch(_) { existing = null; }

        if (existing && existing.id) {
          // Update existing record — resume timer
          await axios.put(`${API}/tasks/time/${task.id}`, {
            running: true,
            time: existing.time || "00:00:00",
            timeBeganLatest: now,
            timeBegan: existing.time_began || now,
          }, { headers: authHeader() });
        } else {
          // Create new time record
          await axios.post(`${API}/tasks/time`, {
            task_id: task.id,
            user_id: userId,
            time: "00:00:00",
            running: true,
            time_began: now,
            time_stopped: now,
          }, { headers: authHeader() });
        }

        this.$set(this.c1RunningTimers, task.id, true);
        this.$set(this.c1TimerStartedAt, task.id, Date.now());
        this.$set(task, "timer_running", true);
        this.c1ShowToast("Timer started");
      } catch(e) {
        this.c1ShowToast("Failed to start timer", "#E05A3A");
      }
    },
    async c1StopTimer(task) {
      const now = new Date().toISOString();
      try {
        // Calculate elapsed since start
        const startedAt = this.c1TimerStartedAt[task.id];
        let elapsed = "00:00:00";
        if (startedAt) {
          const ms = Date.now() - startedAt;
          const h = Math.floor(ms / 3600000);
          const m = Math.floor((ms % 3600000) / 60000);
          const s = Math.floor((ms % 60000) / 1000);
          elapsed = `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
        }

        await axios.put(`${API}/tasks/time/${task.id}`, {
          running: false,
          time: elapsed,
          time_stopped: now,
          timeBeganLatest: now,
          timeBegan: now,
        }, { headers: authHeader() });

        this.$delete(this.c1RunningTimers, task.id);
        this.$delete(this.c1TimerStartedAt, task.id);
        this.$set(task, "timer_running", false);
        this.c1ShowToast("Timer stopped");
        this.fetchTasks();
      } catch(e) {
        this.c1ShowToast("Failed to stop timer", "#E05A3A");
      }
    },

    // ── Pause timer (pause without logging) ──────────────────
    async c1PauseTimer(task) {
      const now = new Date().toISOString();
      try {
        const startedAt = this.c1TimerStartedAt[task.id];
        let elapsed = "00:00:00";
        if (startedAt) {
          const ms = Date.now() - startedAt;
          const h = Math.floor(ms / 3600000);
          const m = Math.floor((ms % 3600000) / 60000);
          const s = Math.floor((ms % 60000) / 1000);
          elapsed = `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
        }
        await axios.put(`${API}/tasks/time/${task.id}`, {
          running: false,
          time: elapsed,
          time_stopped: now,
          timeBeganLatest: now,
          timeBegan: now,
        }, { headers: authHeader() });
        this.$delete(this.c1RunningTimers, task.id);
        this.$delete(this.c1TimerStartedAt, task.id);
        this.$set(task, "timer_running", false);
        this.c1ShowToast("Timer paused — resume anytime");
      } catch(e) {
        this.c1ShowToast("Failed to pause timer", "#E05A3A");
      }
    },

    // ── Live elapsed display ──────────────────────────────────
    c1LiveElapsed(task) {
      const startedAt = this.c1TimerStartedAt[task.id];
      if (!startedAt) return "00:00:00";
      // Use c1TimeStr to trigger reactivity every second
      void this.c1TimeStr;
      const ms = Date.now() - startedAt;
      const h = Math.floor(ms / 3600000);
      const m = Math.floor((ms % 3600000) / 60000);
      const s = Math.floor((ms % 60000) / 1000);
      return `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
    },

    // ── Close task ────────────────────────────────────────────
    async c1CloseTask(task) {
      if (!this.c1IsTaskOpener(task)) {
        this.c1ShowToast("Only the task opener can close this task", "#E05A3A");
        return;
      }
      try {
        await axios.put(`${API}/tasks/${task.id}/update`, { is_completed: true, completed_at: new Date().toISOString() }, { headers: authHeader() });
        this.$set(task, "is_completed", true);
        this.$set(task, "completed_at", new Date().toISOString());
        this.c1DetailTask = null;
        this.c1ShowToast("Task closed");
        this.fetchTasks();
      } catch(e) {
        this.c1ShowToast("Failed to close task", "#E05A3A");
      }
    },

    // ── Transfer ──────────────────────────────────────────────
    async c1DoTransfer() {
      if (!this.c1TransferUserId || !this.c1DetailTask) return;
      try {
        await axios.put(`${API}/tasks/${this.c1DetailTask.id}/update`, { to_user_id: this.c1TransferUserId }, { headers: authHeader() });
        this.c1TransferAck = "Transferred successfully";
        this.c1ShowToast("Task transferred");
        setTimeout(() => { this.c1TransferAck = null; }, 3000);
        this.fetchTasks();
      } catch(e) {
        this.c1ShowToast("Transfer failed", "#E05A3A");
      }
    },
    async c1DoTransferModal() {
      if (!this.c1TransferUserId || !this.c1TransferModal) return;
      try {
        await axios.put(`${API}/tasks/${this.c1TransferModal.id}/update`, { to_user_id: this.c1TransferUserId }, { headers: authHeader() });
        this.c1TransferModal = null;
        this.c1ShowToast("Task transferred");
        this.fetchTasks();
      } catch(e) {
        this.c1ShowToast("Transfer failed", "#E05A3A");
      }
    },

    // ── Status update ─────────────────────────────────────────
    async c1DetailUpdateStatus(status) {
      if (!this.c1DetailTask) return;
      const payload = {};
      if (status === "active") payload.is_waiting = false;
      else if (status === "waiting") payload.is_waiting = true;
      else if (status === "done") { payload.is_completed = true; payload.completed_at = new Date().toISOString(); }
      try {
        await axios.put(`${API}/tasks/${this.c1DetailTask.id}/update`, payload, { headers: authHeader() });
        this.c1DetailStatusAck = status;
        this.c1ShowToast("Status updated to " + status);
        setTimeout(() => { this.c1DetailStatusAck = null; }, 3000);
        this.fetchTasks();
      } catch(e) {
        this.c1ShowToast("Update failed", "#E05A3A");
      }
    },

    // ── Comment / Post ────────────────────────────────────────
    async c1SendDetailComment() {
      const text = this.c1DetailComment.trim();
      if (!text || !this.c1DetailTask) return;
      const myId = this.auth && this.auth.user && this.auth.user.id;
      const myUser = this.auth && this.auth.user;
      // Optimistic: add reply to local task object immediately
      const optimistic = { id: Date.now(), reply_by: myId, content: text, created_at: new Date().toISOString(), user: myUser };
      if (!this.c1DetailTask.task_reply_logs) this.$set(this.c1DetailTask, 'task_reply_logs', []);
      this.c1DetailTask.task_reply_logs.push(optimistic);
      this.c1DetailComment = "";
      try {
        const assignIds = (this.c1DetailTask.taskAssignment || []).map(a => a.assigned_to).filter(Boolean);
        await axios.post(`${API}/tasks/reply/${this.c1DetailTask.id}`, {
          reply_content: text,
          assign_to: assignIds.length ? assignIds : [myId],
        }, { headers: authHeader() });
        this.c1DetailCommentSent = true;
        setTimeout(() => { this.c1DetailCommentSent = false; }, 2500);
        // Sync fresh data silently
        this.fetchTasks();
      } catch(e) {
        // Remove the optimistic entry on failure
        const idx = this.c1DetailTask.task_reply_logs.findIndex(r => r.id === optimistic.id);
        if (idx !== -1) this.c1DetailTask.task_reply_logs.splice(idx, 1);
        this.c1DetailComment = text; // restore text
        this.c1ShowToast("Failed to post reply", "#E05A3A");
      }
    },

    // ── Create task ───────────────────────────────────────────
    c1AddSubTask() {
      this.c1CreateForm.sub_tasks.push({ title: "", done: false });
    },
    c1HandleFileAttach(e) {
      const file = e.target.files[0];
      if (file) this.$set(this.c1CreateForm, "attachedFile", file);
    },
    c1ToggleRecipient(uid) {
      const idx = this.c1CreateForm.recipients.indexOf(uid);
      if (idx === -1) this.c1CreateForm.recipients.push(uid);
      else this.c1CreateForm.recipients.splice(idx, 1);
    },
    c1ToggleAssignee(uid) {
      const idx = this.c1CreateForm.to_user_ids.indexOf(uid);
      if (idx === -1) this.c1CreateForm.to_user_ids.push(uid);
      else this.c1CreateForm.to_user_ids.splice(idx, 1);
    },
    async c1SubmitCreate() {
      if (!this.c1CreateForm.title.trim()) {
        this.c1CreateError = "Title is required";
        return;
      }
      this.c1CreateLoading = true;
      this.c1CreateError = null;
      try {
        const assignIds = this.c1CreateForm.to_user_ids.length
          ? this.c1CreateForm.to_user_ids
          : (this.c1CreateForm.to_user_id ? [this.c1CreateForm.to_user_id] : []);
        const payload = {
          title: this.c1CreateForm.title.trim(),
          content: this.c1CreateForm.content || null,
          to_user_ids: assignIds,
          priority_id: this.c1CreateForm.priority_id || 2,
          due_date: this.c1CreateForm.due_date || null,
          kind: this.c1CreateForm.due_date ? "meeting" : (this.c1CreateForm.kind || "task"),
          sub_tasks: this.c1CreateForm.sub_tasks.filter(s => s.title.trim()).map(s => ({ title: s.title })),
        };
        if (this.c1CreateForm.kind === "announcement" && this.c1CreateForm.recipients.length) {
          payload.recipients = this.c1CreateForm.recipients;
        }
        await axios.post(`${API}/tasks/create`, payload, { headers: authHeader() });
        this.c1ShowCreateTask = false;
        this.c1ShowToast("Task created successfully");
        this.fetchTasks();
      } catch(e) {
        this.c1CreateError = (e.response && e.response.data && e.response.data.message) || "Failed to create task";
      } finally {
        this.c1CreateLoading = false;
      }
    },

    // ── Announcements ─────────────────────────────────────────
    async c1LoadAnnouncements() {
      try {
        const res = await axios.get(`${API}/tasks/list`, {
          headers: authHeader(),
          params: { task_kind: "announcement", per_page: 50 },
        });
        const payload = res.data && res.data.data ? res.data.data : (Array.isArray(res.data) ? res.data : []);
        this.c1Announcements = payload;
      } catch(e) {
        this.c1Announcements = [];
      }
    },
    c1AnnReplied(ann, type) {
      if (!ann.replies) return 0;
      return ann.replies.filter(r => r.reply_type === type).length;
    },
    c1AnnPending(ann) {
      if (!ann.recipients || !ann.replies) return ann.recipients ? ann.recipients.length : 0;
      return ann.recipients.length - ann.replies.length;
    },
    c1MyAnnReply(ann) {
      const myId = this.auth && this.auth.user && this.auth.user.id;
      if (!ann.replies || !myId) return null;
      const r = ann.replies.find(r => r.user_id === myId);
      return r ? r.reply_type : null;
    },
    c1AnnNoReply(ann) {
      if (!ann.recipients || !ann.replies) return ann.recipients || [];
      const replied = new Set(ann.replies.map(r => r.user_id));
      return ann.recipients.filter(u => !replied.has(u.id));
    },
    async c1ReplyAnn(ann, type) {
      try {
        await axios.post(`${API}/tasks/${ann.id}/update`, { announcement_reply: type }, { headers: authHeader() });
        if (!ann.replies) this.$set(ann, "replies", []);
        const myId = this.auth && this.auth.user && this.auth.user.id;
        const existing = ann.replies.find(r => r.user_id === myId);
        if (existing) existing.reply_type = type;
        else ann.replies.push({ user_id: myId, reply_type: type });
        this.c1ShowToast("Reply sent: " + type.replace("_", " "));
      } catch(e) {
        this.c1ShowToast("Failed to send reply", "#E05A3A");
      }
    },

    // ── Open full task window ─────────────────────────────────
    openTask(task) {
      this.c1T1Expanded = null;
      this.c1DetailTask = null;
      this.$nextTick(() => {
        this.taskToUpdateId = task.id;
        this.showMainTaskWindow = true;
      });
    },

    // ── Time ago helper ───────────────────────────────────────
    c1TimeAgo(ts) {
      if (!ts) return '';
      const diff = Date.now() - new Date(ts).getTime();
      const mins = Math.floor(diff / 60000);
      if (mins < 1) return 'just now';
      if (mins < 60) return mins + 'm ago';
      const hrs = Math.floor(mins / 60);
      if (hrs < 24) return hrs + 'h ago';
      return Math.floor(hrs / 24) + 'd ago';
    },
    c1ReplyUserName(reply) {
      if (!reply) return '?';
      const u = reply.user || reply.from_user || reply.replyBy;
      if (u) return u.full_name || ((u.first_name || '') + ' ' + (u.last_name || '')).trim() || '?';
      // Fallback: look up by reply_by in salesPersonList
      const uid = reply.reply_by || reply.user_id;
      if (uid && this.$store.state.clients.salesPersonList) {
        const found = this.$store.state.clients.salesPersonList.find(p => p.id === uid);
        if (found) return found.full_name || ((found.first_name || '') + ' ' + (found.last_name || '')).trim();
      }
      return uid ? 'Agent #' + uid : '?';
    },
    c1ReplyUserInitials(reply) {
      const name = this.c1ReplyUserName(reply);
      const parts = name.split(' ');
      return ((parts[0] || '')[0] || '').toUpperCase() + ((parts[1] || '')[0] || '').toUpperCase() || '?';
    },
    c1IsMine(reply) {
      const u = this.auth && this.auth.user;
      if (!u) return false;
      return (reply.reply_by || reply.user_id) === u.id;
    },
  }
};
</script>

<style>
/* ══════════════════════════════════════════════════════════════════════════
   MAESTRO DESIGN SYSTEM — fonts
   ══════════════════════════════════════════════════════════════════════════ */
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700;9..40,800&family=DM+Mono:wght@400;500&family=Plus+Jakarta+Sans:wght@700;800&display=swap');

/* ── Tab bar ──────────────────────────────────────────────────── */
.c1-t1-tabs {
  display: flex;
  gap: 2px;
  padding: 6px 10px 0;
  background: var(--c1-bg, #F7F6F3);
  overflow-x: auto;
  flex-shrink: 0;
}
.c1-t1-tab {
  flex-shrink: 0;
  padding: 5px 10px;
  border-radius: 6px 6px 0 0;
  font-size: 11px;
  font-weight: 600;
  color: var(--c1-t2, #7A7067);
  cursor: pointer;
  background: var(--c1-surface, #EDECEA);
  transition: background .15s, color .15s;
  position: relative;
}
.c1-t1-tab.on { background: #fa8100; color: #fff; }
.c1-t1-tab-missed.on { background: #E05A3A; }
.c1-t1-tab-coming.on { background: #E8891C; }
.c1-t1-tab-announce.on { background: #7C5CFC; }
.c1-t1-tc { font-weight: 700; margin-left: 4px; opacity: .85; }
.c1-t1-tc.red { color: #E05A3A; }
.c1-t1-tc.orange { color: #E8891C; }
.c1-t1-tc.green { color: #2D9D5E; }
.c1-t1-new {
  position: absolute; top: -4px; right: -4px;
  background: #E05A3A; color: #fff;
  font-size: 9px; font-weight: 700;
  padding: 1px 3px; border-radius: 8px;
}

/* ── Task card ────────────────────────────────────────────────── */
.c1-t1-box { border-left: 0; }

/* Type icon circle (replaces small badge) */
.c1-t1-type-ic {
  flex-shrink: 0; width: 38px; height: 38px; border-radius: 9px;
  display: flex; align-items: center; justify-content: center;
  font-size: 9px; font-weight: 800; color: #fff; letter-spacing: .5px;
  margin-right: 10px;
}

.c1-t1-title { font-weight: 700; font-size: 13px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

/* Assignment row */
.c1-t1-assign-row { cursor: pointer; }
.c1-t1-assign-row:hover { background: rgba(0,0,0,.02); }
.c1-t1-agent-name { font-size: 11px; color: var(--c1-t2); font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 90px; }

/* Due date pill */
.c1-t1-due-pill {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 2px 8px; border-radius: 10px;
  font-size: 10px; font-weight: 700; flex-shrink: 0;
  background: rgba(232,137,28,.1); color: #E8891C;
}

/* Description row */
.c1-t1-desc-row { cursor: pointer; }
.c1-t1-desc-row:hover { background: rgba(0,0,0,.02); }
.c1-t1-due { color: #E8891C; }
.c1-t1-to-av { background: #fa8100 !important; }
.c1-t1-content { font-size: 11px; color: var(--c1-t3, #A09E98); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%; }
.c1-t1-tag {
  display: inline-block; padding: 2px 7px; border-radius: 10px;
  background: var(--c1-surface, #EDECEA); color: var(--c1-t2, #7A7067);
  font-size: 10px; font-weight: 600;
}
.c1-t1-pri { font-size: 10px; font-weight: 700; }

/* Stats bar */
.c1-t1-stats-bar {
  display: flex; align-items: center; gap: 6px;
  padding: 5px 10px 8px 58px; flex-wrap: wrap;
}
.c1-t1-stat-chip {
  display: inline-flex; align-items: center; gap: 4px;
  background: rgba(0,0,0,.04); border: 1px solid var(--c1-brd-l);
  border-radius: 8px; padding: 3px 8px;
  font-size: 10px; font-weight: 600; color: var(--c1-t2);
}
.c1-t1-stat-chip svg { flex-shrink: 0; stroke: currentColor; fill: none; }
.c1-t1-stat-time { color: #7C5CFC; background: rgba(124,92,252,.06); border-color: rgba(124,92,252,.15); }
.c1-t1-stat-live { color: #2D9D5E; background: rgba(45,157,94,.07); border-color: rgba(45,157,94,.2); animation: c1-pulse-border 1.5s infinite; }
.c1-t1-stat-client { color: #0ea5e9; background: rgba(14,165,233,.07); border-color: rgba(14,165,233,.2); }

/* Mini subtask progress in stat chip */
.c1-t1-subtrack {
  width: 30px; height: 4px; background: rgba(0,0,0,.08); border-radius: 2px; overflow: hidden;
}
.c1-t1-subfill { height: 100%; background: #2D9D5E; border-radius: 2px; transition: width .4s ease; }

/* Sequential steps mini-dots */
.c1-t1-steps-mini { display: flex; align-items: center; gap: 3px; }
.c1-step-dot {
  width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0;
  border: 1.5px solid rgba(0,0,0,.15);
}
.c1-step-dot-done   { background: #2D9D5E; border-color: #2D9D5E; }
.c1-step-dot-active { background: #fa8100; border-color: #fa8100; }
.c1-step-dot-locked { background: rgba(0,0,0,.1); border-color: rgba(0,0,0,.15); }

@keyframes c1-pulse-border {
  0%,100% { box-shadow: 0 0 0 0 rgba(45,157,94,.3); }
  50% { box-shadow: 0 0 0 3px rgba(45,157,94,.1); }
}

/* Priority colored badges */
.c1-t1-pri-badge {
  display: inline-flex; align-items: center; padding: 1px 7px; border-radius: 10px;
  font-size: 10px; font-weight: 700; letter-spacing: .3px;
}
.c1-pri-1 { background: rgba(224,90,58,.12); color: #E05A3A; }
.c1-pri-2 { background: rgba(232,137,28,.12); color: #E8891C; }
.c1-pri-3 { background: rgba(45,157,94,.12); color: #2D9D5E; }
.c1-pri-4 { background: rgba(124,92,252,.15); color: #7C5CFC; }

/* Live timer widget */
.c1-live-timer {
  display: flex; align-items: center; gap: 8px;
  padding: 8px 14px; margin: 4px 14px 6px;
  background: rgba(45,157,94,.08); border: 1px solid rgba(45,157,94,.2);
  border-radius: 8px;
}
.c1-live-timer-dot {
  width: 8px; height: 8px; border-radius: 50%;
  background: #2D9D5E;
  animation: c1-pulse 1s infinite;
}
.c1-live-timer-display {
  font-size: 20px; font-weight: 800; color: #2D9D5E;
  letter-spacing: 1px;
}
.c1-timer-pause-btn {
  display: flex; align-items: center; gap: 4px;
  padding: 5px 10px; border-radius: 7px; font-size: 11px; font-weight: 600;
  border: 1.5px solid #E8891C; color: #E8891C; background: transparent;
  cursor: pointer; transition: all .15s;
}
.c1-timer-pause-btn:hover { background: rgba(232,137,28,.08); }
.c1-timer-pause-btn:disabled { opacity: .35; cursor: default; }
.c1-timer-pause-btn svg { stroke: currentColor; fill: none; stroke-width: 2; }
.c1-tag-announce { background: #F0ECFF; color: #7C5CFC; font-size: 9px; font-weight: 700; padding: 1px 5px; border-radius: 8px; margin-left: 4px; }

/* status badge */
.c1-t1-bs-act  { background: #FFF4E8; color: #E8891C; }
.c1-t1-bs-wait { background: #EEF2FF; color: #4275ec; }
.c1-t1-bs-done { background: #EDFAF4; color: #2D9D5E; }
.c1-t1-bs-miss { background: #FFF2EE; color: #E05A3A; }
.c1-t1-bs-soon { background: #FFF4E8; color: #fa8100; }

/* priority border */
.c1-t1-missed { border-left: 3px solid #E05A3A; }
.c1-t1-soon   { border-left: 3px solid #E8891C; }

/* top bar buttons */
.c1-t1-new-btn { color: #fa8100 !important; }
.c1-t1-new-btn.c1-tib-btn svg { stroke: #fa8100; }

/* timer running indicator */
.c1-timer-running { color: #2D9D5E; font-weight: 600; }
.c1-timer-dot {
  display: inline-block; width: 6px; height: 6px; border-radius: 50%;
  background: #2D9D5E; margin-right: 3px;
  animation: c1-pulse 1s infinite;
}
@keyframes c1-pulse {
  0%, 100% { opacity: 1; } 50% { opacity: .3; }
}

/* ── Expand transition ────────────────────────────────────────── */
.c1-expand-enter-active, .c1-expand-leave-active { transition: max-height .25s ease, opacity .2s; overflow: hidden; }
.c1-expand-enter, .c1-expand-leave-to { max-height: 0; opacity: 0; }
.c1-expand-enter-to, .c1-expand-leave { max-height: 2000px; opacity: 1; }

/* ── Inline expand body ───────────────────────────────────────── */
.c1-t1-expand-body {
  border-top: 1px solid var(--c1-border, #E6E3DE);
  padding: 4px 0 0;
}
.c1-exp-actions {
  display: flex; flex-wrap: wrap; gap: 6px; padding: 0 14px 14px;
}
.c1-action-btn {
  display: flex; align-items: center; gap: 4px;
  padding: 5px 10px; border-radius: 7px; font-size: 11px; font-weight: 600;
  border: 1.5px solid var(--c1-border, #E6E3DE); cursor: pointer; background: transparent;
  transition: all .15s;
}
.c1-action-btn svg { flex-shrink: 0; }
.c1-action-detail  { color: #4275ec; } .c1-action-detail:hover  { background: #EEF2FF; border-color: #4275ec; }
.c1-action-transfer{ color: #7C5CFC; } .c1-action-transfer:hover{ background: #F0ECFF; border-color: #7C5CFC; }
.c1-action-close   { color: #2D9D5E; } .c1-action-close:hover   { background: #EDFAF4; border-color: #2D9D5E; }
.c1-action-open    { color: #fa8100; } .c1-action-open:hover    { background: #FFF4E8; border-color: #fa8100; }

/* ── Sub-tasks ────────────────────────────────────────────────── */
.c1-subtask-progress {
  margin: 4px 14px 8px; height: 4px;
  background: var(--c1-surface, #EDECEA); border-radius: 2px; overflow: hidden;
}
.c1-subtask-bar { height: 100%; background: linear-gradient(90deg, #2D9D5E, #4ACA89); border-radius: 2px; transition: width .3s; }
.c1-subtask-row {
  display: flex; align-items: center; gap: 8px;
  padding: 4px 14px; cursor: pointer;
}
.c1-subtask-check {
  width: 16px; height: 16px; border-radius: 4px; flex-shrink: 0;
  border: 1.5px solid var(--c1-border, #E6E3DE);
  display: flex; align-items: center; justify-content: center;
  transition: all .15s; cursor: pointer;
}
.c1-subtask-check.done { background: #2D9D5E; border-color: #2D9D5E; }
.c1-subtask-check.done svg { stroke: #fff; }
.c1-subtask-title { font-size: 12px; color: var(--c1-t1, #2C2925); flex: 1; }
.c1-subtask-done-text { text-decoration: line-through; color: var(--c1-t3, #A09E98); }

/* ── Sequential steps ────────────────────────────────────────── */
.c1-steps-row { display: flex; gap: 4px; padding: 4px 14px 6px; align-items: center; }
.c1-step-pill {
  display: flex; align-items: center; justify-content: center;
  width: 22px; height: 22px; border-radius: 50%;
  font-size: 10px; font-weight: 700;
  border: 1.5px solid var(--c1-border, #E6E3DE);
  background: var(--c1-bg, #F7F6F3);
  color: var(--c1-t2, #7A7067);
}
.c1-step-pill.c1-step-done   { background: #2D9D5E; border-color: #2D9D5E; color: #fff; }
.c1-step-pill.c1-step-active { background: #fa8100; border-color: #fa8100; color: #fff; }
.c1-step-pill.c1-step-locked { opacity: .4; }

.c1-seq-steps { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; padding: 4px 14px 8px; }
.c1-seq-step  {
  display: flex; align-items: center; gap: 6px;
  padding: 5px 8px; border-radius: 8px;
  border: 1.5px solid var(--c1-border, #E6E3DE);
  background: var(--c1-bg, #F7F6F3);
}
.c1-seq-done   { background: #EDFAF4; border-color: #2D9D5E; }
.c1-seq-active { background: #FFF4E8; border-color: #fa8100; }
.c1-seq-locked { opacity: .45; }
.c1-seq-num {
  width: 20px; height: 20px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  background: var(--c1-surface, #EDECEA); font-size: 10px; font-weight: 700;
  flex-shrink: 0;
}
.c1-seq-done .c1-seq-num   { background: #2D9D5E; color: #fff; }
.c1-seq-active .c1-seq-num { background: #fa8100; color: #fff; }
.c1-seq-info { display: flex; flex-direction: column; }
.c1-seq-title { font-size: 11px; font-weight: 600; color: var(--c1-t1, #2C2925); }
.c1-seq-status { font-size: 9px; color: var(--c1-t3, #A09E98); text-transform: uppercase; }
.c1-seq-arrow { opacity: .35; flex-shrink: 0; }

/* ── Time tracking ────────────────────────────────────────────── */
.c1-timer-btns { display: flex; gap: 8px; padding: 4px 14px 8px; }
.c1-timer-start-btn, .c1-timer-stop-btn {
  flex: 1; display: flex; align-items: center; justify-content: center; gap: 5px;
  padding: 6px; border-radius: 8px; font-size: 11px; font-weight: 700; cursor: pointer;
  border: 1.5px solid; transition: all .15s;
}
.c1-timer-start-btn { background: #EDFAF4; color: #2D9D5E; border-color: #2D9D5E; }
.c1-timer-start-btn:hover:not(:disabled) { background: #2D9D5E; color: #fff; }
.c1-timer-stop-btn  { background: #FFF2EE; color: #E05A3A; border-color: #E05A3A; }
.c1-timer-stop-btn:hover:not(:disabled)  { background: #E05A3A; color: #fff; }
.c1-timer-start-btn:disabled, .c1-timer-stop-btn:disabled { opacity: .35; cursor: not-allowed; }

.c1-time-sessions { padding: 0 14px; }
.c1-time-session-row {
  display: flex; align-items: center; gap: 6px;
  padding: 4px 0; border-bottom: 1px solid var(--c1-border, #E6E3DE);
  font-size: 11px; color: var(--c1-t2, #7A7067);
}
.c1-time-dur { margin-left: auto; font-weight: 600; color: #7C5CFC; }

/* ── Charts panel extras ──────────────────────────────────────── */
.c1-overdue-list { padding: 0 14px; }
.c1-overdue-row {
  display: flex; align-items: center; gap: 8px;
  padding: 6px 0; border-bottom: 1px solid var(--c1-border, #E6E3DE);
  cursor: pointer;
}
.c1-overdue-rank {
  width: 20px; height: 20px; border-radius: 50%; background: #FFF2EE;
  color: #E05A3A; font-size: 10px; font-weight: 700;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.c1-overdue-info { flex: 1; overflow: hidden; }
.c1-overdue-title { font-size: 11px; font-weight: 600; color: var(--c1-t1, #2C2925); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.c1-overdue-due { font-size: 10px; color: #E05A3A; }
.c1-overdue-days { font-size: 11px; font-weight: 700; color: #E05A3A; flex-shrink: 0; }
.c1-chart-empty { padding: 16px 0; text-align: center; font-size: 11px; color: var(--c1-t3, #A09E98); }
.c1-kpi-row { display: flex; gap: 8px; padding: 0 14px; }
.c1-kpi { flex: 1; padding: 8px; background: var(--c1-surface, #EDECEA); border-radius: 8px; text-align: center; }
.c1-kpi-lbl { font-size: 9px; font-weight: 600; color: var(--c1-t3, #A09E98); text-transform: uppercase; }
.c1-kpi-val { font-size: 18px; font-weight: 800; color: var(--c1-t1, #2C2925); margin-top: 2px; }
.c1-co-lbl { font-size: 10px; font-weight: 700; color: var(--c1-t3, #A09E98); text-transform: uppercase; letter-spacing: .8px; padding: 0 14px; }

/* donut */
.c1-donut-row { display: flex; align-items: center; gap: 14px; padding: 0 14px; }
.c1-donut { width: 80px; height: 80px; flex-shrink: 0; }
.c1-donut-legend { flex: 1; display: flex; flex-direction: column; gap: 5px; }
.c1-dl-row { display: flex; align-items: center; gap: 6px; font-size: 11px; color: var(--c1-t2, #7A7067); }
.c1-dl-dot { width: 8px; height: 8px; border-radius: 2px; flex-shrink: 0; }
.c1-dl-val { margin-left: auto; font-weight: 700; color: var(--c1-t1, #2C2925); }

/* completion rate */
.c1-crate-wrap { display: flex; align-items: center; gap: 8px; padding: 0 14px; }
.c1-crate-track { flex: 1; height: 8px; background: var(--c1-surface, #EDECEA); border-radius: 4px; overflow: hidden; }
.c1-crate-fill { height: 100%; background: linear-gradient(90deg, #2D9D5E, #4ACA89); border-radius: 4px; transition: width .4s; }
.c1-crate-pct { font-size: 11px; font-weight: 700; color: #2D9D5E; min-width: 30px; text-align: right; }

/* vbar */
.c1-vbar-chart { padding: 4px 14px; display: flex; flex-direction: column; gap: 6px; }
.c1-vbar-row { display: flex; align-items: center; gap: 8px; }
.c1-vbar-lbl { font-size: 10px; font-weight: 600; color: var(--c1-t2, #7A7067); width: 50px; flex-shrink: 0; }
.c1-vbar-track { flex: 1; height: 14px; background: var(--c1-surface, #EDECEA); border-radius: 4px; overflow: hidden; }
.c1-vbar-fill { min-width: 8px; height: 100%; border-radius: 4px; display: flex; align-items: center; transition: width .4s; }
.c1-vbar-val { font-size: 9px; font-weight: 700; color: #fff; padding: 0 4px; white-space: nowrap; }

/* 7-day */
.c1-7day-chart { display: flex; align-items: flex-end; gap: 6px; padding: 0 14px; height: 56px; }
.c1-7day-col { display: flex; flex-direction: column; align-items: center; flex: 1; }
.c1-7day-bars { display: flex; align-items: flex-end; gap: 2px; height: 44px; }
.c1-7day-bar { width: 8px; border-radius: 2px 2px 0 0; min-height: 2px; transition: height .3s; }
.c1-7day-bar.due { background: #fa8100; }
.c1-7day-bar.done { background: #2D9D5E; }
.c1-7day-lbl { font-size: 9px; font-weight: 600; color: var(--c1-t3, #A09E98); margin-top: 3px; }
.c1-7day-legend { display: flex; align-items: center; padding: 4px 14px 0; gap: 4px; }

/* ── Calendar panel ───────────────────────────────────────────── */
.c1-panel-cal { width: 320px; }
.c1-cal-nav { display: flex; gap: 2px; margin-left: auto; }
.c1-cal-nav-btn {
  width: 28px; height: 28px; border: none; background: var(--c1-surface, #EDECEA);
  border-radius: 6px; cursor: pointer; font-size: 14px; font-weight: 700;
  color: var(--c1-t1, #2C2925); display: flex; align-items: center; justify-content: center;
}
.c1-cal-grid-head {
  display: grid; grid-template-columns: repeat(7, 1fr);
  padding: 8px 10px 4px; gap: 2px;
}
.c1-cal-dh { text-align: center; font-size: 9px; font-weight: 700; color: var(--c1-t3, #A09E98); text-transform: uppercase; }
.c1-cal-grid {
  display: grid; grid-template-columns: repeat(7, 1fr);
  padding: 0 10px; gap: 2px;
}
.c1-cal-cell {
  aspect-ratio: 1; display: flex; flex-direction: column; align-items: center;
  justify-content: flex-start; padding: 4px 2px 2px;
  border-radius: 6px; cursor: default; transition: background .1s;
  border: 1px solid transparent;
}
.c1-cal-has { cursor: pointer; }
.c1-cal-has:hover { background: var(--c1-surface, #EDECEA); }
.c1-cal-off { opacity: .3; }
.c1-cal-today { border-color: #fa8100; }
.c1-cal-dn { font-size: 10px; font-weight: 600; color: var(--c1-t1, #2C2925); }
.c1-cal-off .c1-cal-dn { color: var(--c1-t3, #A09E98); }
.c1-cal-today .c1-cal-dn { color: #fa8100; }
.c1-cal-dots { display: flex; gap: 2px; flex-wrap: wrap; justify-content: center; margin-top: 2px; }
.c1-cal-dot { width: 5px; height: 5px; border-radius: 50%; background: #fa8100; flex-shrink: 0; }
.c1-cal-dot-red    { background: #E05A3A !important; }
.c1-cal-dot-yellow { background: #E8891C !important; }
.c1-cal-dot-green  { background: #2D9D5E !important; }
.c1-cal-legend { display: flex; align-items: center; gap: 6px; padding: 6px 14px; font-size: 10px; color: var(--c1-t2, #7A7067); }
.c1-cal-day-tasks { padding: 6px 10px; border-top: 1px solid var(--c1-border, #E6E3DE); }
.c1-cal-task-row {
  display: flex; align-items: center; gap: 6px;
  padding: 5px 0; border-bottom: 1px solid var(--c1-border, #E6E3DE);
  cursor: pointer;
}
.c1-cal-task-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.c1-cal-task-title { flex: 1; font-size: 11px; color: var(--c1-t1, #2C2925); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

/* ── Viki panel ───────────────────────────────────────────────── */
.c1-viki-msg-row {
  display: flex; align-items: flex-start; gap: 8px;
  padding: 10px 14px; border-bottom: 1px solid var(--c1-border, #E6E3DE);
}
.c1-viki-msg-icon { flex-shrink: 0; margin-top: 2px; }
.c1-viki-msg-body { font-size: 12px; line-height: 1.5; color: var(--c1-t1, #2C2925); }
.c1-viki-msg-warn  .c1-viki-msg-icon { color: #E05A3A; }
.c1-viki-msg-warn  { background: #FFF8F7; }
.c1-viki-msg-ok    .c1-viki-msg-icon { color: #2D9D5E; }
.c1-viki-msg-ok    { background: #F4FDF8; }
.c1-viki-msg-info  .c1-viki-msg-icon { color: #4275ec; }
.c1-viki-notif {
  display: block; width: 7px; height: 7px; border-radius: 50%;
  background: #E05A3A; position: absolute; top: 4px; right: 4px;
}
.c1-viki-btn { position: relative; }

/* ── Create task slide-from-left ──────────────────────────────── */
.c1-slide-left-enter-active, .c1-slide-left-leave-active { transition: transform .25s ease; }
.c1-slide-left-enter, .c1-slide-left-leave-to { transform: translateX(-100%); }
.c1-create-wrap {
  position: fixed; inset: 0; z-index: 2000;
  background: transparent;
  display: flex; align-items: stretch;
}
.c1-create-panel {
  width: 340px; max-width: 92vw;
  background: var(--c1-bg, #F7F6F3);
  display: flex; flex-direction: column;
  box-shadow: 4px 0 24px rgba(0,0,0,.18);
  overflow: hidden;
}
.c1-create-body {
  flex: 1; overflow-y: auto; padding: 10px 14px;
  display: flex; flex-direction: column; gap: 10px;
}
.c1-create-field { display: flex; flex-direction: column; gap: 5px; }
.c1-create-lbl { font-size: 11px; font-weight: 700; color: var(--c1-t2, #7A7067); text-transform: uppercase; letter-spacing: .5px; }
.c1-create-input, .c1-create-select, .c1-create-textarea {
  padding: 7px 10px; border: 1.5px solid var(--c1-border, #E6E3DE);
  border-radius: 8px; font-size: 12px; font-family: inherit;
  color: var(--c1-t1, #2C2925); background: var(--c1-surface, #EDECEA);
  transition: border-color .15s;
}
.c1-create-input:focus, .c1-create-select:focus, .c1-create-textarea:focus {
  outline: none; border-color: #fa8100;
}
.c1-create-textarea { resize: vertical; }
.c1-create-sub-row {
  display: flex; align-items: center; gap: 6px; margin-top: 4px;
}
.c1-create-sub-input {
  flex: 1; padding: 5px 8px; border: 1.5px solid var(--c1-border, #E6E3DE);
  border-radius: 6px; font-size: 11px; font-family: inherit;
  background: var(--c1-bg, #F7F6F3); color: var(--c1-t1, #2C2925);
}
.c1-create-sub-del {
  width: 20px; height: 20px; display: flex; align-items: center; justify-content: center;
  background: #FFF2EE; border: none; border-radius: 4px; cursor: pointer; color: #E05A3A;
  flex-shrink: 0;
}
.c1-add-sub-btn {
  padding: 2px 8px; background: #FFF4E8; color: #fa8100; border: 1px solid #fa8100;
  border-radius: 5px; font-size: 10px; font-weight: 700; cursor: pointer;
}
.c1-attach-btn {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 6px 12px; background: var(--c1-surface, #EDECEA);
  border: 1.5px dashed var(--c1-border, #E6E3DE); border-radius: 8px;
  font-size: 11px; font-weight: 600; color: var(--c1-t2, #7A7067);
  cursor: pointer; transition: border-color .15s;
}
.c1-attach-btn:hover { border-color: #fa8100; color: #fa8100; }
.c1-attached-name { font-size: 10px; color: #2D9D5E; margin-top: 2px; }

/* ── Detail drawer (right) ────────────────────────────────────── */
.c1-drawer-wrap {
  position: fixed; inset: 0; z-index: 1900;
  background: transparent;
  display: flex; justify-content: flex-end;
}
.c1-drawer {
  width: 360px; max-width: 94vw;
  background: var(--c1-bg, #F7F6F3);
  display: flex; flex-direction: column;
  box-shadow: -4px 0 24px rgba(0,0,0,.15);
  overflow: hidden;
}
.c1-drawer-enter-active, .c1-drawer-leave-active { transition: transform .25s ease; }
.c1-drawer-enter, .c1-drawer-leave-to { transform: translateX(100%); }
.c1-drawer-head {
  display: flex; align-items: center; gap: 10px;
  padding: 14px 14px 10px;
  border-bottom: 1px solid var(--c1-border, #E6E3DE);
  flex-shrink: 0;
}
.c1-drawer-av {
  width: 36px; height: 36px; border-radius: 9px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  font-size: 9px; font-weight: 800; color: #fff; letter-spacing: .5px;
}
.c1-drawer-title { flex: 1; overflow: hidden; }
.c1-drawer-name { font-size: 13px; font-weight: 700; color: var(--c1-t1, #2C2925); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.c1-drawer-sub  { font-size: 10px; color: var(--c1-t3, #A09E98); margin-top: 2px; }
.c1-drawer-close {
  width: 28px; height: 28px; display: flex; align-items: center; justify-content: center;
  background: var(--c1-surface, #EDECEA); border: none; border-radius: 7px;
  cursor: pointer; color: var(--c1-t2, #7A7067); flex-shrink: 0;
}
.c1-drawer-body { flex: 1; overflow-y: auto; }

.c1-exp-sec { padding: 10px 0 0; }
.c1-exp-lbl { font-size: 10px; font-weight: 700; color: var(--c1-t3, #A09E98); text-transform: uppercase; letter-spacing: .7px; padding: 0 14px 6px; }
.c1-exp-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; padding: 0 14px; }
.c1-exp-field { display: flex; flex-direction: column; gap: 2px; }
.c1-exp-full { grid-column: 1 / -1; }
.c1-exp-fl { font-size: 9px; font-weight: 600; color: var(--c1-t3, #A09E98); text-transform: uppercase; }
.c1-exp-fv { font-size: 12px; color: var(--c1-t1, #2C2925); }

.c1-exp-activity-row {
  display: flex; align-items: center; gap: 8px;
  padding: 5px 14px; border-bottom: 1px solid var(--c1-border, #E6E3DE);
}
.c1-exp-a-badge {
  width: 28px; height: 28px; border-radius: 7px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  font-size: 8px; font-weight: 800;
}
.c1-exp-a-body { flex: 1; overflow: hidden; }
.c1-exp-a-date { font-size: 10px; color: var(--c1-t3, #A09E98); flex-shrink: 0; }

/* status change */
.c1-drawer-status-row { display: flex; flex-wrap: wrap; gap: 6px; padding: 0 14px; }
.c1-dsr-btn {
  padding: 5px 10px; border-radius: 7px; border: 1.5px solid var(--c1-border, #E6E3DE);
  font-size: 11px; font-weight: 600; cursor: pointer; background: transparent; transition: all .15s;
}
.c1-dsr-btn.act     { color: #fa8100; } .c1-dsr-btn.act:hover     { background: #FFF4E8; border-color: #fa8100; }
.c1-dsr-btn.wait    { color: #4275ec; } .c1-dsr-btn.wait:hover    { background: #EEF2FF; border-color: #4275ec; }
.c1-dsr-btn.outline { color: #7C5CFC; } .c1-dsr-btn.outline:hover { background: #F0ECFF; border-color: #7C5CFC; }
.c1-dsr-btn.done    { color: #2D9D5E; } .c1-dsr-btn.done:hover    { background: #EDFAF4; border-color: #2D9D5E; }
.c1-dsr-btn:disabled { opacity: .4; cursor: not-allowed; }
.c1-dsr-ack {
  display: flex; align-items: center; gap: 6px;
  margin: 8px 14px 0; padding: 6px 10px;
  background: #EDFAF4; border-radius: 7px;
  font-size: 11px; color: #2D9D5E;
}
.c1-dsr-ack svg { width: 12px; height: 12px; }

/* priority selector */
.c1-drawer-pri-row { display: flex; gap: 6px; padding: 0 14px; }
.c1-drawer-pri {
  flex: 1; display: flex; align-items: center; justify-content: center; gap: 4px;
  padding: 6px 4px; border-radius: 8px; border: 1.5px solid var(--c1-border, #E6E3DE);
  font-size: 11px; font-weight: 600; color: var(--c1-t2, #7A7067); cursor: pointer; transition: all .15s;
}
.c1-drawer-pri svg { width: 12px; height: 12px; }
.c1-drawer-pri.on { background: var(--pc); color: #fff; border-color: var(--pc); }
.c1-drawer-pri:not(.on):hover { border-color: var(--pc); color: var(--pc); }

/* complete btn */
.c1-drawer-complete-btn {
  display: flex; align-items: center; justify-content: center; gap: 6px;
  margin: 0 14px; width: calc(100% - 28px); padding: 9px;
  background: #EDFAF4; color: #2D9D5E; border: 1.5px solid #2D9D5E;
  border-radius: 9px; font-size: 12px; font-weight: 700; cursor: pointer; transition: all .15s;
}
.c1-drawer-complete-btn:hover { background: #2D9D5E; color: #fff; }

/* comment */
.c1-drawer-comment-wrap { padding: 0 14px; display: flex; flex-direction: column; gap: 6px; }
.c1-drawer-comment {
  width: 100%; box-sizing: border-box; padding: 8px 10px;
  border-radius: 8px; border: 1.5px solid var(--c1-border, #E6E3DE);
  font-size: 12px; font-family: inherit; color: var(--c1-t1, #2C2925);
  background: var(--c1-bg, #F7F6F3); resize: none; transition: border-color .15s;
}
.c1-drawer-comment:focus { outline: none; border-color: #fa8100; }
.c1-drawer-comment-send {
  align-self: flex-end; display: flex; align-items: center; gap: 5px;
  padding: 6px 14px; background: #fa8100; color: #fff; border: none;
  border-radius: 7px; font-size: 11px; font-weight: 700; cursor: pointer; transition: opacity .15s;
}
.c1-drawer-comment-send:disabled { opacity: .4; cursor: not-allowed; }

/* submit btn */
.c1-pkf-submit {
  display: flex; align-items: center; justify-content: center;
  padding: 10px; background: #fa8100; color: #fff; border: none;
  border-radius: 9px; font-size: 13px; font-weight: 700; cursor: pointer; transition: opacity .15s;
  width: 100%;
}
.c1-pkf-submit:disabled { opacity: .4; cursor: not-allowed; }
.c1-pkf-submit:hover:not(:disabled) { opacity: .88; }

/* transfer row */
.c1-transfer-row { display: flex; gap: 8px; padding: 0 14px; }

/* content */
.c1-t1-drawer-content {
  padding: 0 14px;
  font-size: 12px; line-height: 1.6;
  color: var(--c1-t1, #2C2925); word-break: break-word;
}

/* ── Announcement tab ─────────────────────────────────────────── */
.c1-announce-list { padding: 10px; display: flex; flex-direction: column; gap: 10px; }
.c1-ann-card {
  background: var(--c1-surface, #EDECEA); border-radius: 12px;
  overflow: hidden; border: 1.5px solid var(--c1-border, #E6E3DE);
}
.c1-ann-head {
  display: flex; align-items: center; gap: 8px; padding: 10px 12px 6px;
}
.c1-ann-badge {
  background: #F0ECFF; color: #7C5CFC; font-size: 9px; font-weight: 800;
  padding: 2px 6px; border-radius: 5px; flex-shrink: 0;
}
.c1-ann-title { flex: 1; font-size: 13px; font-weight: 700; color: var(--c1-t1, #2C2925); }
.c1-ann-date  { font-size: 10px; color: var(--c1-t3, #A09E98); flex-shrink: 0; }
.c1-ann-body  { padding: 0 12px 8px; font-size: 12px; color: var(--c1-t2, #7A7067); line-height: 1.5; }
.c1-ann-stats { display: flex; flex-wrap: wrap; gap: 6px; padding: 0 12px 8px; }
.c1-ann-stat  { display: flex; align-items: center; gap: 4px; font-size: 10px; font-weight: 600; padding: 2px 7px; border-radius: 8px; }
.c1-ann-stat.ok     { background: #EDFAF4; color: #2D9D5E; }
.c1-ann-stat.info   { background: #EEF2FF; color: #4275ec; }
.c1-ann-stat.done   { background: #F0ECFF; color: #7C5CFC; }
.c1-ann-stat.pending{ background: #FFF4E8; color: #fa8100; }
.c1-ann-reply-row { display: flex; gap: 6px; padding: 0 12px 10px; flex-wrap: wrap; }
.c1-ann-btn {
  padding: 5px 12px; border-radius: 7px; font-size: 11px; font-weight: 700;
  border: 1.5px solid; cursor: pointer; background: transparent; transition: all .15s;
}
.c1-ann-btn.understood { color: #2D9D5E; border-color: #2D9D5E; }
.c1-ann-btn.understood:hover { background: #2D9D5E; color: #fff; }
.c1-ann-btn.more-info  { color: #4275ec; border-color: #4275ec; }
.c1-ann-btn.more-info:hover  { background: #4275ec; color: #fff; }
.c1-ann-btn.done       { color: #7C5CFC; border-color: #7C5CFC; }
.c1-ann-btn.done:hover { background: #7C5CFC; color: #fff; }
.c1-ann-replied {
  display: flex; align-items: center; gap: 6px;
  margin: 0 12px 10px; padding: 5px 10px;
  background: #EDFAF4; border-radius: 7px; font-size: 11px; color: #2D9D5E;
}
.c1-ann-who { display: flex; align-items: center; gap: 4px; padding: 0 12px 10px; flex-wrap: wrap; }
.c1-ann-who-lbl { font-size: 10px; font-weight: 600; color: var(--c1-t3, #A09E98); margin-right: 4px; }

/* ── Modal (transfer) ─────────────────────────────────────────── */
.c1-modal-wrap {
  position: fixed; inset: 0; z-index: 3000;
  background: rgba(0,0,0,.4);
  display: flex; align-items: center; justify-content: center;
}
.c1-modal {
  background: var(--c1-bg, #F7F6F3); border-radius: 14px;
  padding: 20px; width: 300px; max-width: 90vw;
  box-shadow: 0 8px 40px rgba(0,0,0,.25);
  display: flex; flex-direction: column; gap: 12px;
}
.c1-modal-ttl { font-size: 14px; font-weight: 700; color: var(--c1-t1, #2C2925); }
.c1-modal-actions { display: flex; justify-content: flex-end; gap: 8px; }

/* ── Toast ────────────────────────────────────────────────────── */
.t1-toast {
  position: fixed; bottom: 28px; left: 50%; transform: translateX(-50%);
  z-index: 99999; padding: 10px 22px; border-radius: 24px; color: #fff;
  font-size: .85rem; font-weight: 600;
  box-shadow: 0 4px 20px rgba(0,0,0,.25); pointer-events: none;
  white-space: nowrap; height: auto; display: inline-flex; align-items: center;
}
.t1-toast-fade-enter-active, .t1-toast-fade-leave-active { transition: opacity .25s, transform .25s; }
.t1-toast-fade-enter, .t1-toast-fade-leave-to { opacity: 0; transform: translateX(-50%) translateY(10px); }

/* ── Filter panel extras ──────────────────────────────────────── */
.c1-fs-search-wrap {
  position: relative; display: flex; align-items: center;
  margin: 8px 12px; background: var(--c1-bg, #F7F6F3);
  border: 1.5px solid var(--c1-border, #E6E3DE); border-radius: 9px; overflow: hidden;
}
.c1-fp-sico { width: 14px; height: 14px; margin: 0 8px; flex-shrink: 0; stroke: var(--c1-t3, #A09E98); fill: none; }
.c1-fp-sinput { flex: 1; border: none; background: transparent; font-size: 12px; padding: 7px 6px 7px 0; font-family: inherit; color: var(--c1-t1, #2C2925); outline: none; }
.c1-fp-sclear { width: 28px; height: 28px; display: flex; align-items: center; justify-content: center; cursor: pointer; color: var(--c1-t3, #A09E98); flex-shrink: 0; }
.c1-fp-sclear svg { width: 12px; height: 12px; stroke: currentColor; fill: none; }

.c1-fs-section-lbl { font-size: 10px; font-weight: 700; color: var(--c1-t3, #A09E98); text-transform: uppercase; letter-spacing: .7px; padding: 6px 14px 4px; }
.c1-fs-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; padding: 0 12px 8px; }
.c1-fs-grid-3 { grid-template-columns: 1fr 1fr 1fr; }
.c1-fs-grid-2 { grid-template-columns: 1fr 1fr; }
.c1-fs-card {
  background: var(--c1-bg, #F7F6F3); border-radius: 9px;
  border: 1.5px solid var(--c1-border, #E6E3DE); padding: 8px 10px;
  display: flex; flex-direction: column; gap: 2px; cursor: pointer; transition: all .15s;
}
.c1-fs-card.on, .c1-fs-card:hover { border-color: var(--fsclr, #fa8100); background: color-mix(in srgb, var(--fsclr, #fa8100) 10%, white); }
.c1-fs-name { font-size: 11px; font-weight: 600; color: var(--c1-t2, #7A7067); }
.c1-fs-num  { font-size: 18px; font-weight: 800; color: var(--c1-t1, #2C2925); }
.c1-fs-card.on .c1-fs-name, .c1-fs-card.on .c1-fs-num { color: var(--fsclr, #fa8100); }

.c1-fs-scard {
  padding: 7px 10px; background: var(--c1-bg, #F7F6F3);
  border: 1.5px solid var(--c1-border, #E6E3DE); border-radius: 8px;
  font-size: 11px; font-weight: 700; color: var(--c1-t2, #7A7067);
  cursor: pointer; text-align: center; display: flex; align-items: center; justify-content: center; gap: 4px;
  transition: all .15s;
}
.c1-fs-scard.on, .c1-fs-scard:hover { background: var(--fsclr, #fa8100); color: #fff; border-color: var(--fsclr, #fa8100); }
.c1-fs-scard-wide { grid-column: 1 / -1; }

.c1-fs-toggle { display: flex; gap: 4px; padding: 0 12px 8px; }
.c1-fs-tog-btn {
  flex: 1; padding: 6px 4px; text-align: center;
  background: var(--c1-surface, #EDECEA); border: 1.5px solid var(--c1-border, #E6E3DE);
  border-radius: 7px; font-size: 11px; font-weight: 600; cursor: pointer; color: var(--c1-t2, #7A7067); transition: all .15s;
}
.c1-fs-tog-btn.on { background: #fa8100; color: #fff; border-color: #fa8100; }

.c1-fs-agent-hdr { display: flex; align-items: center; justify-content: space-between; }
.c1-fs-agent-count { background: #fa8100; color: #fff; font-size: 9px; font-weight: 700; padding: 1px 5px; border-radius: 8px; margin-left: 6px; }
.c1-fs-agent-clear { font-size: 11px; color: #E05A3A; cursor: pointer; padding: 0 14px; font-weight: 600; }

.c1-agent-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 5px; padding: 0 12px 8px; }
.c1-agent-chip {
  display: flex; flex-direction: column; align-items: center; gap: 4px;
  padding: 8px 4px; border-radius: 9px;
  border: 1.5px solid var(--c1-border, #E6E3DE);
  background: var(--c1-bg, #F7F6F3); cursor: pointer; transition: all .15s;
}
.c1-agent-chip.on { border-color: #fa8100; background: #FFF4E8; }
.c1-agent-av {
  width: 30px; height: 30px; border-radius: 50%; background: var(--c1-surface, #EDECEA);
  display: flex; align-items: center; justify-content: center;
  font-size: 11px; font-weight: 700; color: var(--c1-t1, #2C2925);
}
.c1-agent-chip.on .c1-agent-av { background: #fa8100; color: #fff; }
.c1-agent-nm { font-size: 10px; font-weight: 600; color: var(--c1-t2, #7A7067); text-align: center; line-height: 1.2; word-break: break-word; }
.c1-agent-cnt { font-size: 10px; font-weight: 700; color: var(--c1-t3, #A09E98); }

.c1-date-range-row { display: flex; align-items: center; gap: 8px; }
.c1-date-sep { font-size: 11px; color: var(--c1-t3, #A09E98); flex-shrink: 0; }
.c1-date-input {
  flex: 1; padding: 6px 8px; border: 1.5px solid var(--c1-border, #E6E3DE);
  border-radius: 7px; font-size: 11px; font-family: inherit;
  background: var(--c1-bg, #F7F6F3); color: var(--c1-t1, #2C2925);
}
.c1-date-input:focus { outline: none; border-color: #fa8100; }

.c1-reset-bar {
  display: flex; align-items: center; gap: 7px;
  margin: 6px 12px; padding: 7px 10px;
  background: #FFF2EE; border-radius: 8px;
  font-size: 11px; font-weight: 600; color: #E05A3A; cursor: pointer;
}
.c1-reset-bar svg { width: 13px; height: 13px; stroke: #E05A3A; fill: none; }
.c1-reset-bar-count { margin-left: auto; background: #E05A3A; color: #fff; font-size: 10px; font-weight: 700; padding: 1px 5px; border-radius: 8px; }

.c1-ftab-menu {
  display: flex; overflow-x: auto; padding: 6px 10px 0; gap: 2px;
  border-bottom: 1px solid var(--c1-border, #E6E3DE);
}
.c1-ftab-mi {
  flex-shrink: 0; display: flex; align-items: center; gap: 4px;
  padding: 5px 8px; border-radius: 6px 6px 0 0;
  font-size: 10px; font-weight: 700; color: var(--c1-t2, #7A7067);
  cursor: pointer; transition: all .15s; position: relative;
}
.c1-ftab-mi svg { width: 12px; height: 12px; stroke: currentColor; fill: none; }
.c1-ftab-mi.on { background: var(--c1-bg, #F7F6F3); color: #fa8100; border-bottom: 2px solid #fa8100; }
.c1-ftab-badge {
  background: #fa8100; color: #fff; font-size: 9px; font-weight: 700;
  padding: 1px 4px; border-radius: 6px; margin-left: 2px;
}

/* panel header bar */
.c1-panel-hdr-bar {
  display: flex; align-items: center; gap: 8px; padding: 12px 14px 8px;
  border-bottom: 1px solid var(--c1-border, #E6E3DE);
}
.c1-panel-hdr-bar svg { width: 16px; height: 16px; stroke: var(--c1-t2, #7A7067); fill: none; flex-shrink: 0; }
.c1-panel-hdr-ttl { font-size: 14px; font-weight: 700; color: var(--c1-t1, #2C2925); }
.c1-panel-hdr-count { font-size: 10px; color: var(--c1-t3, #A09E98); margin-left: 2px; }
.c1-collapse-btn {
  margin-left: auto; width: 28px; height: 28px;
  display: flex; align-items: center; justify-content: center;
  background: var(--c1-surface, #EDECEA); border-radius: 7px; cursor: pointer;
  color: var(--c1-t2, #7A7067);
}
.c1-collapse-btn svg { width: 14px; height: 14px; stroke: currentColor; fill: none; }

.c1-collapse-bar {
  display: flex; align-items: center; justify-content: center; gap: 6px;
  padding: 10px; font-size: 11px; font-weight: 600; color: var(--c1-t2, #7A7067);
  cursor: pointer; border-top: 1px solid var(--c1-border, #E6E3DE);
  transition: background .15s; flex-shrink: 0;
}
.c1-collapse-bar svg { width: 14px; height: 14px; stroke: currentColor; fill: none; }
.c1-collapse-bar:hover { background: var(--c1-surface, #EDECEA); }

/* panel general */
/* .c1-panel positioning handled globally by c1-design.css */
.c1-panel.c1-panel--open { transform: translateX(0); }
/* .c1-panel-backdrop — defined globally in c1-design.css */
.c1-sl-body { flex: 1; overflow-y: auto; }

/* pagination */
.c1-pg-bar {
  display: flex; align-items: center; gap: 4px;
  padding: 5px 10px; background: var(--c1-bg, #F7F6F3);
  border-bottom: 1px solid var(--c1-border, #E6E3DE); flex-shrink: 0;
}
.c1-pg-btn {
  width: 28px; height: 28px; display: flex; align-items: center; justify-content: center;
  border-radius: 7px; cursor: pointer; background: var(--c1-surface, #EDECEA);
  transition: background .15s;
}
.c1-pg-btn svg { width: 13px; height: 13px; stroke: var(--c1-t1, #2C2925); fill: none; }
.c1-pg-btn.disabled { opacity: .35; cursor: not-allowed; }
.c1-pg-info { font-size: 11px; color: var(--c1-t2, #7A7067); }
.c1-pg-sep  { width: 1px; height: 14px; background: var(--c1-border, #E6E3DE); }
.c1-hp { flex: 1; }

/* loading */
.c1-loading { display: flex; flex-direction: column; align-items: center; padding: 40px; }
.c1-spinner {
  width: 28px; height: 28px; border-radius: 50%;
  border: 3px solid var(--c1-border, #E6E3DE);
  border-top-color: #fa8100;
  animation: c1-spin .7s linear infinite;
}
@keyframes c1-spin { to { transform: rotate(360deg); } }

/* empty state */
.c1-empty { display: flex; flex-direction: column; align-items: center; padding: 50px 20px; }
.c1-empty-icon { width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; background: var(--c1-surface, #EDECEA); border-radius: 14px; margin-bottom: 12px; }
.c1-empty-icon svg { width: 22px; height: 22px; stroke: var(--c1-t3, #A09E98); fill: none; }
.c1-empty-msg { font-size: 13px; color: var(--c1-t3, #A09E98); font-weight: 600; }

/* mono */
.c1-mono { font-family: "SF Mono", "Fira Mono", monospace; }

/* toast */
.c1-tib-badge {
  background: #E05A3A; color: #fff; font-size: 9px; font-weight: 700;
  padding: 1px 4px; border-radius: 6px; margin-left: 2px;
}

/* ── Quick-action buttons in panel nav ── */
.c1-psel-action-row { display:flex; gap:6px; padding:8px 10px 4px; }
.c1-psel-action-btn { flex:1; display:flex; align-items:center; justify-content:center; gap:5px; padding:7px 8px; font-size:11px; font-weight:600; color:#fff; background:#7C5CFC; border-radius:7px; cursor:pointer; transition:background .15s; }
.c1-psel-action-btn:hover { background:#6a4fe0; }
.c1-psel-action-btn svg { width:13px; height:13px; stroke:currentColor; fill:none; stroke-width:2; }
.c1-psel-action-announce { background:#E05A3A; }
.c1-psel-action-announce:hover { background:#cc4e30; }
.c1-psel-action-outline { background:#7C5CFC; }
.c1-psel-action-outline:hover { background:#6a4fe0; }
.c1-psel-action-events { background:#1144bc; }
.c1-psel-action-events:hover { background:#0d389a; }

/* ── Compact status strip ── */
.c1-status-strip { display:flex; align-items:center; height:36px; padding:0 12px 0 calc(var(--gnm-sw,220px) + 12px); background:#fff; border-bottom:1px solid var(--c1-border); gap:8px; }
.c1-status-pill { display:flex; align-items:center; gap:6px; padding:3px 10px 3px 7px; border-radius:20px; font-size:12px; font-weight:600; background:#F6F5F3; }
.c1-sp-dot { width:7px; height:7px; border-radius:50%; background:currentColor; flex-shrink:0; }
.c1-sp-lbl { color:var(--c1-t1); }
.c1-sp-count { background:rgba(0,0,0,.08); border-radius:10px; padding:1px 6px; font-size:10px; }
/* status pill color variants */
.c1-sp-active .c1-sp-dot { background:#fa8100; }
.c1-sp-waiting .c1-sp-dot { background:#4275ec; }
.c1-sp-completed .c1-sp-dot { background:#2D9D5E; }
.c1-sp-outline .c1-sp-dot { background:#7C5CFC; }
.c1-sp-missed .c1-sp-dot { background:#E05A3A; }
.c1-sp-coming .c1-sp-dot { background:#E8891C; }
.c1-sp-announcements .c1-sp-dot { background:#7C5CFC; }
.c1-sp-events .c1-sp-dot { background:#1144bc; }
.c1-sp-today .c1-sp-dot { background:#fa8100; }
/* shortcut chips row */
.c1-ss-shortcuts { display:flex; gap:4px; }
.c1-ss-chip { display:flex; align-items:center; gap:4px; padding:3px 8px; font-size:10px; font-weight:500; color:var(--c1-t2); border-radius:12px; cursor:pointer; border:1px solid transparent; transition:all .12s; }
.c1-ss-chip:hover { background:#F0ECFF; color:#7C5CFC; }
.c1-ss-chip.on { background:#F0ECFF; color:#7C5CFC; border-color:#d6ceff; font-weight:700; }
.c1-ss-chip span { font-weight:700; opacity:.7; }
.c1-ss-done.on { background:#EBF7F0; color:#2D9D5E; border-color:#c3e8d5; }
.c1-ss-done:hover { background:#EBF7F0; color:#2D9D5E; }
.c1-ss-missed.on { background:#FFF2EE; color:#E05A3A; border-color:#ffd0c0; }
.c1-ss-missed:hover { background:#FFF2EE; color:#E05A3A; }

/* ── Gantt chart ── */
.c1-gantt-nav { display:flex; align-items:center; justify-content:space-between; padding:4px 14px 8px; }
.c1-gantt-wrap { overflow-x:auto; min-width:0; padding:0 14px; }
.c1-gantt-hdr { display:flex; margin-bottom:4px; }
.c1-gantt-name-col { width:90px; flex-shrink:0; }
.c1-gantt-days-col { flex:1; display:flex; }
.c1-gantt-day-tick { flex:1; font-size:9px; color:var(--c1-t3); text-align:center; min-width:0; }
.c1-gantt-row { display:flex; align-items:center; min-height:24px; margin-bottom:3px; }
.c1-gantt-name { width:90px; flex-shrink:0; font-size:10px; color:var(--c1-t2); white-space:nowrap; overflow:hidden; text-overflow:ellipsis; padding-right:6px; }
.c1-gantt-bar-col { flex:1; min-width:0; }
.c1-gantt-bar-track { position:relative; height:18px; background:var(--c1-border); border-radius:4px; overflow:hidden; }
.c1-gantt-bar { position:absolute; top:0; height:100%; border-radius:4px; min-width:4px; cursor:pointer; display:flex; align-items:center; transition:opacity .15s; }
.c1-gantt-bar:hover { opacity:.85; }
.c1-gantt-bar-lbl { font-size:9px; color:#fff; padding:0 4px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:100%; }
.c1-gantt-legend { display:flex; align-items:center; gap:4px; padding:8px 14px; font-size:10px; color:var(--c1-t2); }
.c1-gantt-leg-dot { display:inline-block; width:8px; height:8px; border-radius:2px; }

/* ── Activity log ── */
.c1-log-entry { display:flex; align-items:flex-start; gap:8px; padding:8px 14px; border-bottom:1px solid var(--c1-border); }
.c1-log-icon { width:22px; height:22px; border-radius:50%; display:flex; align-items:center; justify-content:center; flex-shrink:0; margin-top:1px; }
.c1-log-create { background:#F0ECFF; color:#7C5CFC; }
.c1-log-done { background:#EBF7F0; color:#2D9D5E; }
.c1-log-transfer { background:#FFF3E8; color:#E8891C; }
.c1-log-reply { background:#FFF6F4; color:#E05A3A; }
.c1-log-log { background:#F2F1F0; color:var(--c1-t3); }
.c1-log-body { flex:1; min-width:0; }
.c1-log-msg { font-size:11px; color:var(--c1-t1); line-height:1.4; }
.c1-log-meta { font-size:10px; color:var(--c1-t3); margin-top:2px; }
.c1-log-task { cursor:pointer; color:#7C5CFC; }
.c1-log-task:hover { text-decoration:underline; }
.c1-log-time { font-size:9px; color:var(--c1-t3); white-space:nowrap; }

/* ── Agent bar chart ── */
.c1-agent-bar-row { display:flex; align-items:center; gap:8px; padding:4px 14px; }
.c1-agent-bar-name { width:70px; flex-shrink:0; font-size:10px; color:var(--c1-t2); white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.c1-agent-bar-track { flex:1; height:12px; background:var(--c1-border); border-radius:3px; overflow:hidden; }
.c1-agent-bar-fill { height:100%; background:#7C5CFC; border-radius:3px; transition:width .3s; }
.c1-agent-bar-num { width:24px; text-align:right; font-size:10px; font-weight:600; color:var(--c1-t1); }

/* ── Replies thread ── */
.c1-replies-thread { padding:6px 0; }
.c1-reply-row { display:flex; align-items:flex-start; gap:8px; padding:6px 14px; }
.c1-reply-mine { flex-direction:row-reverse; }
.c1-reply-av { width:26px; height:26px; border-radius:50%; background:#7C5CFC; color:#fff; font-size:9px; font-weight:700; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
.c1-reply-bubble { max-width:80%; background:var(--c1-border); border-radius:10px; padding:6px 10px; }
.c1-reply-mine .c1-reply-bubble { background:#F0ECFF; }
.c1-reply-name { font-size:9px; font-weight:600; color:var(--c1-t2); margin-bottom:2px; }
.c1-reply-text { font-size:11px; color:var(--c1-t1); line-height:1.4; }
.c1-reply-time { font-size:9px; color:var(--c1-t3); margin-top:3px; }

/* ── Multi-assignee & hierarchy ── */
.c1-ag-more { font-size:9px; color:var(--c1-t3); font-weight:600; margin-left:2px; }
.c1-hierarchy-badge { display:inline-flex; align-items:center; gap:2px; font-size:9px; color:var(--c1-dp); background:#F0ECFF; border-radius:8px; padding:1px 5px; margin-left:4px; font-weight:600; }
.c1-assignee-pill { display:inline-block; background:#F0ECFF; color:#7C5CFC; border-radius:8px; padding:2px 7px; font-size:10px; font-weight:600; }

/* ════════════════════════════════════════════════════════════════════════════
   MAESTRO DESIGN SYSTEM BRIDGE
   Maps marketing-site design tokens onto all Tasks1 components.
   Only uses !important where needed to override existing specificity.
   ════════════════════════════════════════════════════════════════════════════ */

/* ── 1. Design tokens ───────────────────────────────────────────────────── */
:root {
  /* Base surface / border / text */
  --c1-bg:       #f8fafc;
  --c1-surface:  #f1f5f9;
  --c1-border:   #e2e8f0;
  --c1-t1:       #06080f;
  --c1-t2:       #64748b;
  --c1-t3:       #94a3b8;
  --c1-dp:       #7c3aed;
  /* Maestro accent palette */
  --m-blue:      #0057ff;
  --m-blue-dim:  #eef3ff;
  --m-blue-mid:  #c7d7ff;
  --m-purple:    #7c3aed;
  --m-green:     #00b67a;
  --m-gold:      #f59e0b;
  --m-red:       #ef4444;
  --m-ink:       #06080f;
  --m-muted:     #64748b;
  --m-faint:     #94a3b8;
  --m-rule:      #e2e8f0;
  /* Typography */
  --m-font:      'DM Sans', system-ui, sans-serif;
  --m-display:   'Plus Jakarta Sans', 'DM Sans', system-ui, sans-serif;
  --m-mono:      'DM Mono', monospace;
}

/* ── 2. Base font ───────────────────────────────────────────────────────── */
[class*="c1-"] { font-family: var(--m-font); }

/* ── 3. Tab bar — pill style (mirrors .mod-tab) ─────────────────────────── */
.c1-t1-tabs { padding: 8px 10px; gap: 4px; }
.c1-t1-tab {
  border-radius: 50px !important;
  padding: 6px 14px !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  background: var(--c1-surface) !important;
  color: var(--m-muted) !important;
  transition: all .2s !important;
}
.c1-t1-tab:hover                { background: var(--m-blue-dim) !important; color: var(--m-ink) !important; }
.c1-t1-tab.on                   { background: var(--m-blue) !important; color: #fff !important;
                                   box-shadow: 0 2px 8px rgba(0,87,255,.25), 0 0 0 4px rgba(0,87,255,.08) !important; }
.c1-t1-tab-missed.on            { background: var(--m-red) !important;
                                   box-shadow: 0 2px 8px rgba(239,68,68,.25), 0 0 0 4px rgba(239,68,68,.08) !important; }
.c1-t1-tab-coming.on            { background: var(--m-gold) !important;
                                   box-shadow: 0 2px 8px rgba(245,158,11,.25), 0 0 0 4px rgba(245,158,11,.08) !important; }
.c1-t1-tab-announce.on          { background: var(--m-purple) !important;
                                   box-shadow: 0 2px 8px rgba(124,58,237,.25), 0 0 0 4px rgba(124,58,237,.08) !important; }
.c1-t1-tc.red   { color: var(--m-red) !important; }
.c1-t1-tc.orange{ color: var(--m-gold) !important; }
.c1-t1-tc.green { color: var(--m-green) !important; }
.c1-t1-new      { background: var(--m-red) !important; }

/* Filter tab menu */
.c1-ftab-mi.on   { color: var(--m-blue) !important; border-bottom-color: var(--m-blue) !important; }
.c1-ftab-badge   { background: var(--m-blue) !important; }

/* ── 4. Task card ───────────────────────────────────────────────────────── */
.c1-t1-title {
  font-family: var(--m-display) !important;
  font-weight: 700 !important;
}
.c1-t1-due   { color: var(--m-gold) !important; }

/* Status badges */
.c1-t1-bs-act  { background: #fffbeb !important; color: var(--m-gold) !important; }
.c1-t1-bs-wait { background: var(--m-blue-dim) !important; color: var(--m-blue) !important; }
.c1-t1-bs-done { background: #f0fdf4 !important; color: var(--m-green) !important; }
.c1-t1-bs-miss { background: #fef2f2 !important; color: var(--m-red) !important; }
.c1-t1-bs-soon { background: #fffbeb !important; color: var(--m-gold) !important; }

/* Priority left-border (Kanban style) */
.c1-t1-missed  { border-left: 3px solid var(--m-red) !important; }
.c1-t1-soon    { border-left: 3px solid var(--m-gold) !important; }

/* New-task btn */
.c1-t1-new-btn               { color: var(--m-blue) !important; }
.c1-t1-new-btn.c1-tib-btn svg{ stroke: var(--m-blue) !important; }
.c1-tib-badge                { background: var(--m-red) !important; }

/* ── 5. Hierarchy / assignee badges ─────────────────────────────────────── */
.c1-hierarchy-badge { background: #f5f3ff !important; color: var(--m-purple) !important; }
.c1-assignee-pill   { background: #f5f3ff !important; color: var(--m-purple) !important; }

/* ── 6. Status strip pills ──────────────────────────────────────────────── */
.c1-sp-active .c1-sp-dot        { background: var(--m-blue) !important; }
.c1-sp-today .c1-sp-dot         { background: var(--m-blue) !important; }
.c1-sp-waiting .c1-sp-dot       { background: var(--m-blue) !important; }
.c1-sp-completed .c1-sp-dot     { background: var(--m-green) !important; }
.c1-sp-outline .c1-sp-dot       { background: var(--m-purple) !important; }
.c1-sp-missed .c1-sp-dot        { background: var(--m-red) !important; }
.c1-sp-coming .c1-sp-dot        { background: var(--m-gold) !important; }
.c1-sp-announcements .c1-sp-dot { background: var(--m-purple) !important; }
.c1-sp-events .c1-sp-dot        { background: var(--m-blue) !important; }
.c1-status-pill                 { background: var(--c1-surface) !important; }

/* Shortcut chips */
.c1-ss-chip:hover,
.c1-ss-chip.on      { background: #f5f3ff !important; color: var(--m-purple) !important; border-color: #ddd6fe !important; }
.c1-ss-done.on,
.c1-ss-done:hover   { background: #f0fdf4 !important; color: var(--m-green) !important; border-color: #bbf7d0 !important; }
.c1-ss-missed.on,
.c1-ss-missed:hover { background: #fef2f2 !important; color: var(--m-red) !important; border-color: #fecaca !important; }

/* ── 7. Filter sidebar ──────────────────────────────────────────────────── */
/* Stat cards — infographic large number style */
.c1-fs-num {
  font-family: var(--m-mono) !important;
  font-size: 22px !important;
  font-weight: 800 !important;
  letter-spacing: -1px !important;
  color: var(--m-ink) !important;
}
.c1-fs-name {
  font-size: 9px !important;
  font-weight: 700 !important;
  letter-spacing: 1.5px !important;
  text-transform: uppercase !important;
  color: var(--m-faint) !important;
}
.c1-fs-card.on .c1-fs-num,
.c1-fs-card.on .c1-fs-name  { color: var(--m-blue) !important; }
.c1-fs-card.on,
.c1-fs-card:hover            { border-color: var(--m-blue) !important; background: var(--m-blue-dim) !important; }
.c1-fs-scard.on,
.c1-fs-scard:hover           { background: var(--m-blue) !important; border-color: var(--m-blue) !important; }
.c1-fs-agent-count           { background: var(--m-blue) !important; }
.c1-fs-agent-clear           { color: var(--m-red) !important; }
.c1-fs-tog-btn.on            { background: var(--m-blue) !important; border-color: var(--m-blue) !important; }

/* Section labels — mono uppercase (matches maestro .label pattern) */
.c1-exp-lbl,
.c1-create-lbl,
.c1-fs-section-lbl {
  font-family: var(--m-mono) !important;
  font-size: 9px !important;
  letter-spacing: 2px !important;
  text-transform: uppercase !important;
}

/* Reset bar */
.c1-reset-bar       { background: #fef2f2 !important; color: var(--m-red) !important; }
.c1-reset-bar svg   { stroke: var(--m-red) !important; }
.c1-reset-bar-count { background: var(--m-red) !important; }

/* ── 8. Agent chips & bars ──────────────────────────────────────────────── */
.c1-agent-chip.on            { border-color: var(--m-blue) !important; background: var(--m-blue-dim) !important; }
.c1-agent-chip.on .c1-agent-av { background: var(--m-blue) !important; }
.c1-agent-bar-fill           { background: linear-gradient(90deg, var(--m-blue), #4d8eff) !important; }

/* ── 9. Panel header — display font ─────────────────────────────────────── */
.c1-panel-hdr-ttl {
  font-family: var(--m-display) !important;
  font-size: 15px !important;
  font-weight: 800 !important;
  letter-spacing: -.3px !important;
}

/* ── 10. Detail drawer / create panel ───────────────────────────────────── */
.c1-create-panel,
.c1-drawer        { background: #fff !important; }

.c1-create-input:focus,
.c1-create-select:focus,
.c1-create-textarea:focus { border-color: var(--m-blue) !important; }
.c1-attach-btn:hover      { border-color: var(--m-blue) !important; color: var(--m-blue) !important; }
.c1-add-sub-btn           { background: var(--m-blue-dim) !important; color: var(--m-blue) !important; border-color: var(--m-blue) !important; }
.c1-date-input:focus      { border-color: var(--m-blue) !important; }
.c1-create-sub-del        { background: #fef2f2 !important; color: var(--m-red) !important; }

/* Drawer field values */
.c1-exp-fv { font-size: 12px !important; color: var(--m-ink) !important; }

/* Drawer status buttons */
.c1-dsr-btn.act        { color: var(--m-blue) !important; }
.c1-dsr-btn.act:hover  { background: var(--m-blue-dim) !important; border-color: var(--m-blue) !important; }
.c1-dsr-btn.done       { color: var(--m-green) !important; }
.c1-dsr-btn.done:hover { background: #f0fdf4 !important; border-color: var(--m-green) !important; }
.c1-dsr-ack            { background: #f0fdf4 !important; color: var(--m-green) !important; }

/* Drawer priority buttons */
.c1-drawer-pri.on      { background: var(--pc, var(--m-blue)) !important; border-color: var(--pc, var(--m-blue)) !important; }

/* Complete button */
.c1-drawer-complete-btn       { background: #f0fdf4 !important; color: var(--m-green) !important; border-color: var(--m-green) !important; }
.c1-drawer-complete-btn:hover { background: var(--m-green) !important; color: #fff !important; }

/* Comment input + send */
.c1-drawer-comment:focus      { border-color: var(--m-blue) !important; }
.c1-drawer-comment-send       { background: var(--m-blue) !important; }

/* Submit button */
.c1-pkf-submit                { background: var(--m-blue) !important; border-radius: 10px !important; }
.c1-pkf-submit:hover:not(:disabled) { background: #0044cc !important; }

/* ── 11. Action buttons ─────────────────────────────────────────────────── */
.c1-action-btn               { border-radius: 8px !important; }
.c1-action-detail            { color: var(--m-blue) !important; }
.c1-action-detail:hover      { background: var(--m-blue-dim) !important; border-color: var(--m-blue) !important; }
.c1-action-close             { color: var(--m-green) !important; }
.c1-action-close:hover       { background: #f0fdf4 !important; border-color: var(--m-green) !important; }
.c1-action-open              { color: var(--m-blue) !important; }
.c1-action-open:hover        { background: var(--m-blue-dim) !important; border-color: var(--m-blue) !important; }
.c1-action-transfer          { color: var(--m-purple) !important; }
.c1-action-transfer:hover    { background: #f5f3ff !important; border-color: var(--m-purple) !important; }

/* Quick-action panel buttons */
.c1-psel-action-btn          { background: var(--m-blue) !important; }
.c1-psel-action-btn:hover    { background: #0044cc !important; }
.c1-psel-action-announce     { background: var(--m-red) !important; }
.c1-psel-action-announce:hover { background: #dc2626 !important; }
.c1-psel-action-outline      { background: var(--m-purple) !important; }
.c1-psel-action-outline:hover { background: #6d28d9 !important; }
.c1-psel-action-events       { background: var(--m-blue) !important; }
.c1-psel-action-events:hover { background: #0044cc !important; }

/* ── 12. Sub-tasks & sequential steps ───────────────────────────────────── */
.c1-subtask-check.done  { background: var(--m-green) !important; border-color: var(--m-green) !important; }
.c1-subtask-bar         { background: linear-gradient(90deg, var(--m-green), #6ee7b7) !important; }
.c1-step-pill.c1-step-active { background: var(--m-blue) !important; border-color: var(--m-blue) !important; }
.c1-step-pill.c1-step-done   { background: var(--m-green) !important; border-color: var(--m-green) !important; }
.c1-seq-active          { background: var(--m-blue-dim) !important; border-color: var(--m-blue) !important; }
.c1-seq-active .c1-seq-num { background: var(--m-blue) !important; }
.c1-seq-done            { background: #f0fdf4 !important; border-color: var(--m-green) !important; }
.c1-seq-done .c1-seq-num { background: var(--m-green) !important; }

/* ── 13. Timer ──────────────────────────────────────────────────────────── */
.c1-timer-dot               { background: var(--m-green) !important; }
.c1-timer-running           { color: var(--m-green) !important; }
.c1-timer-start-btn         { background: #f0fdf4 !important; color: var(--m-green) !important; border-color: var(--m-green) !important; }
.c1-timer-start-btn:hover:not(:disabled) { background: var(--m-green) !important; color: #fff !important; }
.c1-timer-stop-btn          { background: #fef2f2 !important; color: var(--m-red) !important; border-color: var(--m-red) !important; }
.c1-timer-stop-btn:hover:not(:disabled)  { background: var(--m-red) !important; color: #fff !important; }
.c1-time-dur                { color: var(--m-purple) !important; }

/* ── 14. Announcements tab ──────────────────────────────────────────────── */
.c1-ann-card    { border-radius: 14px !important; background: #fff !important; border: 1.5px solid var(--m-rule) !important; }
.c1-ann-badge   { background: #f5f3ff !important; color: var(--m-purple) !important; }
.c1-ann-stat.ok      { background: #f0fdf4 !important; color: var(--m-green) !important; }
.c1-ann-stat.info    { background: var(--m-blue-dim) !important; color: var(--m-blue) !important; }
.c1-ann-stat.done    { background: #f5f3ff !important; color: var(--m-purple) !important; }
.c1-ann-stat.pending { background: #fffbeb !important; color: var(--m-gold) !important; }
.c1-ann-btn.understood       { color: var(--m-green) !important; border-color: var(--m-green) !important; }
.c1-ann-btn.understood:hover { background: var(--m-green) !important; color: #fff !important; }
.c1-ann-btn.more-info        { color: var(--m-blue) !important; border-color: var(--m-blue) !important; }
.c1-ann-btn.more-info:hover  { background: var(--m-blue) !important; color: #fff !important; }
.c1-ann-btn.done             { color: var(--m-purple) !important; border-color: var(--m-purple) !important; }
.c1-ann-btn.done:hover       { background: var(--m-purple) !important; color: #fff !important; }
.c1-ann-replied              { background: #f0fdf4 !important; color: var(--m-green) !important; }
.c1-tag-announce             { background: #f5f3ff !important; color: var(--m-purple) !important; }

/* ── 15. Activity log ───────────────────────────────────────────────────── */
.c1-log-create    { background: #f5f3ff !important; color: var(--m-purple) !important; }
.c1-log-done      { background: #f0fdf4 !important; color: var(--m-green) !important; }
.c1-log-transfer  { background: #fffbeb !important; color: var(--m-gold) !important; }
.c1-log-reply     { background: var(--m-blue-dim) !important; color: var(--m-blue) !important; }
.c1-log-task      { color: var(--m-purple) !important; }

/* ── 16. Reply thread ───────────────────────────────────────────────────── */
.c1-reply-av                    { background: var(--m-purple) !important; }
.c1-reply-mine .c1-reply-bubble { background: var(--m-blue-dim) !important; }

/* ── 17. Overdue / charts ───────────────────────────────────────────────── */
.c1-overdue-rank              { background: #fef2f2 !important; color: var(--m-red) !important; }
.c1-overdue-due,
.c1-overdue-days              { color: var(--m-red) !important; }

/* ── 18. Calendar ───────────────────────────────────────────────────────── */
.c1-cal-today              { border-color: var(--m-blue) !important; }
.c1-cal-today .c1-cal-dn   { color: var(--m-blue) !important; }
.c1-cal-dot                { background: var(--m-blue) !important; }
.c1-cal-dot-red            { background: var(--m-red) !important; }
.c1-cal-dot-yellow         { background: var(--m-gold) !important; }
.c1-cal-dot-green          { background: var(--m-green) !important; }

/* ── 19. Viki panel ─────────────────────────────────────────────────────── */
.c1-viki-msg-warn              { background: #fef2f2 !important; }
.c1-viki-msg-warn .c1-viki-msg-icon { color: var(--m-red) !important; }
.c1-viki-msg-ok                { background: #f0fdf4 !important; }
.c1-viki-msg-ok .c1-viki-msg-icon   { color: var(--m-green) !important; }
.c1-viki-msg-info .c1-viki-msg-icon { color: var(--m-blue) !important; }
.c1-viki-notif                 { background: var(--m-red) !important; }

/* ── 20. Spinner / loading ──────────────────────────────────────────────── */
.c1-spinner { border-top-color: var(--m-blue) !important; }

/* ── 21. Gantt bars ─────────────────────────────────────────────────────── */
/* default bar colour inherits from task priority — no override needed */

/* ── 22. Modal ──────────────────────────────────────────────────────────── */
.c1-modal { border-radius: 18px !important; background: #fff !important; }

/* ── 23. Mono utility class ─────────────────────────────────────────────── */
.c1-mono { font-family: var(--m-mono) !important; }

/* ── Team Filter ──────────────────────────────────────────────── */
.c1-t1-team-chip {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 20px;
  letter-spacing: .2px;
}

/* ── Viki left panel ──────────────────────────────────────────── */
.c1-viki-slide-enter-active, .c1-viki-slide-leave-active { transition: transform .28s cubic-bezier(.4,0,.2,1); }
.c1-viki-slide-enter, .c1-viki-slide-leave-to { transform: translateX(-100%); }
.c1-viki-left-panel {
  position: fixed;
  top: 0; left: 0; bottom: 0;
  width: 300px; max-width: 92vw;
  background: var(--c1-bg, #F7F6F3);
  z-index: 1100;
  display: flex; flex-direction: column;
  box-shadow: 4px 0 32px rgba(0,0,0,.22);
  overflow: hidden;
}
</style>
